export default {
    bbbz:{
        bw:[
            {
              "f1": 0,
              "keyName": "胃脘",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.69%",
              "valueName": "116"
            },
            {
              "f1": 0,
              "keyName": "脾",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.62%",
              "valueName": "114"
            },
            {
              "f1": 0,
              "keyName": "肾",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.32%",
              "valueName": "73"
            },
            {
              "f1": 0,
              "keyName": "肝",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.23%",
              "valueName": "70"
            },
            {
              "f1": 0,
              "keyName": "中焦",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.54%",
              "valueName": "17"
            },
            {
              "f1": 0,
              "keyName": "心",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.22%",
              "valueName": "7"
            },
            {
              "f1": 0,
              "keyName": "营分",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.19%",
              "valueName": "6"
            },
            {
              "f1": 0,
              "keyName": "肺",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.16%",
              "valueName": "5"
            },
            {
              "f1": 0,
              "keyName": "里",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.16%",
              "valueName": "5"
            },
            {
              "f1": 0,
              "keyName": "中阳",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.16%",
              "valueName": "5"
            }
        ],
        bx:[
            {
              "f1": 0,
              "keyName": "阳虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.59%",
              "valueName": "113"
            },
            {
              "f1": 0,
              "keyName": "阴虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.58%",
              "valueName": "81"
            },
            {
              "f1": 0,
              "keyName": "失和",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.73%",
              "valueName": "23"
            },
            {
              "f1": 0,
              "keyName": "虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.67%",
              "valueName": "21"
            },
            {
              "f1": 0,
              "keyName": "气郁",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.64%",
              "valueName": "20"
            },
            {
              "f1": 0,
              "keyName": "气虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.54%",
              "valueName": "17"
            },
            {
              "f1": 0,
              "keyName": "热",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.45%",
              "valueName": "14"
            },
            {
              "f1": 0,
              "keyName": "气逆",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.19%",
              "valueName": "6"
            },
            {
              "f1": 0,
              "keyName": "食积",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.13%",
              "valueName": "4"
            },
            {
              "f1": 0,
              "keyName": "寒",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.10%",
              "valueName": "3"
            }
        ],
        zyjb_lc_st:{
            "edges": [
              {
                "weight": 2,
                "source": "见点闷症",
                "value": 0,
                "target": "舌绛紫音缩"
              },
              {
                "weight": 1,
                "source": "血痢",
                "value": 0,
                "target": "面色消夺"
              },
              {
                "weight": 2,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "身小气弱"
              },
              {
                "weight": 2,
                "source": "脾肾阳虚",
                "value": 0,
                "target": "晨泄"
              },
              {
                "weight": 2,
                "source": "肾厥",
                "value": 0,
                "target": "肾厥"
              },
              {
                "weight": 1,
                "source": "肺郁水气不降",
                "value": 0,
                "target": "仰卧不安"
              },
              {
                "weight": 1,
                "source": "阴虚阳升",
                "value": 0,
                "target": "咳频呕哕"
              },
              {
                "weight": 1,
                "source": "兼失血",
                "value": 0,
                "target": "四末汗出"
              },
              {
                "weight": 1,
                "source": "劳伤血滞",
                "value": 0,
                "target": "痛极昏厥"
              },
              {
                "weight": 1,
                "source": "气血凝络肝逆胃痛呕",
                "value": 0,
                "target": "胃脘两胁痛甚欲呕"
              },
              {
                "weight": 1,
                "source": "阴虚阳升",
                "value": 0,
                "target": "皆系阴亏"
              },
              {
                "weight": 1,
                "source": "阴虚火炎",
                "value": 0,
                "target": "反加泄泻"
              },
              {
                "weight": 1,
                "source": "肝疝犯胃",
                "value": 0,
                "target": "胜疝坠"
              },
              {
                "weight": 3,
                "source": "湿热",
                "value": 0,
                "target": "大便不爽"
              },
              {
                "weight": 2,
                "source": "脾肾阳虚",
                "value": 0,
                "target": "肾虚瘕泄"
              },
              {
                "weight": 2,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "薄浆回痂"
              },
              {
                "weight": 2,
                "source": "阴虚阳浮",
                "value": 0,
                "target": "左垂尺泽"
              },
              {
                "weight": 2,
                "source": "久疝湿热郁",
                "value": 0,
                "target": "痰多"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "脉右劲"
              },
              {
                "weight": 2,
                "source": "胃阴虚",
                "value": 0,
                "target": "失血后"
              },
              {
                "weight": 2,
                "source": "营络气聚结瘕",
                "value": 0,
                "target": "疝瘕"
              },
              {
                "weight": 2,
                "source": "脾胃阳虚",
                "value": 0,
                "target": "脉沉小弦"
              },
              {
                "weight": 2,
                "source": "阳虚单胀浊阴凝滞",
                "value": 0,
                "target": "手足畏冷"
              },
              {
                "weight": 2,
                "source": "肝犯胃",
                "value": 0,
                "target": "咽阻"
              },
              {
                "weight": 2,
                "source": "风温",
                "value": 0,
                "target": "咳嗽"
              },
              {
                "weight": 2,
                "source": "瘅疟",
                "value": 0,
                "target": "阴气先伤"
              },
              {
                "weight": 2,
                "source": "温邪",
                "value": 0,
                "target": "咳嗽头胀"
              },
              {
                "weight": 3,
                "source": "肝风",
                "value": 0,
                "target": "头晕"
              },
              {
                "weight": 2,
                "source": "肝郁风火升",
                "value": 0,
                "target": "自觉冷者"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "久则食不甘"
              },
              {
                "weight": 2,
                "source": "风火",
                "value": 0,
                "target": "风火上郁"
              },
              {
                "weight": 2,
                "source": "湿阻中焦阳气",
                "value": 0,
                "target": "脉缓"
              },
              {
                "weight": 2,
                "source": "见点闷症",
                "value": 0,
                "target": "神醒"
              },
              {
                "weight": 2,
                "source": "温邪",
                "value": 0,
                "target": "咳嗽痰黄"
              },
              {
                "weight": 2,
                "source": "脾阳虚",
                "value": 0,
                "target": "便溏"
              },
              {
                "weight": 2,
                "source": "阳虚",
                "value": 0,
                "target": "寒热未止"
              },
              {
                "weight": 2,
                "source": "热毒壅结上焦",
                "value": 0,
                "target": "牙关紧闭"
              },
              {
                "weight": 2,
                "source": "热毒壅结上焦",
                "value": 0,
                "target": "腹满已久"
              },
              {
                "weight": 3,
                "source": "脾阳虚",
                "value": 0,
                "target": "三疟"
              },
              {
                "weight": 2,
                "source": "见点闷症",
                "value": 0,
                "target": "渴饮不已"
              },
              {
                "weight": 2,
                "source": "胃阴虚",
                "value": 0,
                "target": "不饥不饱"
              },
              {
                "weight": 2,
                "source": "湿热",
                "value": 0,
                "target": "腹痛"
              },
              {
                "weight": 2,
                "source": "痰火",
                "value": 0,
                "target": "痰多"
              },
              {
                "weight": 2,
                "source": "脾阳虚",
                "value": 0,
                "target": "渴喜热饮"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "心痛"
              },
              {
                "weight": 3,
                "source": "湿热",
                "value": 0,
                "target": "自利"
              },
              {
                "weight": 2,
                "source": "阳虚单胀浊阴凝滞",
                "value": 0,
                "target": "右胁汩汩有声"
              },
              {
                "weight": 2,
                "source": "劳伤中气虚",
                "value": 0,
                "target": "大便不实"
              },
              {
                "weight": 2,
                "source": "阴阳并虚",
                "value": 0,
                "target": "大便溏泻"
              },
              {
                "weight": 2,
                "source": "腰痛",
                "value": 0,
                "target": "腰痛"
              },
              {
                "weight": 2,
                "source": "支脉结饮",
                "value": 0,
                "target": "支脉结饮"
              },
              {
                "weight": 2,
                "source": "脾胃阳虚",
                "value": 0,
                "target": "大便不爽"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "口涌甜水"
              },
              {
                "weight": 2,
                "source": "肾气不纳",
                "value": 0,
                "target": "身动即喘"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "欲呕"
              },
              {
                "weight": 2,
                "source": "中气虚",
                "value": 0,
                "target": "畏风怯冷"
              },
              {
                "weight": 2,
                "source": "胸脘清阳不运",
                "value": 0,
                "target": "胸痹"
              },
              {
                "weight": 2,
                "source": "中气虚",
                "value": 0,
                "target": "久嗽"
              },
              {
                "weight": 2,
                "source": "暑兼血症",
                "value": 0,
                "target": "劳伤挟暑"
              },
              {
                "weight": 2,
                "source": "肝犯胃",
                "value": 0,
                "target": "胃中不和"
              },
              {
                "weight": 2,
                "source": "木火犯中胃虚生痰",
                "value": 0,
                "target": "痰多"
              },
              {
                "weight": 2,
                "source": "肺疟",
                "value": 0,
                "target": "咳嗽"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "皮毛内应乎肺"
              },
              {
                "weight": 2,
                "source": "热毒壅结上焦",
                "value": 0,
                "target": "先有寒热"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "脉左弦"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "胃津日耗"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "脉弦"
              },
              {
                "weight": 2,
                "source": "营虚",
                "value": 0,
                "target": "失血"
              },
              {
                "weight": 2,
                "source": "伏梁",
                "value": 0,
                "target": "伏梁病在络"
              },
              {
                "weight": 2,
                "source": "风温伤肺",
                "value": 0,
                "target": "风温入肺"
              },
              {
                "weight": 2,
                "source": "心肾兼治",
                "value": 0,
                "target": "有梦遗精"
              },
              {
                "weight": 2,
                "source": "肾阳虚膀胱气化不通降",
                "value": 0,
                "target": "小水不利"
              },
              {
                "weight": 2,
                "source": "湿热",
                "value": 0,
                "target": "湿热下痢"
              },
              {
                "weight": 2,
                "source": "胃阳虚浊阴上逆",
                "value": 0,
                "target": "胃阳大伤"
              },
              {
                "weight": 2,
                "source": "气分热",
                "value": 0,
                "target": "脉右数大"
              },
              {
                "weight": 2,
                "source": "胸脘清阳不运",
                "value": 0,
                "target": "脉弦"
              },
              {
                "weight": 2,
                "source": "瘅疟",
                "value": 0,
                "target": "阳气独发"
              },
              {
                "weight": 2,
                "source": "脾阳虚",
                "value": 0,
                "target": "食下腹胀"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "便燥结"
              },
              {
                "weight": 2,
                "source": "湿疟",
                "value": 0,
                "target": "疟止"
              },
              {
                "weight": 2,
                "source": "阴虚阳升",
                "value": 0,
                "target": "血涌如泉"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "脉左数"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "不司供肺"
              },
              {
                "weight": 2,
                "source": "奇脉虚",
                "value": 0,
                "target": "淋带瘕泄"
              },
              {
                "weight": 3,
                "source": "肝犯胃",
                "value": 0,
                "target": "食入呕吐"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "舌白"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "不饥"
              },
              {
                "weight": 2,
                "source": "暑热阻气中痞不运",
                "value": 0,
                "target": "脉虚"
              },
              {
                "weight": 2,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "毒瓦斯未尽"
              },
              {
                "weight": 2,
                "source": "阴虚邪伏",
                "value": 0,
                "target": "脉左数"
              },
              {
                "weight": 2,
                "source": "肝犯胃",
                "value": 0,
                "target": "呕吐"
              },
              {
                "weight": 2,
                "source": "胃气窒筋骨不利",
                "value": 0,
                "target": "大便旬日不通"
              },
              {
                "weight": 2,
                "source": "胃阳虚浊阴上逆",
                "value": 0,
                "target": "并不渴饮"
              },
              {
                "weight": 2,
                "source": "肝犯胃",
                "value": 0,
                "target": "口吐清涎"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "卫疏易伤冷热"
              },
              {
                "weight": 2,
                "source": "燥",
                "value": 0,
                "target": "咳嗽气塞痰多"
              },
              {
                "weight": 2,
                "source": "阴虚阳升",
                "value": 0,
                "target": "阳动失血"
              },
              {
                "weight": 2,
                "source": "阴虚",
                "value": 0,
                "target": "阴伤劳损"
              },
              {
                "weight": 2,
                "source": "热毒壅结上焦",
                "value": 0,
                "target": "非是暴症"
              },
              {
                "weight": 2,
                "source": "肝郁犯胃兼湿",
                "value": 0,
                "target": "大便不爽"
              }
            ],
            "nodes": [
              {
                "degree": 0,
                "name": "见点闷症",
                "id": "见点闷症",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "舌绛紫音缩",
                "id": "舌绛紫音缩",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "血痢",
                "id": "血痢",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "面色消夺",
                "id": "面色消夺",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "肝肾蕴毒闷症",
                "id": "肝肾蕴毒闷症",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "身小气弱",
                "id": "身小气弱",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "脾肾阳虚",
                "id": "脾肾阳虚",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "晨泄",
                "id": "晨泄",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "肾厥",
                "id": "肾厥",
                "distance": 0,
                "group": "48"
              },
              {
                "degree": 0,
                "name": "肺郁水气不降",
                "id": "肺郁水气不降",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "仰卧不安",
                "id": "仰卧不安",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "阴虚阳升",
                "id": "阴虚阳升",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "咳频呕哕",
                "id": "咳频呕哕",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "兼失血",
                "id": "兼失血",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "四末汗出",
                "id": "四末汗出",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "劳伤血滞",
                "id": "劳伤血滞",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "痛极昏厥",
                "id": "痛极昏厥",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "气血凝络肝逆胃痛呕",
                "id": "气血凝络肝逆胃痛呕",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "胃脘两胁痛甚欲呕",
                "id": "胃脘两胁痛甚欲呕",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "皆系阴亏",
                "id": "皆系阴亏",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "阴虚火炎",
                "id": "阴虚火炎",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "反加泄泻",
                "id": "反加泄泻",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "肝疝犯胃",
                "id": "肝疝犯胃",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "胜疝坠",
                "id": "胜疝坠",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "湿热",
                "id": "湿热",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "大便不爽",
                "id": "大便不爽",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "肾虚瘕泄",
                "id": "肾虚瘕泄",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "薄浆回痂",
                "id": "薄浆回痂",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "阴虚阳浮",
                "id": "阴虚阳浮",
                "distance": 0,
                "group": "39"
              },
              {
                "degree": 0,
                "name": "左垂尺泽",
                "id": "左垂尺泽",
                "distance": 0,
                "group": "39"
              },
              {
                "degree": 0,
                "name": "久疝湿热郁",
                "id": "久疝湿热郁",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "痰多",
                "id": "痰多",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "燥",
                "id": "燥",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "脉右劲",
                "id": "脉右劲",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "胃阴虚",
                "id": "胃阴虚",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "失血后",
                "id": "失血后",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "营络气聚结瘕",
                "id": "营络气聚结瘕",
                "distance": 0,
                "group": "43"
              },
              {
                "degree": 0,
                "name": "疝瘕",
                "id": "疝瘕",
                "distance": 0,
                "group": "43"
              },
              {
                "degree": 0,
                "name": "脾胃阳虚",
                "id": "脾胃阳虚",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "脉沉小弦",
                "id": "脉沉小弦",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "阳虚单胀浊阴凝滞",
                "id": "阳虚单胀浊阴凝滞",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "手足畏冷",
                "id": "手足畏冷",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "肝犯胃",
                "id": "肝犯胃",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "咽阻",
                "id": "咽阻",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "风温",
                "id": "风温",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "咳嗽",
                "id": "咳嗽",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "瘅疟",
                "id": "瘅疟",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "阴气先伤",
                "id": "阴气先伤",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "温邪",
                "id": "温邪",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "咳嗽头胀",
                "id": "咳嗽头胀",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "肝风",
                "id": "肝风",
                "distance": 0,
                "group": "47"
              },
              {
                "degree": 0,
                "name": "头晕",
                "id": "头晕",
                "distance": 0,
                "group": "47"
              },
              {
                "degree": 0,
                "name": "肝郁风火升",
                "id": "肝郁风火升",
                "distance": 0,
                "group": "34"
              },
              {
                "degree": 0,
                "name": "自觉冷者",
                "id": "自觉冷者",
                "distance": 0,
                "group": "34"
              },
              {
                "degree": 0,
                "name": "久则食不甘",
                "id": "久则食不甘",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "风火",
                "id": "风火",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "风火上郁",
                "id": "风火上郁",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "湿阻中焦阳气",
                "id": "湿阻中焦阳气",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "脉缓",
                "id": "脉缓",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "神醒",
                "id": "神醒",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "咳嗽痰黄",
                "id": "咳嗽痰黄",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "脾阳虚",
                "id": "脾阳虚",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "便溏",
                "id": "便溏",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "阳虚",
                "id": "阳虚",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "寒热未止",
                "id": "寒热未止",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "热毒壅结上焦",
                "id": "热毒壅结上焦",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "牙关紧闭",
                "id": "牙关紧闭",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "腹满已久",
                "id": "腹满已久",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "三疟",
                "id": "三疟",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "渴饮不已",
                "id": "渴饮不已",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "不饥不饱",
                "id": "不饥不饱",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "腹痛",
                "id": "腹痛",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "痰火",
                "id": "痰火",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "渴喜热饮",
                "id": "渴喜热饮",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "肝胃",
                "id": "肝胃",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "心痛",
                "id": "心痛",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "自利",
                "id": "自利",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "右胁汩汩有声",
                "id": "右胁汩汩有声",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "劳伤中气虚",
                "id": "劳伤中气虚",
                "distance": 0,
                "group": "45"
              },
              {
                "degree": 0,
                "name": "大便不实",
                "id": "大便不实",
                "distance": 0,
                "group": "45"
              },
              {
                "degree": 0,
                "name": "阴阳并虚",
                "id": "阴阳并虚",
                "distance": 0,
                "group": "42"
              },
              {
                "degree": 0,
                "name": "大便溏泻",
                "id": "大便溏泻",
                "distance": 0,
                "group": "42"
              },
              {
                "degree": 0,
                "name": "腰痛",
                "id": "腰痛",
                "distance": 0,
                "group": "49"
              },
              {
                "degree": 0,
                "name": "支脉结饮",
                "id": "支脉结饮",
                "distance": 0,
                "group": "50"
              },
              {
                "degree": 0,
                "name": "口涌甜水",
                "id": "口涌甜水",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "肾气不纳",
                "id": "肾气不纳",
                "distance": 0,
                "group": "40"
              },
              {
                "degree": 0,
                "name": "身动即喘",
                "id": "身动即喘",
                "distance": 0,
                "group": "40"
              },
              {
                "degree": 0,
                "name": "欲呕",
                "id": "欲呕",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "中气虚",
                "id": "中气虚",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "畏风怯冷",
                "id": "畏风怯冷",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "胸脘清阳不运",
                "id": "胸脘清阳不运",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "胸痹",
                "id": "胸痹",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "久嗽",
                "id": "久嗽",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "暑兼血症",
                "id": "暑兼血症",
                "distance": 0,
                "group": "37"
              },
              {
                "degree": 0,
                "name": "劳伤挟暑",
                "id": "劳伤挟暑",
                "distance": 0,
                "group": "37"
              },
              {
                "degree": 0,
                "name": "胃中不和",
                "id": "胃中不和",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "木火犯中胃虚生痰",
                "id": "木火犯中胃虚生痰",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "肺疟",
                "id": "肺疟",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "皮毛内应乎肺",
                "id": "皮毛内应乎肺",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "先有寒热",
                "id": "先有寒热",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "脉左弦",
                "id": "脉左弦",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "胃津日耗",
                "id": "胃津日耗",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "脉弦",
                "id": "脉弦",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "营虚",
                "id": "营虚",
                "distance": 0,
                "group": "35"
              },
              {
                "degree": 0,
                "name": "失血",
                "id": "失血",
                "distance": 0,
                "group": "35"
              },
              {
                "degree": 0,
                "name": "伏梁",
                "id": "伏梁",
                "distance": 0,
                "group": "33"
              },
              {
                "degree": 0,
                "name": "伏梁病在络",
                "id": "伏梁病在络",
                "distance": 0,
                "group": "33"
              },
              {
                "degree": 0,
                "name": "风温伤肺",
                "id": "风温伤肺",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "风温入肺",
                "id": "风温入肺",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "心肾兼治",
                "id": "心肾兼治",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "有梦遗精",
                "id": "有梦遗精",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "肾阳虚膀胱气化不通降",
                "id": "肾阳虚膀胱气化不通降",
                "distance": 0,
                "group": "36"
              },
              {
                "degree": 0,
                "name": "小水不利",
                "id": "小水不利",
                "distance": 0,
                "group": "36"
              },
              {
                "degree": 0,
                "name": "湿热下痢",
                "id": "湿热下痢",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "胃阳虚浊阴上逆",
                "id": "胃阳虚浊阴上逆",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "胃阳大伤",
                "id": "胃阳大伤",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "气分热",
                "id": "气分热",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "脉右数大",
                "id": "脉右数大",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "阳气独发",
                "id": "阳气独发",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "食下腹胀",
                "id": "食下腹胀",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "便燥结",
                "id": "便燥结",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "湿疟",
                "id": "湿疟",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "疟止",
                "id": "疟止",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "血涌如泉",
                "id": "血涌如泉",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "脉左数",
                "id": "脉左数",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "不司供肺",
                "id": "不司供肺",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "奇脉虚",
                "id": "奇脉虚",
                "distance": 0,
                "group": "46"
              },
              {
                "degree": 0,
                "name": "淋带瘕泄",
                "id": "淋带瘕泄",
                "distance": 0,
                "group": "46"
              },
              {
                "degree": 0,
                "name": "食入呕吐",
                "id": "食入呕吐",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "舌白",
                "id": "舌白",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "不饥",
                "id": "不饥",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "暑热阻气中痞不运",
                "id": "暑热阻气中痞不运",
                "distance": 0,
                "group": "44"
              },
              {
                "degree": 0,
                "name": "脉虚",
                "id": "脉虚",
                "distance": 0,
                "group": "44"
              },
              {
                "degree": 0,
                "name": "毒瓦斯未尽",
                "id": "毒瓦斯未尽",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "阴虚邪伏",
                "id": "阴虚邪伏",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "呕吐",
                "id": "呕吐",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "胃气窒筋骨不利",
                "id": "胃气窒筋骨不利",
                "distance": 0,
                "group": "41"
              },
              {
                "degree": 0,
                "name": "大便旬日不通",
                "id": "大便旬日不通",
                "distance": 0,
                "group": "41"
              },
              {
                "degree": 0,
                "name": "并不渴饮",
                "id": "并不渴饮",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "口吐清涎",
                "id": "口吐清涎",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "卫疏易伤冷热",
                "id": "卫疏易伤冷热",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "咳嗽气塞痰多",
                "id": "咳嗽气塞痰多",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "阳动失血",
                "id": "阳动失血",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "阴虚",
                "id": "阴虚",
                "distance": 0,
                "group": "38"
              },
              {
                "degree": 0,
                "name": "阴伤劳损",
                "id": "阴伤劳损",
                "distance": 0,
                "group": "38"
              },
              {
                "degree": 0,
                "name": "非是暴症",
                "id": "非是暴症",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "肝郁犯胃兼湿",
                "id": "肝郁犯胃兼湿",
                "distance": 0,
                "group": "10"
              }
            ]
        },
        zyzh_lc_st: {
            "edges": [
              {
                "weight": 3,
                "source": "吐血",
                "value": 0,
                "target": "血止"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "汗出不解"
              },
              {
                "weight": 3,
                "source": "泄泻",
                "value": 0,
                "target": "泄泻"
              },
              {
                "weight": 3,
                "source": "痢",
                "value": 0,
                "target": "肛坠"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "卫疏易伤冷热"
              },
              {
                "weight": 3,
                "source": "虚劳",
                "value": 0,
                "target": "汗出"
              },
              {
                "weight": 8,
                "source": "疟",
                "value": 0,
                "target": "舌白"
              },
              {
                "weight": 2,
                "source": "眩晕",
                "value": 0,
                "target": "内风逆"
              },
              {
                "weight": 2,
                "source": "遗精",
                "value": 0,
                "target": "阴精走泄"
              },
              {
                "weight": 3,
                "source": "湿",
                "value": 0,
                "target": "身痛"
              },
              {
                "weight": 2,
                "source": "不寐",
                "value": 0,
                "target": "阳气不交于阴"
              },
              {
                "weight": 2,
                "source": "便血",
                "value": 0,
                "target": "便后有血"
              },
              {
                "weight": 3,
                "source": "疟",
                "value": 0,
                "target": "不饥"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "口涌甜水"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "不饥不思食"
              },
              {
                "weight": 2,
                "source": "暑",
                "value": 0,
                "target": "烦渴"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "不司供肺"
              },
              {
                "weight": 2,
                "source": "噫嗳",
                "value": 0,
                "target": "噫气不爽"
              },
              {
                "weight": 4,
                "source": "疟",
                "value": 0,
                "target": "脉濡"
              },
              {
                "weight": 2,
                "source": "呕吐",
                "value": 0,
                "target": "咽阻"
              },
              {
                "weight": 2,
                "source": "暑",
                "value": 0,
                "target": "头胀"
              },
              {
                "weight": 3,
                "source": "咳嗽",
                "value": 0,
                "target": "咳"
              },
              {
                "weight": 2,
                "source": "痰饮",
                "value": 0,
                "target": "脉沉弦"
              },
              {
                "weight": 2,
                "source": "痰饮",
                "value": 0,
                "target": "背寒"
              },
              {
                "weight": 2,
                "source": "调经",
                "value": 0,
                "target": "大便不爽"
              },
              {
                "weight": 8,
                "source": "吐血",
                "value": 0,
                "target": "失血"
              },
              {
                "weight": 2,
                "source": "目疾",
                "value": 0,
                "target": "左目赤痛"
              },
              {
                "weight": 2,
                "source": "不寐",
                "value": 0,
                "target": "阳跷穴空"
              },
              {
                "weight": 2,
                "source": "腰腿足痛",
                "value": 0,
                "target": "腰痛"
              },
              {
                "weight": 3,
                "source": "调经",
                "value": 0,
                "target": "脉数"
              },
              {
                "weight": 4,
                "source": "胃脘痛",
                "value": 0,
                "target": "胃痛"
              },
              {
                "weight": 2,
                "source": "痹",
                "value": 0,
                "target": "风湿相搏"
              },
              {
                "weight": 2,
                "source": "调经",
                "value": 0,
                "target": "经闭"
              },
              {
                "weight": 2,
                "source": "暑",
                "value": 0,
                "target": "自利"
              },
              {
                "weight": 3,
                "source": "泄泻",
                "value": 0,
                "target": "小便不利"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "阳动失血"
              },
              {
                "weight": 2,
                "source": "痘",
                "value": 0,
                "target": "毒瓦斯未尽"
              },
              {
                "weight": 4,
                "source": "痰",
                "value": 0,
                "target": "痰多"
              },
              {
                "weight": 4,
                "source": "吐血",
                "value": 0,
                "target": "失血后"
              },
              {
                "weight": 2,
                "source": "肿胀",
                "value": 0,
                "target": "食入不运"
              },
              {
                "weight": 5,
                "source": "肿胀",
                "value": 0,
                "target": "大便不爽"
              },
              {
                "weight": 2,
                "source": "崩漏",
                "value": 0,
                "target": "天癸当止之年"
              },
              {
                "weight": 2,
                "source": "痢",
                "value": 0,
                "target": "腹痛下痢"
              },
              {
                "weight": 2,
                "source": "痘",
                "value": 0,
                "target": "渴饮不已"
              },
              {
                "weight": 3,
                "source": "暑",
                "value": 0,
                "target": "脉虚"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "间疟"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "虽得血止"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "阳气正升"
              },
              {
                "weight": 3,
                "source": "泄泻",
                "value": 0,
                "target": "腹痛泄泻"
              },
              {
                "weight": 2,
                "source": "痘",
                "value": 0,
                "target": "神醒"
              },
              {
                "weight": 3,
                "source": "吐血",
                "value": 0,
                "target": "汗出"
              },
              {
                "weight": 2,
                "source": "胁痛",
                "value": 0,
                "target": "胁痛"
              },
              {
                "weight": 3,
                "source": "疟",
                "value": 0,
                "target": "腹中不和"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "疟后"
              },
              {
                "weight": 3,
                "source": "遗精",
                "value": 0,
                "target": "有梦遗精"
              },
              {
                "weight": 2,
                "source": "肿胀",
                "value": 0,
                "target": "手足畏冷"
              },
              {
                "weight": 2,
                "source": "痘",
                "value": 0,
                "target": "薄浆回痂"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "脉虚"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "咳嗽痰黄"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "久则食不甘"
              },
              {
                "weight": 2,
                "source": "木乘土",
                "value": 0,
                "target": "脉弦"
              },
              {
                "weight": 3,
                "source": "湿",
                "value": 0,
                "target": "不饥不食"
              },
              {
                "weight": 2,
                "source": "温热",
                "value": 0,
                "target": "非是暴症"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "腹胀"
              },
              {
                "weight": 2,
                "source": "便血",
                "value": 0,
                "target": "食入不化"
              },
              {
                "weight": 2,
                "source": "淋浊",
                "value": 0,
                "target": "淋浊"
              },
              {
                "weight": 3,
                "source": "疟",
                "value": 0,
                "target": "自利"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "脉涩"
              },
              {
                "weight": 4,
                "source": "咳嗽",
                "value": 0,
                "target": "久嗽"
              },
              {
                "weight": 2,
                "source": "虚劳",
                "value": 0,
                "target": "食减"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "阴气先伤"
              },
              {
                "weight": 3,
                "source": "疟",
                "value": 0,
                "target": "身痛"
              },
              {
                "weight": 3,
                "source": "吐血",
                "value": 0,
                "target": "脉小数"
              },
              {
                "weight": 4,
                "source": "疟",
                "value": 0,
                "target": "脉数"
              },
              {
                "weight": 2,
                "source": "症瘕",
                "value": 0,
                "target": "疝瘕"
              },
              {
                "weight": 3,
                "source": "呕吐",
                "value": 0,
                "target": "食入呕吐"
              },
              {
                "weight": 4,
                "source": "眩晕",
                "value": 0,
                "target": "头晕"
              },
              {
                "weight": 3,
                "source": "咳嗽",
                "value": 0,
                "target": "咳嗽头胀"
              },
              {
                "weight": 2,
                "source": "虚劳",
                "value": 0,
                "target": "便溏"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "血涌如泉"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "疟止"
              },
              {
                "weight": 2,
                "source": "积聚",
                "value": 0,
                "target": "伏梁病在络"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "渴饮"
              },
              {
                "weight": 3,
                "source": "痰饮",
                "value": 0,
                "target": "喘不得卧"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "寒热咳嗽"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "咳嗽"
              },
              {
                "weight": 6,
                "source": "咳嗽",
                "value": 0,
                "target": "咳嗽"
              },
              {
                "weight": 3,
                "source": "虚劳",
                "value": 0,
                "target": "阴伤及阳"
              },
              {
                "weight": 2,
                "source": "痿",
                "value": 0,
                "target": "寝食如常"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "不饥"
              },
              {
                "weight": 3,
                "source": "疟",
                "value": 0,
                "target": "三疟"
              },
              {
                "weight": 3,
                "source": "调经",
                "value": 0,
                "target": "经事愆期"
              },
              {
                "weight": 3,
                "source": "疟",
                "value": 0,
                "target": "寒热未止"
              },
              {
                "weight": 2,
                "source": "痹",
                "value": 0,
                "target": "周身痹痛"
              },
              {
                "weight": 2,
                "source": "温热",
                "value": 0,
                "target": "脉左数"
              },
              {
                "weight": 2,
                "source": "产后",
                "value": 0,
                "target": "腹膨"
              },
              {
                "weight": 2,
                "source": "产后",
                "value": 0,
                "target": "产后下虚"
              },
              {
                "weight": 2,
                "source": "温热",
                "value": 0,
                "target": "先有寒热"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "嗽"
              },
              {
                "weight": 4,
                "source": "疟",
                "value": 0,
                "target": "渴喜热饮"
              }
            ],
            "nodes": [
              {
                "degree": 0,
                "name": "吐血",
                "id": "吐血",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "血止",
                "id": "血止",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "疟",
                "id": "疟",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "汗出不解",
                "id": "汗出不解",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "泄泻",
                "id": "泄泻",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "痢",
                "id": "痢",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "肛坠",
                "id": "肛坠",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "咳嗽",
                "id": "咳嗽",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "卫疏易伤冷热",
                "id": "卫疏易伤冷热",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "虚劳",
                "id": "虚劳",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "汗出",
                "id": "汗出",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "舌白",
                "id": "舌白",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "眩晕",
                "id": "眩晕",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "内风逆",
                "id": "内风逆",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "遗精",
                "id": "遗精",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "阴精走泄",
                "id": "阴精走泄",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "湿",
                "id": "湿",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "身痛",
                "id": "身痛",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "不寐",
                "id": "不寐",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "阳气不交于阴",
                "id": "阳气不交于阴",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "便血",
                "id": "便血",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "便后有血",
                "id": "便后有血",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "不饥",
                "id": "不饥",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "口涌甜水",
                "id": "口涌甜水",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "不饥不思食",
                "id": "不饥不思食",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "暑",
                "id": "暑",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "烦渴",
                "id": "烦渴",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "不司供肺",
                "id": "不司供肺",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "噫嗳",
                "id": "噫嗳",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "噫气不爽",
                "id": "噫气不爽",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "脉濡",
                "id": "脉濡",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "呕吐",
                "id": "呕吐",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "咽阻",
                "id": "咽阻",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "头胀",
                "id": "头胀",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "咳",
                "id": "咳",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "痰饮",
                "id": "痰饮",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "脉沉弦",
                "id": "脉沉弦",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "背寒",
                "id": "背寒",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "调经",
                "id": "调经",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "大便不爽",
                "id": "大便不爽",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "失血",
                "id": "失血",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "目疾",
                "id": "目疾",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "左目赤痛",
                "id": "左目赤痛",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "阳跷穴空",
                "id": "阳跷穴空",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "腰腿足痛",
                "id": "腰腿足痛",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "腰痛",
                "id": "腰痛",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "脉数",
                "id": "脉数",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "胃脘痛",
                "id": "胃脘痛",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "胃痛",
                "id": "胃痛",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "痹",
                "id": "痹",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "风湿相搏",
                "id": "风湿相搏",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "经闭",
                "id": "经闭",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "自利",
                "id": "自利",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "小便不利",
                "id": "小便不利",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "阳动失血",
                "id": "阳动失血",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "痘",
                "id": "痘",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "毒瓦斯未尽",
                "id": "毒瓦斯未尽",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "痰",
                "id": "痰",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "痰多",
                "id": "痰多",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "失血后",
                "id": "失血后",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "肿胀",
                "id": "肿胀",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "食入不运",
                "id": "食入不运",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "崩漏",
                "id": "崩漏",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "天癸当止之年",
                "id": "天癸当止之年",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "腹痛下痢",
                "id": "腹痛下痢",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "渴饮不已",
                "id": "渴饮不已",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "脉虚",
                "id": "脉虚",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "间疟",
                "id": "间疟",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "虽得血止",
                "id": "虽得血止",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "阳气正升",
                "id": "阳气正升",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "腹痛泄泻",
                "id": "腹痛泄泻",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "神醒",
                "id": "神醒",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "胁痛",
                "id": "胁痛",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "腹中不和",
                "id": "腹中不和",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "疟后",
                "id": "疟后",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "有梦遗精",
                "id": "有梦遗精",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "手足畏冷",
                "id": "手足畏冷",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "薄浆回痂",
                "id": "薄浆回痂",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "咳嗽痰黄",
                "id": "咳嗽痰黄",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "久则食不甘",
                "id": "久则食不甘",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "木乘土",
                "id": "木乘土",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "脉弦",
                "id": "脉弦",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "不饥不食",
                "id": "不饥不食",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "温热",
                "id": "温热",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "非是暴症",
                "id": "非是暴症",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "腹胀",
                "id": "腹胀",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "食入不化",
                "id": "食入不化",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "淋浊",
                "id": "淋浊",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "脉涩",
                "id": "脉涩",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "久嗽",
                "id": "久嗽",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "食减",
                "id": "食减",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "阴气先伤",
                "id": "阴气先伤",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "脉小数",
                "id": "脉小数",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "症瘕",
                "id": "症瘕",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "疝瘕",
                "id": "疝瘕",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "食入呕吐",
                "id": "食入呕吐",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "头晕",
                "id": "头晕",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "咳嗽头胀",
                "id": "咳嗽头胀",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "便溏",
                "id": "便溏",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "血涌如泉",
                "id": "血涌如泉",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "疟止",
                "id": "疟止",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "积聚",
                "id": "积聚",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "伏梁病在络",
                "id": "伏梁病在络",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "渴饮",
                "id": "渴饮",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "喘不得卧",
                "id": "喘不得卧",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "寒热咳嗽",
                "id": "寒热咳嗽",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "阴伤及阳",
                "id": "阴伤及阳",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "痿",
                "id": "痿",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "寝食如常",
                "id": "寝食如常",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "三疟",
                "id": "三疟",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "经事愆期",
                "id": "经事愆期",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "寒热未止",
                "id": "寒热未止",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "周身痹痛",
                "id": "周身痹痛",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "脉左数",
                "id": "脉左数",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "产后",
                "id": "产后",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "腹膨",
                "id": "腹膨",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "产后下虚",
                "id": "产后下虚",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "先有寒热",
                "id": "先有寒热",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "嗽",
                "id": "嗽",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "渴喜热饮",
                "id": "渴喜热饮",
                "distance": 0,
                "group": "3"
              }
            ]
        },
        zyjb_zh_gl:[
            {
              "coverage": "0.018176020408163265",
              "confidence": "0.9473684210526315",
              "count": 54,
              "lift": "55.01754385964912",
              "source": "痘",
              "support": "0.01721938775510204",
              "target": "肝肾蕴毒闷症"
            },
            {
              "coverage": "0.022002551020408163",
              "confidence": "0.8260869565217391",
              "count": 57,
              "lift": "29.107962872496337",
              "source": "木乘土",
              "support": "0.018176020408163265",
              "target": "肝胃"
            },
            {
              "coverage": "0.0589923469387755",
              "confidence": "0.17297297297297298",
              "count": 32,
              "lift": "6.094867901609475",
              "source": "疟",
              "support": "0.01020408163265306",
              "target": "肝胃"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.1483050847457627",
              "count": 35,
              "lift": "12.569857993586806",
              "source": "吐血",
              "support": "0.011160714285714286",
              "target": "阴虚阳升"
            }
        ],
        zyjb_zh_st:{
            "edges": [
              {
                "weight": 22,
                "source": "吐血",
                "value": 0,
                "target": "胃阴虚"
              },
              {
                "weight": 11,
                "source": "肿胀",
                "value": 0,
                "target": "阳虚单胀浊阴凝滞"
              },
              {
                "weight": 7,
                "source": "痹",
                "value": 0,
                "target": "周痹"
              },
              {
                "weight": 7,
                "source": "痉厥",
                "value": 0,
                "target": "暑邪内陷胞络闭结"
              },
              {
                "weight": 8,
                "source": "症瘕",
                "value": 0,
                "target": "营络气聚结瘕"
              },
              {
                "weight": 8,
                "source": "痰饮",
                "value": 0,
                "target": "悬饮"
              },
              {
                "weight": 8,
                "source": "虚劳",
                "value": 0,
                "target": "阳虚"
              },
              {
                "weight": 8,
                "source": "中风",
                "value": 0,
                "target": "痰火阻络"
              },
              {
                "weight": 13,
                "source": "痉厥",
                "value": 0,
                "target": "肝风"
              },
              {
                "weight": 10,
                "source": "崩漏",
                "value": 0,
                "target": "奇脉阴虚风阳动"
              },
              {
                "weight": 8,
                "source": "遗精",
                "value": 0,
                "target": "下损及中兼治脾胃"
              },
              {
                "weight": 14,
                "source": "肿胀",
                "value": 0,
                "target": "肝郁犯胃兼湿"
              },
              {
                "weight": 9,
                "source": "疝",
                "value": 0,
                "target": "久疝湿热郁"
              },
              {
                "weight": 8,
                "source": "痰饮",
                "value": 0,
                "target": "脾阳不运"
              },
              {
                "weight": 54,
                "source": "痘",
                "value": 0,
                "target": "肝肾蕴毒闷症"
              },
              {
                "weight": 17,
                "source": "呕吐",
                "value": 0,
                "target": "胃阳虚浊阴上逆"
              },
              {
                "weight": 11,
                "source": "暑",
                "value": 0,
                "target": "暑热阻气中痞不运"
              },
              {
                "weight": 15,
                "source": "痹",
                "value": 0,
                "target": "风湿"
              },
              {
                "weight": 13,
                "source": "虚劳",
                "value": 0,
                "target": "阴阳并虚"
              },
              {
                "weight": 57,
                "source": "木乘土",
                "value": 0,
                "target": "肝胃"
              },
              {
                "weight": 8,
                "source": "腰腿足痛",
                "value": 0,
                "target": "腰痛"
              },
              {
                "weight": 10,
                "source": "产后",
                "value": 0,
                "target": "阳虚肿胀"
              },
              {
                "weight": 11,
                "source": "痢",
                "value": 0,
                "target": "痢伤阴液"
              },
              {
                "weight": 9,
                "source": "胃脘痛",
                "value": 0,
                "target": "肝犯胃"
              },
              {
                "weight": 11,
                "source": "产后",
                "value": 0,
                "target": "蓐劳"
              },
              {
                "weight": 8,
                "source": "胃脘痛",
                "value": 0,
                "target": "阳虚"
              },
              {
                "weight": 7,
                "source": "疮疡",
                "value": 0,
                "target": "溃疡"
              },
              {
                "weight": 9,
                "source": "痹",
                "value": 0,
                "target": "寒湿"
              },
              {
                "weight": 35,
                "source": "吐血",
                "value": 0,
                "target": "阴虚阳升"
              },
              {
                "weight": 7,
                "source": "产后",
                "value": 0,
                "target": "郁冒"
              },
              {
                "weight": 25,
                "source": "湿",
                "value": 0,
                "target": "湿阻中焦阳气"
              },
              {
                "weight": 10,
                "source": "泄泻",
                "value": 0,
                "target": "暑湿热"
              },
              {
                "weight": 11,
                "source": "噎膈反胃",
                "value": 0,
                "target": "胃阳虚"
              },
              {
                "weight": 8,
                "source": "疟",
                "value": 0,
                "target": "暑疟"
              },
              {
                "weight": 12,
                "source": "胸痹",
                "value": 0,
                "target": "胸脘清阳不运"
              },
              {
                "weight": 13,
                "source": "脱",
                "value": 0,
                "target": "阴阳并虚"
              },
              {
                "weight": 9,
                "source": "疟",
                "value": 0,
                "target": "瘅疟"
              },
              {
                "weight": 21,
                "source": "泄泻",
                "value": 0,
                "target": "脾肾阳虚"
              },
              {
                "weight": 15,
                "source": "肺痹",
                "value": 0,
                "target": "上焦气分壅热肺不开降"
              },
              {
                "weight": 10,
                "source": "遗精",
                "value": 0,
                "target": "阴虚阳动"
              },
              {
                "weight": 8,
                "source": "痢",
                "value": 0,
                "target": "疟变痢"
              },
              {
                "weight": 9,
                "source": "肝风",
                "value": 0,
                "target": "肝阴虚"
              },
              {
                "weight": 11,
                "source": "疟",
                "value": 0,
                "target": "痞"
              },
              {
                "weight": 8,
                "source": "目疾",
                "value": 0,
                "target": "木火上郁"
              },
              {
                "weight": 11,
                "source": "痰饮",
                "value": 0,
                "target": "肾阳虚饮逆喘咳呕"
              },
              {
                "weight": 17,
                "source": "痢",
                "value": 0,
                "target": "湿热"
              },
              {
                "weight": 9,
                "source": "疟",
                "value": 0,
                "target": "脾阳虚"
              },
              {
                "weight": 23,
                "source": "中风",
                "value": 0,
                "target": "肾阴虚肝风动"
              },
              {
                "weight": 24,
                "source": "咳嗽",
                "value": 0,
                "target": "中气虚"
              },
              {
                "weight": 27,
                "source": "呕吐",
                "value": 0,
                "target": "肝犯胃"
              },
              {
                "weight": 8,
                "source": "疟",
                "value": 0,
                "target": "湿热"
              },
              {
                "weight": 13,
                "source": "泄泻",
                "value": 0,
                "target": "肝犯胃"
              },
              {
                "weight": 26,
                "source": "吐血",
                "value": 0,
                "target": "劳伤中气虚"
              },
              {
                "weight": 11,
                "source": "吐血",
                "value": 0,
                "target": "血络痹胸胁痛"
              },
              {
                "weight": 10,
                "source": "淋浊",
                "value": 0,
                "target": "败精浊瘀阻窍"
              },
              {
                "weight": 9,
                "source": "吐血",
                "value": 0,
                "target": "肝胃不和"
              },
              {
                "weight": 14,
                "source": "疮疡",
                "value": 0,
                "target": "疮"
              },
              {
                "weight": 9,
                "source": "产后",
                "value": 0,
                "target": "阴虚风阳动"
              },
              {
                "weight": 13,
                "source": "肝风",
                "value": 0,
                "target": "肝肾阴虚"
              },
              {
                "weight": 15,
                "source": "暑",
                "value": 0,
                "target": "暑湿弥漫三焦"
              },
              {
                "weight": 14,
                "source": "便闭",
                "value": 0,
                "target": "血液枯燥"
              },
              {
                "weight": 9,
                "source": "痰",
                "value": 0,
                "target": "痰火"
              },
              {
                "weight": 22,
                "source": "虚劳",
                "value": 0,
                "target": "阴虚阳浮"
              },
              {
                "weight": 11,
                "source": "脾胃",
                "value": 0,
                "target": "胃阳虚"
              },
              {
                "weight": 8,
                "source": "泄泻",
                "value": 0,
                "target": "脾胃阳虚"
              },
              {
                "weight": 11,
                "source": "咳嗽",
                "value": 0,
                "target": "胃阴虚"
              },
              {
                "weight": 15,
                "source": "吐蛔",
                "value": 0,
                "target": "胃虚肝乘"
              },
              {
                "weight": 14,
                "source": "肿胀",
                "value": 0,
                "target": "脾阳虚"
              },
              {
                "weight": 12,
                "source": "痢",
                "value": 0,
                "target": "阳虚"
              },
              {
                "weight": 10,
                "source": "诸痛",
                "value": 0,
                "target": "血络瘀痹"
              },
              {
                "weight": 13,
                "source": "喘",
                "value": 0,
                "target": "肾气不纳"
              },
              {
                "weight": 8,
                "source": "泄泻",
                "value": 0,
                "target": "湿热"
              },
              {
                "weight": 7,
                "source": "虚劳",
                "value": 0,
                "target": "营虚"
              },
              {
                "weight": 12,
                "source": "痢",
                "value": 0,
                "target": "久痢伤肾下焦不摄"
              },
              {
                "weight": 17,
                "source": "吐血",
                "value": 0,
                "target": "血络痹阻"
              },
              {
                "weight": 22,
                "source": "疟",
                "value": 0,
                "target": "阳虚"
              },
              {
                "weight": 7,
                "source": "温热",
                "value": 0,
                "target": "阴虚邪伏"
              },
              {
                "weight": 22,
                "source": "吐血",
                "value": 0,
                "target": "阴虚"
              },
              {
                "weight": 8,
                "source": "调经",
                "value": 0,
                "target": "痛经郁伤气血滞"
              },
              {
                "weight": 13,
                "source": "肠痹",
                "value": 0,
                "target": "肺气不开降"
              },
              {
                "weight": 9,
                "source": "疟",
                "value": 0,
                "target": "温疟"
              },
              {
                "weight": 8,
                "source": "痢",
                "value": 0,
                "target": "暑湿热"
              },
              {
                "weight": 14,
                "source": "泄泻",
                "value": 0,
                "target": "寒湿"
              },
              {
                "weight": 8,
                "source": "咳嗽",
                "value": 0,
                "target": "温邪"
              },
              {
                "weight": 12,
                "source": "胁痛",
                "value": 0,
                "target": "血络瘀痹"
              },
              {
                "weight": 14,
                "source": "吐血",
                "value": 0,
                "target": "营虚"
              },
              {
                "weight": 18,
                "source": "咳嗽",
                "value": 0,
                "target": "劳嗽"
              },
              {
                "weight": 16,
                "source": "虚劳",
                "value": 0,
                "target": "中虚"
              },
              {
                "weight": 8,
                "source": "痢",
                "value": 0,
                "target": "阳虚气滞"
              },
              {
                "weight": 18,
                "source": "遗精",
                "value": 0,
                "target": "心肾兼治"
              },
              {
                "weight": 19,
                "source": "暑",
                "value": 0,
                "target": "暑伤气分上焦闭郁"
              },
              {
                "weight": 20,
                "source": "咳嗽",
                "value": 0,
                "target": "燥"
              },
              {
                "weight": 8,
                "source": "痰饮",
                "value": 0,
                "target": "脾胃阳虚"
              },
              {
                "weight": 8,
                "source": "湿",
                "value": 0,
                "target": "湿郁脾阳"
              },
              {
                "weight": 12,
                "source": "痹",
                "value": 0,
                "target": "湿热"
              },
              {
                "weight": 10,
                "source": "噎膈反胃",
                "value": 0,
                "target": "阳结于上阴衰于下关格"
              },
              {
                "weight": 32,
                "source": "疟",
                "value": 0,
                "target": "肝胃"
              },
              {
                "weight": 24,
                "source": "虚劳",
                "value": 0,
                "target": "阴虚"
              },
              {
                "weight": 8,
                "source": "吐血",
                "value": 0,
                "target": "阴虚肝风动"
              },
              {
                "weight": 7,
                "source": "疝",
                "value": 0,
                "target": "浊阴凝聚肝络"
              }
            ],
            "nodes": [
              {
                "degree": 0,
                "name": "吐血",
                "id": "吐血",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "胃阴虚",
                "id": "胃阴虚",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "肿胀",
                "id": "肿胀",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "阳虚单胀浊阴凝滞",
                "id": "阳虚单胀浊阴凝滞",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "痹",
                "id": "痹",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "周痹",
                "id": "周痹",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "痉厥",
                "id": "痉厥",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "暑邪内陷胞络闭结",
                "id": "暑邪内陷胞络闭结",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "症瘕",
                "id": "症瘕",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "营络气聚结瘕",
                "id": "营络气聚结瘕",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "痰饮",
                "id": "痰饮",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "悬饮",
                "id": "悬饮",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "虚劳",
                "id": "虚劳",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "阳虚",
                "id": "阳虚",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "中风",
                "id": "中风",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "痰火阻络",
                "id": "痰火阻络",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "肝风",
                "id": "肝风",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "崩漏",
                "id": "崩漏",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "奇脉阴虚风阳动",
                "id": "奇脉阴虚风阳动",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "遗精",
                "id": "遗精",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "下损及中兼治脾胃",
                "id": "下损及中兼治脾胃",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "肝郁犯胃兼湿",
                "id": "肝郁犯胃兼湿",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "疝",
                "id": "疝",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "久疝湿热郁",
                "id": "久疝湿热郁",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "脾阳不运",
                "id": "脾阳不运",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "痘",
                "id": "痘",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "肝肾蕴毒闷症",
                "id": "肝肾蕴毒闷症",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "呕吐",
                "id": "呕吐",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "胃阳虚浊阴上逆",
                "id": "胃阳虚浊阴上逆",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "暑",
                "id": "暑",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "暑热阻气中痞不运",
                "id": "暑热阻气中痞不运",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "风湿",
                "id": "风湿",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "阴阳并虚",
                "id": "阴阳并虚",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "木乘土",
                "id": "木乘土",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "肝胃",
                "id": "肝胃",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "腰腿足痛",
                "id": "腰腿足痛",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "腰痛",
                "id": "腰痛",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "产后",
                "id": "产后",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "阳虚肿胀",
                "id": "阳虚肿胀",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "痢",
                "id": "痢",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "痢伤阴液",
                "id": "痢伤阴液",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "胃脘痛",
                "id": "胃脘痛",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "肝犯胃",
                "id": "肝犯胃",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "蓐劳",
                "id": "蓐劳",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "疮疡",
                "id": "疮疡",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "溃疡",
                "id": "溃疡",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "寒湿",
                "id": "寒湿",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "阴虚阳升",
                "id": "阴虚阳升",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "郁冒",
                "id": "郁冒",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "湿",
                "id": "湿",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "湿阻中焦阳气",
                "id": "湿阻中焦阳气",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "泄泻",
                "id": "泄泻",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "暑湿热",
                "id": "暑湿热",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "噎膈反胃",
                "id": "噎膈反胃",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "胃阳虚",
                "id": "胃阳虚",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "疟",
                "id": "疟",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "暑疟",
                "id": "暑疟",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "胸痹",
                "id": "胸痹",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "胸脘清阳不运",
                "id": "胸脘清阳不运",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "脱",
                "id": "脱",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "瘅疟",
                "id": "瘅疟",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "脾肾阳虚",
                "id": "脾肾阳虚",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "肺痹",
                "id": "肺痹",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "上焦气分壅热肺不开降",
                "id": "上焦气分壅热肺不开降",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "阴虚阳动",
                "id": "阴虚阳动",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "疟变痢",
                "id": "疟变痢",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "肝阴虚",
                "id": "肝阴虚",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "痞",
                "id": "痞",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "目疾",
                "id": "目疾",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "木火上郁",
                "id": "木火上郁",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "肾阳虚饮逆喘咳呕",
                "id": "肾阳虚饮逆喘咳呕",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "湿热",
                "id": "湿热",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "脾阳虚",
                "id": "脾阳虚",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "肾阴虚肝风动",
                "id": "肾阴虚肝风动",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "咳嗽",
                "id": "咳嗽",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "中气虚",
                "id": "中气虚",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "劳伤中气虚",
                "id": "劳伤中气虚",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "血络痹胸胁痛",
                "id": "血络痹胸胁痛",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "淋浊",
                "id": "淋浊",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "败精浊瘀阻窍",
                "id": "败精浊瘀阻窍",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "肝胃不和",
                "id": "肝胃不和",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "疮",
                "id": "疮",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "阴虚风阳动",
                "id": "阴虚风阳动",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "肝肾阴虚",
                "id": "肝肾阴虚",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "暑湿弥漫三焦",
                "id": "暑湿弥漫三焦",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "便闭",
                "id": "便闭",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "血液枯燥",
                "id": "血液枯燥",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "痰",
                "id": "痰",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "痰火",
                "id": "痰火",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "阴虚阳浮",
                "id": "阴虚阳浮",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "脾胃",
                "id": "脾胃",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "脾胃阳虚",
                "id": "脾胃阳虚",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "吐蛔",
                "id": "吐蛔",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "胃虚肝乘",
                "id": "胃虚肝乘",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "诸痛",
                "id": "诸痛",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "血络瘀痹",
                "id": "血络瘀痹",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "喘",
                "id": "喘",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "肾气不纳",
                "id": "肾气不纳",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "营虚",
                "id": "营虚",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "久痢伤肾下焦不摄",
                "id": "久痢伤肾下焦不摄",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "血络痹阻",
                "id": "血络痹阻",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "温热",
                "id": "温热",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "阴虚邪伏",
                "id": "阴虚邪伏",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "阴虚",
                "id": "阴虚",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "调经",
                "id": "调经",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "痛经郁伤气血滞",
                "id": "痛经郁伤气血滞",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "肠痹",
                "id": "肠痹",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "肺气不开降",
                "id": "肺气不开降",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "温疟",
                "id": "温疟",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "温邪",
                "id": "温邪",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "胁痛",
                "id": "胁痛",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "劳嗽",
                "id": "劳嗽",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "中虚",
                "id": "中虚",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "阳虚气滞",
                "id": "阳虚气滞",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "心肾兼治",
                "id": "心肾兼治",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "暑伤气分上焦闭郁",
                "id": "暑伤气分上焦闭郁",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "燥",
                "id": "燥",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "湿郁脾阳",
                "id": "湿郁脾阳",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "阳结于上阴衰于下关格",
                "id": "阳结于上阴衰于下关格",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "阴虚肝风动",
                "id": "阴虚肝风动",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "浊阴凝聚肝络",
                "id": "浊阴凝聚肝络",
                "distance": 0,
                "group": "6"
              }
            ]
        },
        lc:[
            {
              "f1": 0,
              "keyName": "脉数",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "1%",
              "valueName": "25"
            },
            {
              "f1": 0,
              "keyName": "大便不爽",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "1%",
              "valueName": "24"
            },
            {
              "f1": 0,
              "keyName": "舌白",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "1%",
              "valueName": "18"
            },
            {
              "f1": 0,
              "keyName": "寒热",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0%",
              "valueName": "14"
            },
            {
              "f1": 0,
              "keyName": "不饥不食",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0%",
              "valueName": "13"
            },
            {
              "f1": 0,
              "keyName": "脉沉",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0%",
              "valueName": "12"
            },
            {
              "f1": 0,
              "keyName": "咳嗽",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0%",
              "valueName": "12"
            },
            {
              "f1": 0,
              "keyName": "腹痛",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0%",
              "valueName": "11"
            },
            {
              "f1": 0,
              "keyName": "脉左数",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0%",
              "valueName": "11"
            },
            {
              "f1": 0,
              "keyName": "脉弦",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0%",
              "valueName": "11"
            }
        ],
        tj:[
            {
              "f1": 0,
              "keyName": "吐血",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "7.53%",
              "valueName": "236"
            },
            {
              "f1": 0,
              "keyName": "疟",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "5.90%",
              "valueName": "185"
            },
            {
              "f1": 0,
              "keyName": "咳嗽",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "5.01%",
              "valueName": "157"
            },
            {
              "f1": 0,
              "keyName": "虚劳",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.95%",
              "valueName": "124"
            },
            {
              "f1": 0,
              "keyName": "产后",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.86%",
              "valueName": "121"
            },
            {
              "f1": 0,
              "keyName": "痢",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.51%",
              "valueName": "110"
            },
            {
              "f1": 0,
              "keyName": "肿胀",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.28%",
              "valueName": "103"
            },
            {
              "f1": 0,
              "keyName": "泄泻",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.90%",
              "valueName": "91"
            },
            {
              "f1": 0,
              "keyName": "痰饮",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.65%",
              "valueName": "83"
            },
            {
              "f1": 0,
              "keyName": "痹",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.61%",
              "valueName": "82"
            }
        ],
        zh:[
            {
              "f1": 0,
              "keyName": "阳虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.59%",
              "valueName": "113"
            },
            {
              "f1": 0,
              "keyName": "阴虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.58%",
              "valueName": "81"
            },
            {
              "f1": 0,
              "keyName": "失和",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.73%",
              "valueName": "23"
            },
            {
              "f1": 0,
              "keyName": "虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.67%",
              "valueName": "21"
            },
            {
              "f1": 0,
              "keyName": "气郁",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.64%",
              "valueName": "20"
            },
            {
              "f1": 0,
              "keyName": "气虚",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.54%",
              "valueName": "17"
            },
            {
              "f1": 0,
              "keyName": "热",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.45%",
              "valueName": "14"
            },
            {
              "f1": 0,
              "keyName": "气逆",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.19%",
              "valueName": "6"
            },
            {
              "f1": 0,
              "keyName": "食积",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.13%",
              "valueName": "4"
            },
            {
              "f1": 0,
              "keyName": "寒",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.10%",
              "valueName": "3"
            }
        ],
    },
    cfyy:{
        gj:[
            {
              "f1": 0,
              "keyName": "肺",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "42.99%",
              "valueName": "8403"
            },
            {
              "f1": 0,
              "keyName": "脾",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "39.28%",
              "valueName": "7678"
            },
            {
              "f1": 0,
              "keyName": "心",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "32.25%",
              "valueName": "6304"
            },
            {
              "f1": 0,
              "keyName": "肾",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "29.19%",
              "valueName": "5706"
            },
            {
              "f1": 0,
              "keyName": "胃",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "24.16%",
              "valueName": "4722"
            },
            {
              "f1": 0,
              "keyName": "肝",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "22.35%",
              "valueName": "4369"
            },
            {
              "f1": 0,
              "keyName": "膀胱",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "6.16%",
              "valueName": "1204"
            },
            {
              "f1": 0,
              "keyName": "大肠",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "4.76%",
              "valueName": "930"
            },
            {
              "f1": 0,
              "keyName": "小肠",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.08%",
              "valueName": "407"
            },
            {
              "f1": 0,
              "keyName": "胆",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.02%",
              "valueName": "395"
            },
            {
              "f1": 0,
              "keyName": "三焦",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "1.49%",
              "valueName": "292"
            },
            {
              "f1": 0,
              "keyName": "心包",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.66%",
              "valueName": "129"
            }
        ],
        gx:[
            {
              "f1": 0,
              "keyName": "宁心",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "6.81%",
              "valueName": "1331"
            },
            {
              "f1": 0,
              "keyName": "利水渗湿",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "5.94%",
              "valueName": "1162"
            },
            {
              "f1": 0,
              "keyName": "健脾",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "5.07%",
              "valueName": "991"
            },
            {
              "f1": 0,
              "keyName": "燥湿化痰",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "4.39%",
              "valueName": "859"
            },
            {
              "f1": 0,
              "keyName": "生津养血",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "4.33%",
              "valueName": "847"
            },
            {
              "f1": 0,
              "keyName": "安神益智",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "4.18%",
              "valueName": "817"
            },
            {
              "f1": 0,
              "keyName": "大补元气",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.68%",
              "valueName": "720"
            },
            {
              "f1": 0,
              "keyName": "补脾益肺",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.68%",
              "valueName": "720"
            },
            {
              "f1": 0,
              "keyName": "复脉固脱",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.68%",
              "valueName": "720"
            },
            {
              "f1": 0,
              "keyName": "清热凉血",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.44%",
              "valueName": "673"
            }
        ],
        jl_1:{
            "distance": 35.32704346531139,
            "children": [
              {
                "distance": 0,
                "degree": 0,
                "name": "茯苓"
              },
              {
                "distance": 31.63858403911275,
                "children": [
                  {
                    "distance": 0,
                    "degree": 0,
                    "name": "人参"
                  },
                  {
                    "distance": 27,
                    "children": [
                      {
                        "distance": 24.310491562286437,
                        "children": [
                          {
                            "distance": 0,
                            "degree": 0,
                            "name": "杏仁"
                          },
                          {
                            "distance": 22.693611435820433,
                            "children": [
                              {
                                "distance": 0,
                                "degree": 0,
                                "name": "半夏"
                              },
                              {
                                "distance": 18.49324200890693,
                                "children": [
                                  {
                                    "distance": 0,
                                    "degree": 0,
                                    "name": "陈皮"
                                  },
                                  {
                                    "distance": 0,
                                    "degree": 0,
                                    "name": "厚朴"
                                  }
                                ],
                                "degree": 0,
                                "name": "4"
                              }
                            ],
                            "degree": 0,
                            "name": "10"
                          }
                        ],
                        "degree": 0,
                        "name": "15"
                      },
                      {
                        "distance": 25.768197453450252,
                        "children": [
                          {
                            "distance": 23.15167380558045,
                            "children": [
                              {
                                "distance": 0,
                                "degree": 0,
                                "name": "茯神"
                              },
                              {
                                "distance": 23.021728866442675,
                                "children": [
                                  {
                                    "distance": 15.968719422671311,
                                    "children": [
                                      {
                                        "distance": 0,
                                        "degree": 0,
                                        "name": "地黄"
                                      },
                                      {
                                        "distance": 0,
                                        "degree": 0,
                                        "name": "阿胶"
                                      }
                                    ],
                                    "degree": 0,
                                    "name": "2"
                                  },
                                  {
                                    "distance": 21.18962010041709,
                                    "children": [
                                      {
                                        "distance": 18.05547008526779,
                                        "children": [
                                          {
                                            "distance": 0,
                                            "degree": 0,
                                            "name": "麦冬"
                                          },
                                          {
                                            "distance": 0,
                                            "degree": 0,
                                            "name": "甘草"
                                          }
                                        ],
                                        "degree": 0,
                                        "name": "3"
                                      },
                                      {
                                        "distance": 20.29778313018444,
                                        "children": [
                                          {
                                            "distance": 0,
                                            "degree": 0,
                                            "name": "黄连"
                                          },
                                          {
                                            "distance": 19.621416870348583,
                                            "children": [
                                              {
                                                "distance": 0,
                                                "degree": 0,
                                                "name": "牡丹皮"
                                              },
                                              {
                                                "distance": 14.422205101855956,
                                                "children": [
                                                  {
                                                    "distance": 0,
                                                    "degree": 0,
                                                    "name": "熟地黄"
                                                  },
                                                  {
                                                    "distance": 0,
                                                    "degree": 0,
                                                    "name": "五味子"
                                                  }
                                                ],
                                                "degree": 0,
                                                "name": "1"
                                              }
                                            ],
                                            "degree": 0,
                                            "name": "5"
                                          }
                                        ],
                                        "degree": 0,
                                        "name": "7"
                                      }
                                    ],
                                    "degree": 0,
                                    "name": "8"
                                  }
                                ],
                                "degree": 0,
                                "name": "12"
                              }
                            ],
                            "degree": 0,
                            "name": "13"
                          },
                          {
                            "distance": 24.08318915758459,
                            "children": [
                              {
                                "distance": 0,
                                "degree": 0,
                                "name": "白芍"
                              },
                              {
                                "distance": 22.93468988235943,
                                "children": [
                                  {
                                    "distance": 0,
                                    "degree": 0,
                                    "name": "炙甘草"
                                  },
                                  {
                                    "distance": 22.315913604421397,
                                    "children": [
                                      {
                                        "distance": 0,
                                        "degree": 0,
                                        "name": "桂枝"
                                      },
                                      {
                                        "distance": 20.049937655763422,
                                        "children": [
                                          {
                                            "distance": 0,
                                            "degree": 0,
                                            "name": "白术"
                                          },
                                          {
                                            "distance": 0,
                                            "degree": 0,
                                            "name": "当归"
                                          }
                                        ],
                                        "degree": 0,
                                        "name": "6"
                                      }
                                    ],
                                    "degree": 0,
                                    "name": "9"
                                  }
                                ],
                                "degree": 0,
                                "name": "11"
                              }
                            ],
                            "degree": 0,
                            "name": "14"
                          }
                        ],
                        "degree": 0,
                        "name": "16"
                      }
                    ],
                    "degree": 0,
                    "name": "17"
                  }
                ],
                "degree": 0,
                "name": "18"
              }
            ],
            "degree": 0,
            "name": "19"
        },
        jl_table:[
              {
                "variable": "茯苓",
                "intvalue": 961
              },
              {
                "variable": "人参",
                "intvalue": 711
              },
              {
                "variable": "炙甘草",
                "intvalue": 439
              },
              {
                "variable": "白芍",
                "intvalue": 379
              },
              {
                "variable": "桂枝",
                "intvalue": 345
              },
              {
                "variable": "半夏",
                "intvalue": 340
              },
              {
                "variable": "陈皮",
                "intvalue": 335
              },
              {
                "variable": "地黄",
                "intvalue": 335
              },
              {
                "variable": "茯神",
                "intvalue": 331
              },
              {
                "variable": "杏仁",
                "intvalue": 296
              },
              {
                "variable": "白术",
                "intvalue": 255
              },
              {
                "variable": "麦冬",
                "intvalue": 255
              },
              {
                "variable": "当归",
                "intvalue": 225
              },
              {
                "variable": "厚朴",
                "intvalue": 223
              },
              {
                "variable": "牡丹皮",
                "intvalue": 214
              },
              {
                "variable": "熟地黄",
                "intvalue": 209
              },
              {
                "variable": "阿胶",
                "intvalue": 204
              },
              {
                "variable": "黄连",
                "intvalue": 203
              },
              {
                "variable": "五味子",
                "intvalue": 195
              },
              {
                "variable": "甘草",
                "intvalue": 177
              }
        ],
          sq:[
            {
              "f1": 0,
              "keyName": "茯苓",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "31.44%",
              "valueName": "986"
            },
            {
              "f1": 0,
              "keyName": "人参",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "22.96%",
              "valueName": "720"
            },
            {
              "f1": 0,
              "keyName": "炙甘草",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "14.25%",
              "valueName": "447"
            },
            {
              "f1": 0,
              "keyName": "白芍",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "12.24%",
              "valueName": "384"
            },
            {
              "f1": 0,
              "keyName": "桂枝",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "11.22%",
              "valueName": "352"
            },
            {
              "f1": 0,
              "keyName": "茯神",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "11.00%",
              "valueName": "345"
            },
            {
              "f1": 0,
              "keyName": "半夏",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "10.94%",
              "valueName": "343"
            },
            {
              "f1": 0,
              "keyName": "陈皮",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "10.87%",
              "valueName": "341"
            },
            {
              "f1": 0,
              "keyName": "地黄",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "10.71%",
              "valueName": "336"
            },
            {
              "f1": 0,
              "keyName": "杏仁",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "9.50%",
              "valueName": "298"
            }
          ],
          tj:[
            {
              "f1": 0,
              "keyName": "茯苓",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "31.44%",
              "valueName": "986"
            },
            {
              "f1": 0,
              "keyName": "人参",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "22.96%",
              "valueName": "720"
            },
            {
              "f1": 0,
              "keyName": "炙甘草",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "14.25%",
              "valueName": "447"
            },
            {
              "f1": 0,
              "keyName": "白芍",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "12.24%",
              "valueName": "384"
            },
            {
              "f1": 0,
              "keyName": "桂枝",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "11.22%",
              "valueName": "352"
            },
            {
              "f1": 0,
              "keyName": "茯神",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "11.00%",
              "valueName": "345"
            },
            {
              "f1": 0,
              "keyName": "半夏",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "10.94%",
              "valueName": "343"
            },
            {
              "f1": 0,
              "keyName": "陈皮",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "10.87%",
              "valueName": "341"
            },
            {
              "f1": 0,
              "keyName": "地黄",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "10.71%",
              "valueName": "336"
            },
            {
              "f1": 0,
              "keyName": "杏仁",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "9.50%",
              "valueName": "298"
            }
          ],
          ww:[
            {
              "f1": 0,
              "keyName": "甘",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "43.34%",
              "valueName": "8472"
            },
            {
              "f1": 0,
              "keyName": "苦",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "25.47%",
              "valueName": "4979"
            },
            {
              "f1": 0,
              "keyName": "辛",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "24.51%",
              "valueName": "4791"
            },
            {
              "f1": 0,
              "keyName": "淡",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "10.30%",
              "valueName": "2014"
            },
            {
              "f1": 0,
              "keyName": "微苦",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "6.09%",
              "valueName": "1191"
            },
            {
              "f1": 0,
              "keyName": "酸",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "5.36%",
              "valueName": "1048"
            },
            {
              "f1": 0,
              "keyName": "咸",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "3.67%",
              "valueName": "718"
            },
            {
              "f1": 0,
              "keyName": "涩",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "2.54%",
              "valueName": "497"
            },
            {
              "f1": 0,
              "keyName": "微甘",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.69%",
              "valueName": "135"
            },
            {
              "f1": 0,
              "keyName": "微辛",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.02%",
              "valueName": "3"
            },
            {
              "f1": 0,
              "keyName": "微酸",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.01%",
              "valueName": "2"
            },
            {
              "f1": 0,
              "keyName": "微咸",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.00%",
              "valueName": "0"
            },
            {
              "f1": 0,
              "keyName": "微涩",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.00%",
              "valueName": "0"
            }
          ],
          zy_fz:{
            jsonList:[
               {
                "elements": {
                  "nodes": [
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "厚朴",
                        "id": "厚朴"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "茯苓",
                        "id": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "半夏",
                        "id": "半夏"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "生姜汁",
                        "id": "生姜汁"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "炙甘草",
                        "id": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "麦冬",
                        "id": "麦冬"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "人参",
                        "id": "人参"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "熟地黄",
                        "id": "熟地黄"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "黄芩",
                        "id": "黄芩"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "白芍",
                        "id": "白芍"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "干姜",
                        "id": "干姜"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "生姜",
                        "id": "生姜"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "大枣",
                        "id": "大枣"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "白术",
                        "id": "白术"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "桂枝",
                        "id": "桂枝"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "山药",
                        "id": "山药"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "枳实",
                        "id": "枳实"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "阿胶",
                        "id": "阿胶"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "茯神",
                        "id": "茯神"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "山萸肉",
                        "id": "山萸肉"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "附子",
                        "id": "附子"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "五味子",
                        "id": "五味子"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "黄连",
                        "id": "黄连"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "陈皮",
                        "id": "陈皮"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "当归",
                        "id": "当归"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "黄芪",
                        "id": "黄芪"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "甘草",
                        "id": "甘草"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "杏仁",
                        "id": "杏仁"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "薏苡仁",
                        "id": "薏苡仁"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "泽泻",
                        "id": "泽泻"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "远志",
                        "id": "远志"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "地黄",
                        "id": "地黄"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "连翘",
                        "id": "连翘"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "玄参",
                        "id": "玄参"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "橘红",
                        "id": "橘红"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "牡丹皮",
                        "id": "牡丹皮"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "南枣",
                        "id": "南枣"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "天冬",
                        "id": "天冬"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "石膏",
                        "id": "石膏"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "鲜石斛",
                        "id": "鲜石斛"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "猪苓",
                        "id": "猪苓"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "瓜蒌皮",
                        "id": "瓜蒌皮"
                      }
                    },
                    {
                      "data": {
                        "distance": 0,
                        "degree": 0,
                        "name": "郁金",
                        "id": "郁金"
                      }
                    }
                  ],
                  "edges": [
                    {
                      "data": {
                        "weight": '210',
                        "source": "厚朴",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 230,
                        "source": "半夏",
                        "value": 0,
                        "target": "生姜汁"
                      }
                    },
                    {
                      "data": {
                        "weight": 124,
                        "source": "炙甘草",
                        "value": 0,
                        "target": "麦冬"
                      }
                    },
                    {
                      "data": {
                        "weight": 482,
                        "source": "人参",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 206,
                        "source": "熟地黄",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "黄芩",
                        "value": 0,
                        "target": "白芍"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "半夏",
                        "value": 0,
                        "target": "干姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 130,
                        "source": "生姜",
                        "value": 0,
                        "target": "大枣"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "白术",
                        "value": 0,
                        "target": "桂枝"
                      }
                    },
                    {
                      "data": {
                        "weight": 162,
                        "source": "山药",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 106,
                        "source": "人参",
                        "value": 0,
                        "target": "熟地黄"
                      }
                    },
                    {
                      "data": {
                        "weight": 104,
                        "source": "人参",
                        "value": 0,
                        "target": "枳实"
                      }
                    },
                    {
                      "data": {
                        "weight": 184,
                        "source": "茯苓",
                        "value": 0,
                        "target": "生姜汁"
                      }
                    },
                    {
                      "data": {
                        "weight": 114,
                        "source": "阿胶",
                        "value": 0,
                        "target": "茯神"
                      }
                    },
                    {
                      "data": {
                        "weight": 360,
                        "source": "白术",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 124,
                        "source": "茯神",
                        "value": 0,
                        "target": "白芍"
                      }
                    },
                    {
                      "data": {
                        "weight": 108,
                        "source": "山萸肉",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 128,
                        "source": "附子",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 182,
                        "source": "茯苓",
                        "value": 0,
                        "target": "五味子"
                      }
                    },
                    {
                      "data": {
                        "weight": 130,
                        "source": "人参",
                        "value": 0,
                        "target": "大枣"
                      }
                    },
                    {
                      "data": {
                        "weight": 206,
                        "source": "人参",
                        "value": 0,
                        "target": "白术"
                      }
                    },
                    {
                      "data": {
                        "weight": 124,
                        "source": "黄连",
                        "value": 0,
                        "target": "白芍"
                      }
                    },
                    {
                      "data": {
                        "weight": 292,
                        "source": "人参",
                        "value": 0,
                        "target": "陈皮"
                      }
                    },
                    {
                      "data": {
                        "weight": 150,
                        "source": "人参",
                        "value": 0,
                        "target": "当归"
                      }
                    },
                    {
                      "data": {
                        "weight": 110,
                        "source": "人参",
                        "value": 0,
                        "target": "黄芪"
                      }
                    },
                    {
                      "data": {
                        "weight": 110,
                        "source": "甘草",
                        "value": 0,
                        "target": "麦冬"
                      }
                    },
                    {
                      "data": {
                        "weight": 118,
                        "source": "杏仁",
                        "value": 0,
                        "target": "厚朴"
                      }
                    },
                    {
                      "data": {
                        "weight": 168,
                        "source": "人参",
                        "value": 0,
                        "target": "五味子"
                      }
                    },
                    {
                      "data": {
                        "weight": 280,
                        "source": "白芍",
                        "value": 0,
                        "target": "人参"
                      }
                    },
                    {
                      "data": {
                        "weight": 130,
                        "source": "茯苓",
                        "value": 0,
                        "target": "薏苡仁"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "山萸肉",
                        "value": 0,
                        "target": "山药"
                      }
                    },
                    {
                      "data": {
                        "weight": 238,
                        "source": "白芍",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 350,
                        "source": "茯苓",
                        "value": 0,
                        "target": "桂枝"
                      }
                    },
                    {
                      "data": {
                        "weight": 120,
                        "source": "人参",
                        "value": 0,
                        "target": "附子"
                      }
                    },
                    {
                      "data": {
                        "weight": 152,
                        "source": "麦冬",
                        "value": 0,
                        "target": "阿胶"
                      }
                    },
                    {
                      "data": {
                        "weight": 288,
                        "source": "茯苓",
                        "value": 0,
                        "target": "泽泻"
                      }
                    },
                    {
                      "data": {
                        "weight": 200,
                        "source": "熟地黄",
                        "value": 0,
                        "target": "五味子"
                      }
                    },
                    {
                      "data": {
                        "weight": 156,
                        "source": "茯苓",
                        "value": 0,
                        "target": "生姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 124,
                        "source": "黄连",
                        "value": 0,
                        "target": "半夏"
                      }
                    },
                    {
                      "data": {
                        "weight": 698,
                        "source": "人参",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 158,
                        "source": "茯神",
                        "value": 0,
                        "target": "五味子"
                      }
                    },
                    {
                      "data": {
                        "weight": 124,
                        "source": "茯神",
                        "value": 0,
                        "target": "远志"
                      }
                    },
                    {
                      "data": {
                        "weight": 300,
                        "source": "白芍",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 190,
                        "source": "茯苓",
                        "value": 0,
                        "target": "干姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 142,
                        "source": "人参",
                        "value": 0,
                        "target": "黄连"
                      }
                    },
                    {
                      "data": {
                        "weight": 122,
                        "source": "人参",
                        "value": 0,
                        "target": "地黄"
                      }
                    },
                    {
                      "data": {
                        "weight": 132,
                        "source": "人参",
                        "value": 0,
                        "target": "生姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 138,
                        "source": "地黄",
                        "value": 0,
                        "target": "茯神"
                      }
                    },
                    {
                      "data": {
                        "weight": 118,
                        "source": "人参",
                        "value": 0,
                        "target": "桂枝"
                      }
                    },
                    {
                      "data": {
                        "weight": 158,
                        "source": "熟地黄",
                        "value": 0,
                        "target": "山萸肉"
                      }
                    },
                    {
                      "data": {
                        "weight": 146,
                        "source": "茯神",
                        "value": 0,
                        "target": "熟地黄"
                      }
                    },
                    {
                      "data": {
                        "weight": 108,
                        "source": "连翘",
                        "value": 0,
                        "target": "杏仁"
                      }
                    },
                    {
                      "data": {
                        "weight": 190,
                        "source": "白术",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 182,
                        "source": "桂枝",
                        "value": 0,
                        "target": "白芍"
                      }
                    },
                    {
                      "data": {
                        "weight": 162,
                        "source": "人参",
                        "value": 0,
                        "target": "干姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 356,
                        "source": "茯苓",
                        "value": 0,
                        "target": "半夏"
                      }
                    },
                    {
                      "data": {
                        "weight": 154,
                        "source": "阿胶",
                        "value": 0,
                        "target": "白芍"
                      }
                    },
                    {
                      "data": {
                        "weight": 114,
                        "source": "地黄",
                        "value": 0,
                        "target": "玄参"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "橘红",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 196,
                        "source": "炙甘草",
                        "value": 0,
                        "target": "大枣"
                      }
                    },
                    {
                      "data": {
                        "weight": 118,
                        "source": "牡丹皮",
                        "value": 0,
                        "target": "泽泻"
                      }
                    },
                    {
                      "data": {
                        "weight": 160,
                        "source": "炙甘草",
                        "value": 0,
                        "target": "当归"
                      }
                    },
                    {
                      "data": {
                        "weight": 158,
                        "source": "地黄",
                        "value": 0,
                        "target": "白芍"
                      }
                    },
                    {
                      "data": {
                        "weight": 126,
                        "source": "桂枝",
                        "value": 0,
                        "target": "生姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 170,
                        "source": "麦冬",
                        "value": 0,
                        "target": "人参"
                      }
                    },
                    {
                      "data": {
                        "weight": 126,
                        "source": "黄连",
                        "value": 0,
                        "target": "枳实"
                      }
                    },
                    {
                      "data": {
                        "weight": 136,
                        "source": "炙甘草",
                        "value": 0,
                        "target": "南枣"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "天冬",
                        "value": 0,
                        "target": "茯神"
                      }
                    },
                    {
                      "data": {
                        "weight": 166,
                        "source": "半夏",
                        "value": 0,
                        "target": "陈皮"
                      }
                    },
                    {
                      "data": {
                        "weight": 180,
                        "source": "茯神",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 184,
                        "source": "茯苓",
                        "value": 0,
                        "target": "牡丹皮"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "阿胶",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "杏仁",
                        "value": 0,
                        "target": "半夏"
                      }
                    },
                    {
                      "data": {
                        "weight": 266,
                        "source": "桂枝",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 226,
                        "source": "地黄",
                        "value": 0,
                        "target": "麦冬"
                      }
                    },
                    {
                      "data": {
                        "weight": 162,
                        "source": "黄芪",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 114,
                        "source": "阿胶",
                        "value": 0,
                        "target": "天冬"
                      }
                    },
                    {
                      "data": {
                        "weight": 160,
                        "source": "熟地黄",
                        "value": 0,
                        "target": "山药"
                      }
                    },
                    {
                      "data": {
                        "weight": 110,
                        "source": "石膏",
                        "value": 0,
                        "target": "杏仁"
                      }
                    },
                    {
                      "data": {
                        "weight": 354,
                        "source": "茯苓",
                        "value": 0,
                        "target": "炙甘草"
                      }
                    },
                    {
                      "data": {
                        "weight": 104,
                        "source": "黄连",
                        "value": 0,
                        "target": "干姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 392,
                        "source": "陈皮",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 118,
                        "source": "鲜石斛",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 110,
                        "source": "杏仁",
                        "value": 0,
                        "target": "橘红"
                      }
                    },
                    {
                      "data": {
                        "weight": 288,
                        "source": "地黄",
                        "value": 0,
                        "target": "阿胶"
                      }
                    },
                    {
                      "data": {
                        "weight": 174,
                        "source": "白术",
                        "value": 0,
                        "target": "陈皮"
                      }
                    },
                    {
                      "data": {
                        "weight": 112,
                        "source": "炙甘草",
                        "value": 0,
                        "target": "地黄"
                      }
                    },
                    {
                      "data": {
                        "weight": 142,
                        "source": "炙甘草",
                        "value": 0,
                        "target": "生姜"
                      }
                    },
                    {
                      "data": {
                        "weight": 118,
                        "source": "桂枝",
                        "value": 0,
                        "target": "大枣"
                      }
                    },
                    {
                      "data": {
                        "weight": 120,
                        "source": "猪苓",
                        "value": 0,
                        "target": "泽泻"
                      }
                    },
                    {
                      "data": {
                        "weight": 108,
                        "source": "瓜蒌皮",
                        "value": 0,
                        "target": "杏仁"
                      }
                    },
                    {
                      "data": {
                        "weight": 202,
                        "source": "当归",
                        "value": 0,
                        "target": "茯苓"
                      }
                    },
                    {
                      "data": {
                        "weight": 218,
                        "source": "厚朴",
                        "value": 0,
                        "target": "陈皮"
                      }
                    },
                    {
                      "data": {
                        "weight": 162,
                        "source": "地黄",
                        "value": 0,
                        "target": "天冬"
                      }
                    },
                    {
                      "data": {
                        "weight": 220,
                        "source": "人参",
                        "value": 0,
                        "target": "半夏"
                      }
                    },
                    {
                      "data": {
                        "weight": 132,
                        "source": "杏仁",
                        "value": 0,
                        "target": "郁金"
                      }
                    },
                    {
                      "data": {
                        "weight": 198,
                        "source": "炙甘草",
                        "value": 0,
                        "target": "陈皮"
                      }
                    },
                    {
                      "data": {
                        "weight": 114,
                        "source": "半夏",
                        "value": 0,
                        "target": "枳实"
                      }
                    },
                    {
                      "data": {
                        "weight": 154,
                        "source": "黄连",
                        "value": 0,
                        "target": "黄芩"
                      }
                    },
                    {
                      "data": {
                        "weight": 300,
                        "source": "人参",
                        "value": 0,
                        "target": "茯神"
                      }
                    }
                  ]
                }
              }
            ]
          },
          zy_gl:[
            {
              "coverage": "0.015630427231677665",
              "confidence": "1.0",
              "count": 45,
              "lift": "2.9377551020408164",
              "source": "牡丹皮,山药",
              "support": "0.015630427231677665",
              "target": "茯苓"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "1.0",
              "count": 42,
              "lift": "2.9377551020408164",
              "source": "熟地黄,泽泻",
              "support": "0.014588398749565822",
              "target": "茯苓"
            },
            {
              "coverage": "0.01528308440430705",
              "confidence": "1.0",
              "count": 44,
              "lift": "2.9377551020408164",
              "source": "山药,泽泻",
              "support": "0.01528308440430705",
              "target": "茯苓"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "2.9377551020408164",
              "source": "山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "茯苓"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "1.0",
              "count": 42,
              "lift": "13.267281105990783",
              "source": "熟地黄,泽泻",
              "support": "0.014588398749565822",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.011809656130600903",
              "confidence": "1.0",
              "count": 34,
              "lift": "13.709523809523809",
              "source": "牡丹皮,山萸肉",
              "support": "0.011809656130600903",
              "target": "熟地黄"
            },
            {
              "coverage": "0.01528308440430705",
              "confidence": "1.0",
              "count": 44,
              "lift": "13.267281105990783",
              "source": "山药,泽泻",
              "support": "0.01528308440430705",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.267281105990783",
              "source": "山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.709523809523809",
              "source": "山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "熟地黄"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "1.0",
              "count": 42,
              "lift": "16.357954545454547",
              "source": "茯苓,牡丹皮,熟地黄",
              "support": "0.014588398749565822",
              "target": "泽泻"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "1.0",
              "count": 42,
              "lift": "13.267281105990783",
              "source": "茯苓,熟地黄,泽泻",
              "support": "0.014588398749565822",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "1.0",
              "count": 42,
              "lift": "2.9377551020408164",
              "source": "牡丹皮,熟地黄,泽泻",
              "support": "0.014588398749565822",
              "target": "茯苓"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "1.0",
              "count": 36,
              "lift": "2.9377551020408164",
              "source": "牡丹皮,山药,熟地黄",
              "support": "0.012504341785342132",
              "target": "茯苓"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.709523809523809",
              "source": "茯苓,牡丹皮,山萸肉",
              "support": "0.011462313303230288",
              "target": "熟地黄"
            },
            {
              "coverage": "0.01528308440430705",
              "confidence": "1.0",
              "count": 44,
              "lift": "13.267281105990783",
              "source": "茯苓,山药,泽泻",
              "support": "0.01528308440430705",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.01528308440430705",
              "confidence": "1.0",
              "count": 44,
              "lift": "2.9377551020408164",
              "source": "牡丹皮,山药,泽泻",
              "support": "0.01528308440430705",
              "target": "茯苓"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "16.357954545454547",
              "source": "茯苓,牡丹皮,山萸肉",
              "support": "0.011462313303230288",
              "target": "泽泻"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.267281105990783",
              "source": "茯苓,山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "2.9377551020408164",
              "source": "牡丹皮,山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "茯苓"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "1.0",
              "count": 36,
              "lift": "2.9377551020408164",
              "source": "山药,熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "茯苓"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.709523809523809",
              "source": "茯苓,山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "熟地黄"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "2.9377551020408164",
              "source": "山萸肉,熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "茯苓"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "1.0",
              "count": 36,
              "lift": "16.357954545454547",
              "source": "牡丹皮,山药,熟地黄",
              "support": "0.012504341785342132",
              "target": "泽泻"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "1.0",
              "count": 36,
              "lift": "13.267281105990783",
              "source": "山药,熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.709523809523809",
              "source": "牡丹皮,山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "熟地黄"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.267281105990783",
              "source": "山萸肉,熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "1.0",
              "count": 36,
              "lift": "16.357954545454547",
              "source": "茯苓,牡丹皮,山药,熟地黄",
              "support": "0.012504341785342132",
              "target": "泽泻"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "1.0",
              "count": 36,
              "lift": "13.267281105990783",
              "source": "茯苓,山药,熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "1.0",
              "count": 36,
              "lift": "2.9377551020408164",
              "source": "牡丹皮,山药,熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "茯苓"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "16.357954545454547",
              "source": "茯苓,牡丹皮,山萸肉,熟地黄",
              "support": "0.011462313303230288",
              "target": "泽泻"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.709523809523809",
              "source": "茯苓,牡丹皮,山萸肉,泽泻",
              "support": "0.011462313303230288",
              "target": "熟地黄"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "13.267281105990783",
              "source": "茯苓,山萸肉,熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "1.0",
              "count": 33,
              "lift": "2.9377551020408164",
              "source": "牡丹皮,山萸肉,熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "茯苓"
            },
            {
              "coverage": "0.015630427231677665",
              "confidence": "0.9777777777777777",
              "count": 44,
              "lift": "15.994444444444445",
              "source": "牡丹皮,山药",
              "support": "0.01528308440430705",
              "target": "泽泻"
            },
            {
              "coverage": "0.015630427231677665",
              "confidence": "0.9777777777777777",
              "count": 44,
              "lift": "15.994444444444445",
              "source": "茯苓,牡丹皮,山药",
              "support": "0.01528308440430705",
              "target": "泽泻"
            },
            {
              "coverage": "0.013893713094824593",
              "confidence": "0.975",
              "count": 39,
              "lift": "13.366785714285715",
              "source": "茯苓,山药,山萸肉",
              "support": "0.013546370267453978",
              "target": "熟地黄"
            },
            {
              "coverage": "0.011809656130600903",
              "confidence": "0.9705882352941176",
              "count": 33,
              "lift": "2.8513505402160866",
              "source": "牡丹皮,山萸肉",
              "support": "0.011462313303230288",
              "target": "茯苓"
            },
            {
              "coverage": "0.011809656130600903",
              "confidence": "0.9705882352941176",
              "count": 33,
              "lift": "15.876838235294118",
              "source": "牡丹皮,山萸肉",
              "support": "0.011462313303230288",
              "target": "泽泻"
            },
            {
              "coverage": "0.011809656130600903",
              "confidence": "0.9705882352941176",
              "count": 33,
              "lift": "2.8513505402160866",
              "source": "牡丹皮,山萸肉,熟地黄",
              "support": "0.011462313303230288",
              "target": "茯苓"
            },
            {
              "coverage": "0.011809656130600903",
              "confidence": "0.9705882352941176",
              "count": 33,
              "lift": "15.876838235294118",
              "source": "牡丹皮,山萸肉,熟地黄",
              "support": "0.011462313303230288",
              "target": "泽泻"
            },
            {
              "coverage": "0.019451198332754428",
              "confidence": "0.9464285714285714",
              "count": 53,
              "lift": "12.975085034013604",
              "source": "山药,山萸肉",
              "support": "0.018409169850642584",
              "target": "熟地黄"
            },
            {
              "coverage": "0.018756512678013197",
              "confidence": "0.9444444444444444",
              "count": 51,
              "lift": "12.947883597883598",
              "source": "茯苓,山萸肉",
              "support": "0.017714484195901353",
              "target": "熟地黄"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "0.9393939393939394",
              "count": 31,
              "lift": "6.105000342020658",
              "source": "大枣,桂枝,生姜",
              "support": "0.01076762764848906",
              "target": "炙甘草"
            },
            {
              "coverage": "0.02014588398749566",
              "confidence": "0.9310344827586207",
              "count": 54,
              "lift": "2.7351513019000704",
              "source": "牡丹皮,泽泻",
              "support": "0.0187565126780132",
              "target": "茯苓"
            },
            {
              "coverage": "0.012851684612712747",
              "confidence": "0.918918918918919",
              "count": 34,
              "lift": "7.7130249783311005",
              "source": "人参,远志",
              "support": "0.011809656130600903",
              "target": "茯神"
            },
            {
              "coverage": "0.01667245571378951",
              "confidence": "0.9166666666666666",
              "count": 44,
              "lift": "12.749194847020933",
              "source": "地黄,麦冬,炙甘草",
              "support": "0.01528308440430705",
              "target": "阿胶"
            },
            {
              "coverage": "0.01667245571378951",
              "confidence": "0.9166666666666666",
              "count": 44,
              "lift": "7.854414682539682",
              "source": "阿胶,麦冬,炙甘草",
              "support": "0.01528308440430705",
              "target": "地黄"
            },
            {
              "coverage": "0.015977770059048282",
              "confidence": "0.9130434782608695",
              "count": 42,
              "lift": "2.682298136645963",
              "source": "牡丹皮,熟地黄",
              "support": "0.014588398749565822",
              "target": "茯苓"
            },
            {
              "coverage": "0.015977770059048282",
              "confidence": "0.9130434782608695",
              "count": 42,
              "lift": "14.93552371541502",
              "source": "牡丹皮,熟地黄",
              "support": "0.014588398749565822",
              "target": "泽泻"
            },
            {
              "coverage": "0.014241055922195206",
              "confidence": "0.9024390243902439",
              "count": 37,
              "lift": "14.762056541019955",
              "source": "茯苓,猪苓",
              "support": "0.012851684612712747",
              "target": "泽泻"
            },
            {
              "coverage": "0.013893713094824591",
              "confidence": "0.9",
              "count": 36,
              "lift": "5.848984198645598",
              "source": "饴糖",
              "support": "0.012504341785342132",
              "target": "炙甘草"
            },
            {
              "coverage": "0.017019798541160123",
              "confidence": "0.8979591836734694",
              "count": 44,
              "lift": "9.981561736663778",
              "source": "阿胶,地黄,炙甘草",
              "support": "0.01528308440430705",
              "target": "麦冬"
            },
            {
              "coverage": "0.030566168808614104",
              "confidence": "0.8977272727272727",
              "count": 79,
              "lift": "12.30741341991342",
              "source": "山萸肉",
              "support": "0.02744008336227857",
              "target": "熟地黄"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "0.8888888888888888",
              "count": 32,
              "lift": "5.776774517180837",
              "source": "大枣,人参,生姜",
              "support": "0.011114970475859673",
              "target": "炙甘草"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "0.8787878787878788",
              "count": 29,
              "lift": "5.711129352212874",
              "source": "大枣,黄芪",
              "support": "0.010072941993747829",
              "target": "炙甘草"
            },
            {
              "coverage": "0.011462313303230288",
              "confidence": "0.8787878787878788",
              "count": 29,
              "lift": "12.047763347763347",
              "source": "干姜,枳实",
              "support": "0.010072941993747829",
              "target": "黄连"
            },
            {
              "coverage": "0.01945119833275443",
              "confidence": "0.875",
              "count": 49,
              "lift": "12.169685990338165",
              "source": "地黄,炙甘草",
              "support": "0.017019798541160126",
              "target": "阿胶"
            },
            {
              "coverage": "0.01945119833275443",
              "confidence": "0.875",
              "count": 49,
              "lift": "7.497395833333333",
              "source": "阿胶,炙甘草",
              "support": "0.017019798541160126",
              "target": "地黄"
            },
            {
              "coverage": "0.016325112886418896",
              "confidence": "0.8723404255319149",
              "count": 41,
              "lift": "2.56272253582284",
              "source": "白术,泽泻",
              "support": "0.014241055922195206",
              "target": "茯苓"
            },
            {
              "coverage": "0.016325112886418896",
              "confidence": "0.8723404255319149",
              "count": 41,
              "lift": "5.669228183084386",
              "source": "白芍,大枣",
              "support": "0.014241055922195206",
              "target": "炙甘草"
            },
            {
              "coverage": "0.016325112886418896",
              "confidence": "0.8723404255319149",
              "count": 41,
              "lift": "7.1551797296478155",
              "source": "白芍,大枣",
              "support": "0.014241055922195206",
              "target": "桂枝"
            },
            {
              "coverage": "0.01319902744008336",
              "confidence": "0.868421052631579",
              "count": 33,
              "lift": "12.07818459191457",
              "source": "地黄,牡蛎",
              "support": "0.011462313303230288",
              "target": "阿胶"
            },
            {
              "coverage": "0.018061827023271967",
              "confidence": "0.8653846153846154",
              "count": 45,
              "lift": "11.864010989010989",
              "source": "山萸肉,五味子",
              "support": "0.015630427231677665",
              "target": "熟地黄"
            },
            {
              "coverage": "0.012851684612712745",
              "confidence": "0.8648648648648649",
              "count": 32,
              "lift": "17.412209412209414",
              "source": "人参,生姜,炙甘草",
              "support": "0.011114970475859673",
              "target": "大枣"
            },
            {
              "coverage": "0.02257728377908996",
              "confidence": "0.8615384615384616",
              "count": 56,
              "lift": "5.599027608959889",
              "source": "大枣,生姜",
              "support": "0.019451198332754428",
              "target": "炙甘草"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "0.8611111111111112",
              "count": 31,
              "lift": "2.5297335600907034",
              "source": "桂枝,泽泻",
              "support": "0.01076762764848906",
              "target": "茯苓"
            },
            {
              "coverage": "0.012504341785342132",
              "confidence": "0.8611111111111112",
              "count": 31,
              "lift": "17.336635586635587",
              "source": "桂枝,生姜,炙甘草",
              "support": "0.01076762764848906",
              "target": "大枣"
            },
            {
              "coverage": "0.014935741576936437",
              "confidence": "0.8604651162790697",
              "count": 37,
              "lift": "11.79656699889258",
              "source": "山药,五味子",
              "support": "0.012851684612712747",
              "target": "熟地黄"
            },
            {
              "coverage": "0.019451198332754428",
              "confidence": "0.8571428571428571",
              "count": 48,
              "lift": "9.527854384997243",
              "source": "地黄,炙甘草",
              "support": "0.01667245571378951",
              "target": "麦冬"
            },
            {
              "coverage": "0.019451198332754428",
              "confidence": "0.8571428571428571",
              "count": 48,
              "lift": "9.527854384997243",
              "source": "阿胶,炙甘草",
              "support": "0.01667245571378951",
              "target": "麦冬"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.8571428571428571",
              "count": 36,
              "lift": "21.458385093167703",
              "source": "熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "山药"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.8571428571428571",
              "count": 36,
              "lift": "21.458385093167703",
              "source": "茯苓,牡丹皮,熟地黄",
              "support": "0.012504341785342132",
              "target": "山药"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.8571428571428571",
              "count": 36,
              "lift": "21.458385093167703",
              "source": "茯苓,熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "山药"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.8571428571428571",
              "count": 36,
              "lift": "21.458385093167703",
              "source": "牡丹皮,熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "山药"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.8571428571428571",
              "count": 36,
              "lift": "21.458385093167703",
              "source": "茯苓,牡丹皮,熟地黄,泽泻",
              "support": "0.012504341785342132",
              "target": "山药"
            },
            {
              "coverage": "0.014241055922195208",
              "confidence": "0.8536585365853658",
              "count": 35,
              "lift": "7.001945660482245",
              "source": "白芍,大枣,炙甘草",
              "support": "0.012156998957971519",
              "target": "桂枝"
            },
            {
              "coverage": "0.014241055922195208",
              "confidence": "0.8536585365853658",
              "count": 35,
              "lift": "5.547816990585256",
              "source": "白芍,大枣,桂枝",
              "support": "0.012156998957971519",
              "target": "炙甘草"
            },
            {
              "coverage": "0.020493226814866275",
              "confidence": "0.847457627118644",
              "count": 50,
              "lift": "5.507518077820714",
              "source": "大枣,桂枝",
              "support": "0.01736714136853074",
              "target": "炙甘草"
            },
            {
              "coverage": "0.017714484195901357",
              "confidence": "0.8431372549019608",
              "count": 43,
              "lift": "2.476930772308924",
              "source": "益智仁",
              "support": "0.014935741576936437",
              "target": "茯苓"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.8333333333333334",
              "count": 35,
              "lift": "11.424603174603176",
              "source": "黄芩,枳实",
              "support": "0.012156998957971519",
              "target": "黄连"
            },
            {
              "coverage": "0.026398054880166725",
              "confidence": "0.8289473684210527",
              "count": 63,
              "lift": "7.102796052631579",
              "source": "阿胶,麦冬",
              "support": "0.021882598124348732",
              "target": "地黄"
            },
            {
              "coverage": "0.019798541160125045",
              "confidence": "0.8245614035087719",
              "count": 47,
              "lift": "7.065215121136173",
              "source": "阿胶,天冬",
              "support": "0.016325112886418896",
              "target": "地黄"
            },
            {
              "coverage": "0.01910385550538381",
              "confidence": "0.8181818181818182",
              "count": 45,
              "lift": "2.403617810760668",
              "source": "白术,桂枝",
              "support": "0.015630427231677665",
              "target": "茯苓"
            },
            {
              "coverage": "0.015283084404307049",
              "confidence": "0.8181818181818182",
              "count": 36,
              "lift": "11.216883116883118",
              "source": "山药,泽泻",
              "support": "0.012504341785342132",
              "target": "熟地黄"
            },
            {
              "coverage": "0.015283084404307049",
              "confidence": "0.8181818181818182",
              "count": 36,
              "lift": "28.380065717415114",
              "source": "芡实,熟地黄",
              "support": "0.012504341785342132",
              "target": "莲子"
            },
            {
              "coverage": "0.015283084404307049",
              "confidence": "0.8181818181818182",
              "count": 36,
              "lift": "11.216883116883118",
              "source": "茯苓,山药,泽泻",
              "support": "0.012504341785342132",
              "target": "熟地黄"
            },
            {
              "coverage": "0.015283084404307049",
              "confidence": "0.8181818181818182",
              "count": 36,
              "lift": "11.216883116883118",
              "source": "牡丹皮,山药,泽泻",
              "support": "0.012504341785342132",
              "target": "熟地黄"
            },
            {
              "coverage": "0.015283084404307049",
              "confidence": "0.8181818181818182",
              "count": 36,
              "lift": "11.216883116883118",
              "source": "茯苓,牡丹皮,山药,泽泻",
              "support": "0.012504341785342132",
              "target": "熟地黄"
            },
            {
              "coverage": "0.0187565126780132",
              "confidence": "0.8148148148148148",
              "count": 44,
              "lift": "20.398711755233492",
              "source": "茯苓,牡丹皮,泽泻",
              "support": "0.01528308440430705",
              "target": "山药"
            },
            {
              "coverage": "0.06113233761722821",
              "confidence": "0.8125",
              "count": 143,
              "lift": "2.3869260204081635",
              "source": "泽泻",
              "support": "0.04967002431399792",
              "target": "茯苓"
            },
            {
              "coverage": "0.014241055922195206",
              "confidence": "0.8048780487804879",
              "count": 33,
              "lift": "2.3645345943255354",
              "source": "陈皮,泽泻",
              "support": "0.011462313303230288",
              "target": "茯苓"
            },
            {
              "coverage": "0.024313997915943034",
              "confidence": "0.8",
              "count": 56,
              "lift": "16.10629370629371",
              "source": "生姜,炙甘草",
              "support": "0.019451198332754428",
              "target": "大枣"
            },
            {
              "coverage": "0.013893713094824591",
              "confidence": "0.8",
              "count": 32,
              "lift": "13.086363636363638",
              "source": "厚朴,猪苓",
              "support": "0.011114970475859673",
              "target": "泽泻"
            },
            {
              "coverage": "0.015630427231677665",
              "confidence": "0.8",
              "count": 36,
              "lift": "10.96761904761905",
              "source": "牡丹皮,山药",
              "support": "0.012504341785342132",
              "target": "熟地黄"
            },
            {
              "coverage": "0.015630427231677665",
              "confidence": "0.8",
              "count": 36,
              "lift": "10.96761904761905",
              "source": "茯苓,牡丹皮,山药",
              "support": "0.012504341785342132",
              "target": "熟地黄"
            },
            {
              "coverage": "0.026398054880166725",
              "confidence": "0.7894736842105263",
              "count": 60,
              "lift": "12.914174641148326",
              "source": "猪苓",
              "support": "0.02084056964223689",
              "target": "泽泻"
            },
            {
              "coverage": "0.013199027440083362",
              "confidence": "0.7894736842105263",
              "count": 30,
              "lift": "3.1788737578211266",
              "source": "附子,干姜",
              "support": "0.010420284821118444",
              "target": "人参"
            },
            {
              "coverage": "0.021187912469607502",
              "confidence": "0.7868852459016393",
              "count": 48,
              "lift": "6.742388758782201",
              "source": "麦冬,炙甘草",
              "support": "0.01667245571378951",
              "target": "地黄"
            },
            {
              "coverage": "0.021187912469607502",
              "confidence": "0.7868852459016393",
              "count": 48,
              "lift": "10.944167260631978",
              "source": "麦冬,炙甘草",
              "support": "0.01667245571378951",
              "target": "阿胶"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7857142857142857",
              "count": 33,
              "lift": "25.705357142857142",
              "source": "熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "山萸肉"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7857142857142857",
              "count": 33,
              "lift": "25.705357142857142",
              "source": "茯苓,牡丹皮,熟地黄",
              "support": "0.011462313303230288",
              "target": "山萸肉"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7857142857142857",
              "count": 33,
              "lift": "25.705357142857142",
              "source": "茯苓,熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "山萸肉"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7857142857142857",
              "count": 33,
              "lift": "25.705357142857142",
              "source": "牡丹皮,熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "山萸肉"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7857142857142857",
              "count": 33,
              "lift": "25.705357142857142",
              "source": "茯苓,牡丹皮,熟地黄,泽泻",
              "support": "0.011462313303230288",
              "target": "山萸肉"
            },
            {
              "coverage": "0.017714484195901353",
              "confidence": "0.7843137254901961",
              "count": 40,
              "lift": "2.304121648659464",
              "source": "鹿角霜",
              "support": "0.013893713094824591",
              "target": "茯苓"
            },
            {
              "coverage": "0.01597777005904828",
              "confidence": "0.782608695652174",
              "count": 36,
              "lift": "19.592438563327036",
              "source": "牡丹皮,熟地黄",
              "support": "0.012504341785342132",
              "target": "山药"
            },
            {
              "coverage": "0.014241055922195205",
              "confidence": "0.7804878048780488",
              "count": 32,
              "lift": "5.072289819963662",
              "source": "炒白芍,人参",
              "support": "0.011114970475859673",
              "target": "炙甘草"
            },
            {
              "coverage": "0.018756512678013197",
              "confidence": "0.7777777777777778",
              "count": 42,
              "lift": "10.662962962962963",
              "source": "茯苓,牡丹皮,泽泻",
              "support": "0.014588398749565822",
              "target": "熟地黄"
            },
            {
              "coverage": "0.013893713094824593",
              "confidence": "0.775",
              "count": 31,
              "lift": "5.82565274151436",
              "source": "饴糖",
              "support": "0.01076762764848906",
              "target": "白芍"
            },
            {
              "coverage": "0.015283084404307052",
              "confidence": "0.7727272727272727",
              "count": 34,
              "lift": "30.898358585858585",
              "source": "莲子,五味子",
              "support": "0.011809656130600903",
              "target": "芡实"
            },
            {
              "coverage": "0.013546370267453976",
              "confidence": "0.7692307692307693",
              "count": 30,
              "lift": "26.682113067655237",
              "source": "茯神,芡实",
              "support": "0.010420284821118444",
              "target": "莲子"
            },
            {
              "coverage": "0.014935741576936435",
              "confidence": "0.7674418604651163",
              "count": 33,
              "lift": "7.414312470735133",
              "source": "瓜蒌皮,郁金",
              "support": "0.011462313303230288",
              "target": "杏仁"
            },
            {
              "coverage": "0.017714484195901357",
              "confidence": "0.7647058823529411",
              "count": 39,
              "lift": "6.55234593837535",
              "source": "阿胶,人参",
              "support": "0.013546370267453978",
              "target": "地黄"
            },
            {
              "coverage": "0.017714484195901357",
              "confidence": "0.7647058823529411",
              "count": 39,
              "lift": "19.144245524296675",
              "source": "茯苓,山萸肉,熟地黄",
              "support": "0.013546370267453978",
              "target": "山药"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7619047619047619",
              "count": 32,
              "lift": "2.238289601554907",
              "source": "白术,厚朴",
              "support": "0.011114970475859673",
              "target": "茯苓"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7619047619047619",
              "count": 32,
              "lift": "6.395113147299735",
              "source": "黄连,生姜汁",
              "support": "0.011114970475859673",
              "target": "半夏"
            },
            {
              "coverage": "0.014588398749565822",
              "confidence": "0.7619047619047619",
              "count": 32,
              "lift": "13.213998852553066",
              "source": "大枣,人参,炙甘草",
              "support": "0.011114970475859673",
              "target": "生姜"
            },
            {
              "coverage": "0.020145883987495658",
              "confidence": "0.7586206896551724",
              "count": 44,
              "lift": "18.99190404797601",
              "source": "牡丹皮,泽泻",
              "support": "0.01528308440430705",
              "target": "山药"
            },
            {
              "coverage": "0.015630427231677665",
              "confidence": "0.7555555555555555",
              "count": 34,
              "lift": "2.2196371882086168",
              "source": "肉苁蓉",
              "support": "0.011809656130600903",
              "target": "茯苓"
            },
            {
              "coverage": "0.02674539770753734",
              "confidence": "0.7532467532467533",
              "count": 58,
              "lift": "6.454158936301794",
              "source": "阿胶,白芍",
              "support": "0.020145883987495658",
              "target": "地黄"
            },
            {
              "coverage": "0.01528308440430705",
              "confidence": "0.75",
              "count": 33,
              "lift": "10.282142857142857",
              "source": "莲子,五味子",
              "support": "0.011462313303230288",
              "target": "熟地黄"
            },
            {
              "coverage": "0.01667245571378951",
              "confidence": "0.75",
              "count": 36,
              "lift": "29.989583333333332",
              "source": "莲子,熟地黄",
              "support": "0.012504341785342132",
              "target": "芡实"
            },
            {
              "coverage": "0.014935741576936435",
              "confidence": "0.7441860465116279",
              "count": 32,
              "lift": "2.996519759310457",
              "source": "炒白芍,炙甘草",
              "support": "0.011114970475859673",
              "target": "人参"
            },
            {
              "coverage": "0.0187565126780132",
              "confidence": "0.7407407407407407",
              "count": 40,
              "lift": "18.544283413848632",
              "source": "茯苓,山萸肉",
              "support": "0.013893713094824591",
              "target": "山药"
            },
            {
              "coverage": "0.01736714136853074",
              "confidence": "0.74",
              "count": 37,
              "lift": "2.173938775510204",
              "source": "半夏,桂枝",
              "support": "0.012851684612712747",
              "target": "茯苓"
            },
            {
              "coverage": "0.015977770059048282",
              "confidence": "0.7391304347826086",
              "count": 34,
              "lift": "24.181324110671937",
              "source": "牡丹皮,熟地黄",
              "support": "0.011809656130600903",
              "target": "山萸肉"
            },
            {
              "coverage": "0.018409169850642587",
              "confidence": "0.7358490566037735",
              "count": 39,
              "lift": "2.1617443203696576",
              "source": "山药,山萸肉,熟地黄",
              "support": "0.013546370267453978",
              "target": "茯苓"
            },
            {
              "coverage": "0.02744008336227857",
              "confidence": "0.7341772151898734",
              "count": 58,
              "lift": "10.21109276585336",
              "source": "白芍,地黄",
              "support": "0.020145883987495658",
              "target": "阿胶"
            },
            {
              "coverage": "0.015630427231677665",
              "confidence": "0.7333333333333333",
              "count": 33,
              "lift": "4.765838976674191",
              "source": "当归,黄芪",
              "support": "0.011462313303230288",
              "target": "炙甘草"
            },
            {
              "coverage": "0.015630427231677665",
              "confidence": "0.7333333333333333",
              "count": 33,
              "lift": "6.283531746031746",
              "source": "阿胶,牡蛎",
              "support": "0.011462313303230288",
              "target": "地黄"
            },
            {
              "coverage": "0.014241055922195208",
              "confidence": "0.7317073170731707",
              "count": 30,
              "lift": "2.1495769039323047",
              "source": "白术,生姜",
              "support": "0.010420284821118444",
              "target": "茯苓"
            },
            {
              "coverage": "0.01528308440430705",
              "confidence": "0.7272727272727273",
              "count": 32,
              "lift": "10.314375279892522",
              "source": "芡实,熟地黄",
              "support": "0.011114970475859673",
              "target": "五味子"
            },
            {
              "coverage": "0.017714484195901353",
              "confidence": "0.7254901960784313",
              "count": 37,
              "lift": "2.131312525010004",
              "source": "厚朴,泽泻",
              "support": "0.012851684612712747",
              "target": "茯苓"
            },
            {
              "coverage": "0.013893713094824593",
              "confidence": "0.725",
              "count": 29,
              "lift": "2.129872448979592",
              "source": "白术,陈皮,炙甘草",
              "support": "0.010072941993747829",
              "target": "茯苓"
            },
            {
              "coverage": "0.020145883987495658",
              "confidence": "0.7241379310344828",
              "count": 42,
              "lift": "9.927586206896551",
              "source": "牡丹皮,泽泻",
              "support": "0.014588398749565822",
              "target": "熟地黄"
            },
            {
              "coverage": "0.016325112886418896",
              "confidence": "0.723404255319149",
              "count": 34,
              "lift": "25.09254037426301",
              "source": "芡实,五味子",
              "support": "0.011809656130600903",
              "target": "莲子"
            },
            {
              "coverage": "0.014935741576936439",
              "confidence": "0.7209302325581395",
              "count": 31,
              "lift": "6.177256367663344",
              "source": "白芍,麦冬",
              "support": "0.01076762764848906",
              "target": "地黄"
            },
            {
              "coverage": "0.014935741576936439",
              "confidence": "0.7209302325581395",
              "count": 31,
              "lift": "10.026850915627456",
              "source": "白芍,麦冬",
              "support": "0.01076762764848906",
              "target": "阿胶"
            },
            {
              "coverage": "0.019451198332754428",
              "confidence": "0.7142857142857143",
              "count": 40,
              "lift": "2.098396501457726",
              "source": "山药,山萸肉",
              "support": "0.013893713094824591",
              "target": "茯苓"
            },
            {
              "coverage": "0.032302882945467175",
              "confidence": "0.7096774193548387",
              "count": 66,
              "lift": "2.8575682382134",
              "source": "陈皮,炙甘草",
              "support": "0.022924626606460576",
              "target": "人参"
            },
            {
              "coverage": "0.019103855505383814",
              "confidence": "0.7090909090909091",
              "count": 39,
              "lift": "23.198553719008263",
              "source": "茯苓,山药,熟地黄",
              "support": "0.013546370267453978",
              "target": "山萸肉"
            },
            {
              "coverage": "0.02500868357068426",
              "confidence": "0.7083333333333334",
              "count": 51,
              "lift": "24.569779116465863",
              "source": "芡实",
              "support": "0.017714484195901353",
              "target": "莲子"
            },
            {
              "coverage": "0.01667245571378951",
              "confidence": "0.7083333333333334",
              "count": 34,
              "lift": "4.60336719337848",
              "source": "南枣,人参",
              "support": "0.011809656130600903",
              "target": "炙甘草"
            },
            {
              "coverage": "0.014241055922195208",
              "confidence": "0.7073170731707317",
              "count": 29,
              "lift": "12.193807506937345",
              "source": "薄荷",
              "support": "0.010072941993747829",
              "target": "连翘"
            },
            {
              "coverage": "0.014241055922195208",
              "confidence": "0.7073170731707317",
              "count": 29,
              "lift": "8.8154365959244",
              "source": "陈皮,泽泻",
              "support": "0.010072941993747829",
              "target": "厚朴"
            },
            {
              "coverage": "0.031955540118096565",
              "confidence": "0.7065217391304348",
              "count": 65,
              "lift": "5.93025098238053",
              "source": "茯苓,生姜汁",
              "support": "0.022577283779089963",
              "target": "半夏"
            },
            {
              "coverage": "0.017714484195901353",
              "confidence": "0.7058823529411765",
              "count": 36,
              "lift": "9.677310924369749",
              "source": "莲子,芡实",
              "support": "0.012504341785342132",
              "target": "熟地黄"
            },
            {
              "coverage": "0.034039597082320246",
              "confidence": "0.7040816326530612",
              "count": 69,
              "lift": "2.0684194085797585",
              "source": "白术,人参",
              "support": "0.02396665508857242",
              "target": "茯苓"
            },
            {
              "coverage": "0.016325112886418896",
              "confidence": "0.7021276595744681",
              "count": 33,
              "lift": "6.016147416413373",
              "source": "丹参",
              "support": "0.011462313303230288",
              "target": "地黄"
            },
            {
              "coverage": "0.016325112886418896",
              "confidence": "0.7021276595744681",
              "count": 33,
              "lift": "5.89336889771106",
              "source": "人参,生姜汁",
              "support": "0.011462313303230288",
              "target": "半夏"
            },
            {
              "coverage": "0.017367141368530743",
              "confidence": "0.7",
              "count": 35,
              "lift": "5.261879895561358",
              "source": "大枣,桂枝,炙甘草",
              "support": "0.012156998957971519",
              "target": "白芍"
            },
            {
              "coverage": "0.021882598124348732",
              "confidence": "0.6984126984126984",
              "count": 44,
              "lift": "4.5388942634992295",
              "source": "阿胶,地黄,麦冬",
              "support": "0.01528308440430705",
              "target": "炙甘草"
            },
            {
              "coverage": "0.018409169850642584",
              "confidence": "0.6981132075471698",
              "count": 37,
              "lift": "2.811004090249373",
              "source": "陈皮,茯苓,炙甘草",
              "support": "0.012851684612712747",
              "target": "人参"
            },
            {
              "coverage": "0.02744008336227857",
              "confidence": "0.6962025316455697",
              "count": 55,
              "lift": "9.544605183845691",
              "source": "茯苓,山药",
              "support": "0.019103855505383814",
              "target": "熟地黄"
            },
            {
              "coverage": "0.07189996526571726",
              "confidence": "0.6956521739130435",
              "count": 144,
              "lift": "5.960662525879917",
              "source": "阿胶",
              "support": "0.05001736714136853",
              "target": "地黄"
            },
            {
              "coverage": "0.0399444251476207",
              "confidence": "0.6956521739130435",
              "count": 80,
              "lift": "9.537060041407866",
              "source": "山药",
              "support": "0.027787426189649182",
              "target": "熟地黄"
            },
            {
              "coverage": "0.02049322681486627",
              "confidence": "0.6949152542372882",
              "count": 41,
              "lift": "5.223658007700137",
              "source": "大枣,桂枝",
              "support": "0.014241055922195206",
              "target": "白芍"
            },
            {
              "coverage": "0.01806182702327197",
              "confidence": "0.6923076923076923",
              "count": 36,
              "lift": "9.491208791208791",
              "source": "人参,枳实",
              "support": "0.012504341785342132",
              "target": "黄连"
            },
            {
              "coverage": "0.03160819729072595",
              "confidence": "0.6923076923076923",
              "count": 63,
              "lift": "4.499218614342768",
              "source": "白芍,桂枝",
              "support": "0.021882598124348732",
              "target": "炙甘草"
            },
            {
              "coverage": "0.023619312261201807",
              "confidence": "0.6911764705882353",
              "count": 47,
              "lift": "2.0305072028811524",
              "source": "吴茱萸",
              "support": "0.016325112886418896",
              "target": "茯苓"
            },
            {
              "coverage": "0.05800625217089267",
              "confidence": "0.688622754491018",
              "count": 115,
              "lift": "5.780014315392538",
              "source": "生姜汁",
              "support": "0.0399444251476207",
              "target": "半夏"
            },
            {
              "coverage": "0.027787426189649186",
              "confidence": "0.6875",
              "count": 55,
              "lift": "2.0197066326530613",
              "source": "山药,熟地黄",
              "support": "0.019103855505383814",
              "target": "茯苓"
            },
            {
              "coverage": "0.01667245571378951",
              "confidence": "0.6875",
              "count": 33,
              "lift": "9.750307881773399",
              "source": "莲子,熟地黄",
              "support": "0.011462313303230288",
              "target": "五味子"
            },
            {
              "coverage": "0.0399444251476207",
              "confidence": "0.6869565217391305",
              "count": 79,
              "lift": "2.0181100266193432",
              "source": "山药",
              "support": "0.02744008336227857",
              "target": "茯苓"
            },
            {
              "coverage": "0.021882598124348732",
              "confidence": "0.6825396825396826",
              "count": 43,
              "lift": "4.435737575692429",
              "source": "炒白芍",
              "support": "0.014935741576936437",
              "target": "炙甘草"
            },
            {
              "coverage": "0.03160819729072595",
              "confidence": "0.6813186813186813",
              "count": 62,
              "lift": "2.743379697225851",
              "source": "白术,炙甘草",
              "support": "0.02153525529697812",
              "target": "人参"
            },
            {
              "coverage": "0.016325112886418896",
              "confidence": "0.6808510638297872",
              "count": 32,
              "lift": "9.334143870314083",
              "source": "芡实,五味子",
              "support": "0.011114970475859673",
              "target": "熟地黄"
            },
            {
              "coverage": "0.08891976380687738",
              "confidence": "0.6796875",
              "count": 174,
              "lift": "1.9967554209183673",
              "source": "白术",
              "support": "0.060437651962486974",
              "target": "茯苓"
            },
            {
              "coverage": "0.04967002431399792",
              "confidence": "0.6783216783216783",
              "count": 97,
              "lift": "4.40832530900251",
              "source": "大枣",
              "support": "0.033692254254949636",
              "target": "炙甘草"
            },
            {
              "coverage": "0.029871483153872874",
              "confidence": "0.6744186046511628",
              "count": 58,
              "lift": "2.7155960318751013",
              "source": "茯神,炙甘草",
              "support": "0.020145883987495658",
              "target": "人参"
            },
            {
              "coverage": "0.01806182702327197",
              "confidence": "0.6730769230769231",
              "count": 35,
              "lift": "18.632581360946748",
              "source": "延胡",
              "support": "0.012156998957971519",
              "target": "川楝子"
            },
            {
              "coverage": "0.02535602639805488",
              "confidence": "0.6712328767123288",
              "count": 49,
              "lift": "9.519603212092584",
              "source": "茯神,熟地黄",
              "support": "0.017019798541160126",
              "target": "五味子"
            },
            {
              "coverage": "0.02744008336227857",
              "confidence": "0.6708860759493671",
              "count": 53,
              "lift": "16.795487066593285",
              "source": "山萸肉,熟地黄",
              "support": "0.018409169850642584",
              "target": "山药"
            },
            {
              "coverage": "0.022924626606460576",
              "confidence": "0.6666666666666666",
              "count": 44,
              "lift": "5.661750245821042",
              "source": "苍术",
              "support": "0.01528308440430705",
              "target": "陈皮"
            },
            {
              "coverage": "0.017714484195901357",
              "confidence": "0.6666666666666666",
              "count": 34,
              "lift": "9.454844006568145",
              "source": "莲子,芡实",
              "support": "0.011809656130600903",
              "target": "五味子"
            },
            {
              "coverage": "0.02084056964223689",
              "confidence": "0.6666666666666666",
              "count": 40,
              "lift": "2.684382284382284",
              "source": "白术,茯苓,炙甘草",
              "support": "0.013893713094824591",
              "target": "人参"
            },
            {
              "coverage": "0.027787426189649182",
              "confidence": "0.6625",
              "count": 53,
              "lift": "21.67428977272727",
              "source": "山药,熟地黄",
              "support": "0.018409169850642584",
              "target": "山萸肉"
            },
            {
              "coverage": "0.0163251128864189",
              "confidence": "0.6595744680851063",
              "count": 31,
              "lift": "6.372197629587319",
              "source": "豆蔻",
              "support": "0.01076762764848906",
              "target": "杏仁"
            },
            {
              "coverage": "0.0163251128864189",
              "confidence": "0.6595744680851063",
              "count": 31,
              "lift": "1.9376682587928786",
              "source": "人参,生姜汁",
              "support": "0.01076762764848906",
              "target": "茯苓"
            },
            {
              "coverage": "0.03160819729072595",
              "confidence": "0.6593406593406593",
              "count": 60,
              "lift": "1.9369813859609777",
              "source": "白术,炙甘草",
              "support": "0.02084056964223689",
              "target": "茯苓"
            },
            {
              "coverage": "0.042375824939215004",
              "confidence": "0.6557377049180327",
              "count": 80,
              "lift": "5.618657298985168",
              "source": "天冬",
              "support": "0.027787426189649182",
              "target": "地黄"
            },
            {
              "coverage": "0.03021882598124349",
              "confidence": "0.6551724137931034",
              "count": 57,
              "lift": "5.613813628899836",
              "source": "玄参",
              "support": "0.019798541160125045",
              "target": "地黄"
            },
            {
              "coverage": "0.019103855505383814",
              "confidence": "0.6545454545454545",
              "count": 36,
              "lift": "8.684038542103059",
              "source": "茯苓,山药,熟地黄",
              "support": "0.012504341785342132",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.019103855505383814",
              "confidence": "0.6545454545454545",
              "count": 36,
              "lift": "10.70702479338843",
              "source": "茯苓,山药,熟地黄",
              "support": "0.012504341785342132",
              "target": "泽泻"
            },
            {
              "coverage": "0.01806182702327197",
              "confidence": "0.6538461538461539",
              "count": 34,
              "lift": "2.6327595481441635",
              "source": "煨姜",
              "support": "0.011809656130600903",
              "target": "人参"
            },
            {
              "coverage": "0.03612365404654394",
              "confidence": "0.6538461538461539",
              "count": 68,
              "lift": "4.2492620246570585",
              "source": "南枣",
              "support": "0.023619312261201807",
              "target": "炙甘草"
            },
            {
              "coverage": "0.01806182702327197",
              "confidence": "0.6538461538461539",
              "count": 34,
              "lift": "2.6327595481441635",
              "source": "干姜,黄连",
              "support": "0.011809656130600903",
              "target": "人参"
            },
            {
              "coverage": "0.025008683570684264",
              "confidence": "0.6527777777777778",
              "count": 47,
              "lift": "9.25786808976464",
              "source": "芡实",
              "support": "0.016325112886418896",
              "target": "五味子"
            },
            {
              "coverage": "0.015977770059048282",
              "confidence": "0.6521739130434783",
              "count": 30,
              "lift": "5.588121118012422",
              "source": "竹叶心",
              "support": "0.010420284821118444",
              "target": "地黄"
            },
            {
              "coverage": "0.015977770059048282",
              "confidence": "0.6521739130434783",
              "count": 30,
              "lift": "26.07789855072464",
              "source": "茯神,莲子",
              "support": "0.010420284821118444",
              "target": "芡实"
            },
            {
              "coverage": "0.021882598124348732",
              "confidence": "0.6507936507936508",
              "count": 41,
              "lift": "2.6204684204684208",
              "source": "炒白芍",
              "support": "0.014241055922195206",
              "target": "人参"
            },
            {
              "coverage": "0.04828065300451546",
              "confidence": "0.6474820143884892",
              "count": 90,
              "lift": "1.9021435912494493",
              "source": "陈皮,人参",
              "support": "0.03126085446335533",
              "target": "茯苓"
            },
            {
              "coverage": "0.017714484195901353",
              "confidence": "0.6470588235294118",
              "count": 33,
              "lift": "4.205152038241933",
              "source": "黄芪,人参",
              "support": "0.011462313303230288",
              "target": "炙甘草"
            },
            {
              "coverage": "0.017714484195901353",
              "confidence": "0.6470588235294118",
              "count": 33,
              "lift": "8.58471130387639",
              "source": "茯苓,山萸肉,熟地黄",
              "support": "0.011462313303230288",
              "target": "牡丹皮"
            },
            {
              "coverage": "0.017714484195901353",
              "confidence": "0.6470588235294118",
              "count": 33,
              "lift": "10.584558823529413",
              "source": "茯苓,山萸肉,熟地黄",
              "support": "0.011462313303230288",
              "target": "泽泻"
            },
            {
              "coverage": "0.02257728377908996",
              "confidence": "0.6461538461538462",
              "count": 42,
              "lift": "4.199270706719917",
              "source": "大枣,人参",
              "support": "0.014588398749565822",
              "target": "炙甘草"
            },
            {
              "coverage": "0.027440083362278565",
              "confidence": "0.6455696202531646",
              "count": 51,
              "lift": "1.8965254456212866",
              "source": "山萸肉,熟地黄",
              "support": "0.017714484195901353",
              "target": "茯苓"
            },
            {
              "coverage": "0.021535255296978115",
              "confidence": "0.6451612903225806",
              "count": 40,
              "lift": "1.8953258722843975",
              "source": "白术,人参,炙甘草",
              "support": "0.013893713094824591",
              "target": "茯苓"
            },
            {
              "coverage": "0.019451198332754428",
              "confidence": "0.6428571428571429",
              "count": 36,
              "lift": "5.508290816326531",
              "source": "茯神,天冬",
              "support": "0.012504341785342132",
              "target": "地黄"
            },
            {
              "coverage": "0.0305661688086141",
              "confidence": "0.6363636363636364",
              "count": 56,
              "lift": "15.931225296442687",
              "source": "山萸肉",
              "support": "0.019451198332754428",
              "target": "山药"
            }
        ],
    },
    zzzf:{
        zf:[
            {
              "f1": 0,
              "keyName": "通阳",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.38%",
              "valueName": "12"
            },
            {
              "f1": 0,
              "keyName": "甘缓",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.26%",
              "valueName": "8"
            },
            {
              "f1": 0,
              "keyName": "宣通",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.22%",
              "valueName": "7"
            },
            {
              "f1": 0,
              "keyName": "酸苦泄热",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.22%",
              "valueName": "7"
            },
            {
              "f1": 0,
              "keyName": "苦辛泄降",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.19%",
              "valueName": "6"
            },
            {
              "f1": 0,
              "keyName": "温药和之",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.16%",
              "valueName": "5"
            },
            {
              "f1": 0,
              "keyName": "缓攻",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.16%",
              "valueName": "5"
            },
            {
              "f1": 0,
              "keyName": "开太阳",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.13%",
              "valueName": "4"
            },
            {
              "f1": 0,
              "keyName": "通络",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.13%",
              "valueName": "4"
            },
            {
              "f1": 0,
              "keyName": "通补",
              "maxValue": 0,
              "minValue": 0,
              "percentage": "0.13%",
              "valueName": "4"
            }
          ],
          zy_zfst:{
            "edges": [
              {
                "weight": 3,
                "source": "通阳",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 2,
                "source": "建中",
                "value": 0,
                "target": "桂枝"
              },
              {
                "weight": 2,
                "source": "升阳散郁",
                "value": 0,
                "target": "白芍"
              },
              {
                "weight": 2,
                "source": "清暑益气",
                "value": 0,
                "target": "青皮"
              },
              {
                "weight": 2,
                "source": "酸苦泄热",
                "value": 0,
                "target": "黄芩"
              },
              {
                "weight": 2,
                "source": "固卫阳",
                "value": 0,
                "target": "黄芪"
              },
              {
                "weight": 3,
                "source": "宣通",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 3,
                "source": "清暑益气",
                "value": 0,
                "target": "黄连"
              },
              {
                "weight": 3,
                "source": "通阳",
                "value": 0,
                "target": "生姜汁"
              },
              {
                "weight": 2,
                "source": "补土泄木",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 3,
                "source": "补太阴",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 2,
                "source": "敛补",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 4,
                "source": "温药和之",
                "value": 0,
                "target": "白术"
              },
              {
                "weight": 3,
                "source": "补太阴",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 3,
                "source": "和阳熄风",
                "value": 0,
                "target": "地黄"
              },
              {
                "weight": 2,
                "source": "补托",
                "value": 0,
                "target": "当归身"
              },
              {
                "weight": 4,
                "source": "养胃阴",
                "value": 0,
                "target": "麦冬"
              },
              {
                "weight": 2,
                "source": "兼以敛摄",
                "value": 0,
                "target": "黄芪"
              },
              {
                "weight": 3,
                "source": "清暑益气",
                "value": 0,
                "target": "麦冬"
              },
              {
                "weight": 2,
                "source": "泄木安土",
                "value": 0,
                "target": "青皮"
              },
              {
                "weight": 2,
                "source": "扶正气",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 3,
                "source": "苦辛泄降",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 2,
                "source": "温通",
                "value": 0,
                "target": "厚朴"
              },
              {
                "weight": 3,
                "source": "通补",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 3,
                "source": "益气",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 2,
                "source": "镇补",
                "value": 0,
                "target": "白芍"
              },
              {
                "weight": 4,
                "source": "通阳",
                "value": 0,
                "target": "附子"
              },
              {
                "weight": 2,
                "source": "芳香逐秽",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 3,
                "source": "填补下焦",
                "value": 0,
                "target": "熟地黄"
              },
              {
                "weight": 4,
                "source": "温药和之",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 3,
                "source": "和中",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 2,
                "source": "苦味坚阴",
                "value": 0,
                "target": "泽泻"
              },
              {
                "weight": 5,
                "source": "通阳",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 2,
                "source": "敛补",
                "value": 0,
                "target": "茯神"
              },
              {
                "weight": 7,
                "source": "酸苦泄热",
                "value": 0,
                "target": "黄连"
              },
              {
                "weight": 3,
                "source": "升阳法",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 3,
                "source": "辛甘化风",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 2,
                "source": "暮服清肃上焦方法",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 4,
                "source": "酸苦泄热",
                "value": 0,
                "target": "乌梅"
              },
              {
                "weight": 4,
                "source": "开太阳",
                "value": 0,
                "target": "泽泻"
              },
              {
                "weight": 3,
                "source": "益气",
                "value": 0,
                "target": "黄芪"
              },
              {
                "weight": 5,
                "source": "酸苦泄热",
                "value": 0,
                "target": "白芍"
              },
              {
                "weight": 3,
                "source": "开太阳",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 2,
                "source": "辛甘理阳",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 2,
                "source": "开太阳",
                "value": 0,
                "target": "牡蛎"
              },
              {
                "weight": 3,
                "source": "通补",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 3,
                "source": "培土制木",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 2,
                "source": "苦辛寒",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 3,
                "source": "泻心法",
                "value": 0,
                "target": "枳实"
              },
              {
                "weight": 3,
                "source": "养胃阴",
                "value": 0,
                "target": "甘草"
              },
              {
                "weight": 2,
                "source": "敛补",
                "value": 0,
                "target": "山萸肉炭"
              },
              {
                "weight": 2,
                "source": "镇补",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 2,
                "source": "肝用宜泄",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 2,
                "source": "镇阳熄风",
                "value": 0,
                "target": "地黄"
              },
              {
                "weight": 4,
                "source": "通阳",
                "value": 0,
                "target": "白芍"
              },
              {
                "weight": 3,
                "source": "治中法",
                "value": 0,
                "target": "木瓜"
              },
              {
                "weight": 2,
                "source": "升阳法",
                "value": 0,
                "target": "当归"
              },
              {
                "weight": 3,
                "source": "开太阳",
                "value": 0,
                "target": "猪苓"
              },
              {
                "weight": 3,
                "source": "泄少阳",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 3,
                "source": "通阳",
                "value": 0,
                "target": "干姜"
              },
              {
                "weight": 3,
                "source": "治中法",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 3,
                "source": "辛甘理阳",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 3,
                "source": "分消",
                "value": 0,
                "target": "猪苓"
              },
              {
                "weight": 4,
                "source": "宣通",
                "value": 0,
                "target": "厚朴"
              },
              {
                "weight": 3,
                "source": "清暑益气",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 2,
                "source": "摄固",
                "value": 0,
                "target": "熟地黄炭"
              },
              {
                "weight": 3,
                "source": "升阳法",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 3,
                "source": "甘缓",
                "value": 0,
                "target": "北沙参"
              },
              {
                "weight": 2,
                "source": "补托",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 4,
                "source": "通阳",
                "value": 0,
                "target": "桂枝"
              },
              {
                "weight": 2,
                "source": "补脾少佐疏胃",
                "value": 0,
                "target": "五味子"
              },
              {
                "weight": 3,
                "source": "辛以通之",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 3,
                "source": "培土制木",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 2,
                "source": "升阳散郁",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 4,
                "source": "泻心法",
                "value": 0,
                "target": "黄连"
              },
              {
                "weight": 2,
                "source": "通补阳明厥阴",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 9,
                "source": "通阳",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 4,
                "source": "苦辛泄降",
                "value": 0,
                "target": "黄连"
              },
              {
                "weight": 2,
                "source": "补土泄木",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 2,
                "source": "温药和之",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 2,
                "source": "疏补",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 3,
                "source": "辛甘化风",
                "value": 0,
                "target": "桂枝"
              },
              {
                "weight": 2,
                "source": "导湿分消",
                "value": 0,
                "target": "猪苓"
              },
              {
                "weight": 2,
                "source": "治中法",
                "value": 0,
                "target": "益智"
              },
              {
                "weight": 4,
                "source": "甘缓",
                "value": 0,
                "target": "甘草"
              },
              {
                "weight": 2,
                "source": "和阳熄风",
                "value": 0,
                "target": "麦冬"
              },
              {
                "weight": 2,
                "source": "温养",
                "value": 0,
                "target": "鹿角霜"
              },
              {
                "weight": 3,
                "source": "宣通",
                "value": 0,
                "target": "桂枝"
              },
              {
                "weight": 4,
                "source": "酸苦泄热",
                "value": 0,
                "target": "枳实"
              },
              {
                "weight": 4,
                "source": "益气",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 3,
                "source": "甘缓",
                "value": 0,
                "target": "大枣"
              },
              {
                "weight": 4,
                "source": "泻心法",
                "value": 0,
                "target": "黄芩"
              },
              {
                "weight": 3,
                "source": "补土泄木",
                "value": 0,
                "target": "牡丹皮"
              },
              {
                "weight": 3,
                "source": "开太阳",
                "value": 0,
                "target": "防己"
              },
              {
                "weight": 3,
                "source": "泄少阳",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 2,
                "source": "清上焦",
                "value": 0,
                "target": "滑石"
              },
              {
                "weight": 2,
                "source": "治肝肾",
                "value": 0,
                "target": "枸杞子"
              },
              {
                "weight": 3,
                "source": "通阳",
                "value": 0,
                "target": "白术"
              },
              {
                "weight": 2,
                "source": "摄纳",
                "value": 0,
                "target": "茯神"
              },
              {
                "weight": 2,
                "source": "芳香辟秽",
                "value": 0,
                "target": "厚朴"
              }
            ],
            "nodes": [
              {
                "degree": 0,
                "name": "通阳",
                "id": "通阳",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "人参",
                "id": "人参",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "建中",
                "id": "建中",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "桂枝",
                "id": "桂枝",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "升阳散郁",
                "id": "升阳散郁",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "白芍",
                "id": "白芍",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "清暑益气",
                "id": "清暑益气",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "青皮",
                "id": "青皮",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "酸苦泄热",
                "id": "酸苦泄热",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "黄芩",
                "id": "黄芩",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "固卫阳",
                "id": "固卫阳",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "黄芪",
                "id": "黄芪",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "宣通",
                "id": "宣通",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "茯苓",
                "id": "茯苓",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "黄连",
                "id": "黄连",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "生姜汁",
                "id": "生姜汁",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "补土泄木",
                "id": "补土泄木",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "陈皮",
                "id": "陈皮",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "补太阴",
                "id": "补太阴",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "敛补",
                "id": "敛补",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "温药和之",
                "id": "温药和之",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "白术",
                "id": "白术",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "和阳熄风",
                "id": "和阳熄风",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "地黄",
                "id": "地黄",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "补托",
                "id": "补托",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "当归身",
                "id": "当归身",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "养胃阴",
                "id": "养胃阴",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "麦冬",
                "id": "麦冬",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "兼以敛摄",
                "id": "兼以敛摄",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "泄木安土",
                "id": "泄木安土",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "扶正气",
                "id": "扶正气",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "苦辛泄降",
                "id": "苦辛泄降",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "半夏",
                "id": "半夏",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "温通",
                "id": "温通",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "厚朴",
                "id": "厚朴",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "通补",
                "id": "通补",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "益气",
                "id": "益气",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "镇补",
                "id": "镇补",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "附子",
                "id": "附子",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "芳香逐秽",
                "id": "芳香逐秽",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "填补下焦",
                "id": "填补下焦",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "熟地黄",
                "id": "熟地黄",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "和中",
                "id": "和中",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "苦味坚阴",
                "id": "苦味坚阴",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "泽泻",
                "id": "泽泻",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "茯神",
                "id": "茯神",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "升阳法",
                "id": "升阳法",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "炙甘草",
                "id": "炙甘草",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "辛甘化风",
                "id": "辛甘化风",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "暮服清肃上焦方法",
                "id": "暮服清肃上焦方法",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "乌梅",
                "id": "乌梅",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "开太阳",
                "id": "开太阳",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "辛甘理阳",
                "id": "辛甘理阳",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "牡蛎",
                "id": "牡蛎",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "培土制木",
                "id": "培土制木",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "苦辛寒",
                "id": "苦辛寒",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "泻心法",
                "id": "泻心法",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "枳实",
                "id": "枳实",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "甘草",
                "id": "甘草",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "山萸肉炭",
                "id": "山萸肉炭",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "肝用宜泄",
                "id": "肝用宜泄",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "镇阳熄风",
                "id": "镇阳熄风",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "治中法",
                "id": "治中法",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "木瓜",
                "id": "木瓜",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "当归",
                "id": "当归",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "猪苓",
                "id": "猪苓",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "泄少阳",
                "id": "泄少阳",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "干姜",
                "id": "干姜",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "分消",
                "id": "分消",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "摄固",
                "id": "摄固",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "熟地黄炭",
                "id": "熟地黄炭",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "甘缓",
                "id": "甘缓",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "北沙参",
                "id": "北沙参",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "补脾少佐疏胃",
                "id": "补脾少佐疏胃",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "五味子",
                "id": "五味子",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "辛以通之",
                "id": "辛以通之",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "通补阳明厥阴",
                "id": "通补阳明厥阴",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "疏补",
                "id": "疏补",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "导湿分消",
                "id": "导湿分消",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "益智",
                "id": "益智",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "温养",
                "id": "温养",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "鹿角霜",
                "id": "鹿角霜",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "大枣",
                "id": "大枣",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "牡丹皮",
                "id": "牡丹皮",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "防己",
                "id": "防己",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "清上焦",
                "id": "清上焦",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "滑石",
                "id": "滑石",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "治肝肾",
                "id": "治肝肾",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "枸杞子",
                "id": "枸杞子",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "摄纳",
                "id": "摄纳",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "芳香辟秽",
                "id": "芳香辟秽",
                "distance": 0,
                "group": "6"
              }
            ]
          },
          zyjb_zfst:{
            "edges": [
              {
                "weight": 2,
                "source": "痰饮",
                "value": 0,
                "target": "通阳"
              },
              {
                "weight": 1,
                "source": "咽喉",
                "value": 0,
                "target": "轻药"
              },
              {
                "weight": 1,
                "source": "吐血",
                "value": 0,
                "target": "辛苦急"
              },
              {
                "weight": 1,
                "source": "癫痫",
                "value": 0,
                "target": "理阴和阳"
              },
              {
                "weight": 1,
                "source": "肿胀",
                "value": 0,
                "target": "通腑以泄浊"
              },
              {
                "weight": 1,
                "source": "便血",
                "value": 0,
                "target": "阴药固摄"
              },
              {
                "weight": 1,
                "source": "脾胃",
                "value": 0,
                "target": "以通为补"
              },
              {
                "weight": 1,
                "source": "湿",
                "value": 0,
                "target": "温蒸阳气"
              },
              {
                "weight": 2,
                "source": "痹",
                "value": 0,
                "target": "宣通经脉"
              },
              {
                "weight": 2,
                "source": "目疾",
                "value": 0,
                "target": "治肝肾"
              },
              {
                "weight": 1,
                "source": "耳",
                "value": 0,
                "target": "辛凉轻药"
              },
              {
                "weight": 1,
                "source": "痉厥",
                "value": 0,
                "target": "育阴熄风"
              },
              {
                "weight": 2,
                "source": "咳嗽",
                "value": 0,
                "target": "甘缓"
              },
              {
                "weight": 1,
                "source": "寒",
                "value": 0,
                "target": "辛散"
              },
              {
                "weight": 1,
                "source": "胸痹",
                "value": 0,
                "target": "辛滑微通其阳"
              },
              {
                "weight": 1,
                "source": "温热",
                "value": 0,
                "target": "滋水制热"
              },
              {
                "weight": 1,
                "source": "痰饮",
                "value": 0,
                "target": "治在少阴"
              },
              {
                "weight": 1,
                "source": "呕吐",
                "value": 0,
                "target": "温上通阳"
              },
              {
                "weight": 1,
                "source": "疮疡",
                "value": 0,
                "target": "和血驱风"
              },
              {
                "weight": 1,
                "source": "吐血",
                "value": 0,
                "target": "下焦宜封宜固"
              },
              {
                "weight": 1,
                "source": "虚劳",
                "value": 0,
                "target": "佐酸味以敛之"
              },
              {
                "weight": 1,
                "source": "咳嗽",
                "value": 0,
                "target": "摄纳"
              },
              {
                "weight": 1,
                "source": "疟",
                "value": 0,
                "target": "甘凉养胃"
              },
              {
                "weight": 1,
                "source": "痹",
                "value": 0,
                "target": "迅疾飞走"
              },
              {
                "weight": 1,
                "source": "崩漏",
                "value": 0,
                "target": "坤土阳和旋转"
              },
              {
                "weight": 1,
                "source": "便血",
                "value": 0,
                "target": "治在营络"
              },
              {
                "weight": 1,
                "source": "产后",
                "value": 0,
                "target": "温煦阴中之阳"
              },
              {
                "weight": 1,
                "source": "呕吐",
                "value": 0,
                "target": "辛以通阳"
              },
              {
                "weight": 1,
                "source": "吐血",
                "value": 0,
                "target": "静养"
              },
              {
                "weight": 3,
                "source": "疟",
                "value": 0,
                "target": "通络"
              },
              {
                "weight": 1,
                "source": "痢",
                "value": 0,
                "target": "摄固肠中"
              },
              {
                "weight": 1,
                "source": "肿胀",
                "value": 0,
                "target": "泄木安土"
              },
              {
                "weight": 1,
                "source": "吐血",
                "value": 0,
                "target": "固阴和阳"
              },
              {
                "weight": 1,
                "source": "疟",
                "value": 0,
                "target": "和胃气"
              },
              {
                "weight": 1,
                "source": "泄泻",
                "value": 0,
                "target": "下宜封乃藏"
              },
              {
                "weight": 1,
                "source": "呕吐",
                "value": 0,
                "target": "泄浊阴"
              },
              {
                "weight": 1,
                "source": "便血",
                "value": 0,
                "target": "甘温宜加"
              },
              {
                "weight": 2,
                "source": "木乘土",
                "value": 0,
                "target": "苦辛泄降"
              },
              {
                "weight": 1,
                "source": "郁",
                "value": 0,
                "target": "清上"
              },
              {
                "weight": 1,
                "source": "吐泻",
                "value": 0,
                "target": "通胃阳"
              },
              {
                "weight": 1,
                "source": "胃脘痛",
                "value": 0,
                "target": "通胸中之阳"
              },
              {
                "weight": 1,
                "source": "产后",
                "value": 0,
                "target": "益阴配阳"
              },
              {
                "weight": 1,
                "source": "肿胀",
                "value": 0,
                "target": "开肺气壅遏"
              },
              {
                "weight": 1,
                "source": "腰腿足痛",
                "value": 0,
                "target": "治从肝经"
              },
              {
                "weight": 1,
                "source": "燥",
                "value": 0,
                "target": "甘寒清补胃阴"
              },
              {
                "weight": 1,
                "source": "木乘土",
                "value": 0,
                "target": "平肝和胃"
              },
              {
                "weight": 1,
                "source": "郁",
                "value": 0,
                "target": "宣通脉络"
              },
              {
                "weight": 1,
                "source": "虚劳",
                "value": 0,
                "target": "继当填下"
              },
              {
                "weight": 1,
                "source": "温热",
                "value": 0,
                "target": "芳香逐秽宣窍"
              },
              {
                "weight": 1,
                "source": "肿胀",
                "value": 0,
                "target": "暖水脏以通阳气"
              },
              {
                "weight": 1,
                "source": "诸痛",
                "value": 0,
                "target": "泻阴中伏热"
              },
              {
                "weight": 1,
                "source": "疟",
                "value": 0,
                "target": "滋其化源"
              },
              {
                "weight": 1,
                "source": "吐血",
                "value": 0,
                "target": "育阴和阳"
              },
              {
                "weight": 1,
                "source": "疝",
                "value": 0,
                "target": "反佐辛热"
              },
              {
                "weight": 3,
                "source": "暑",
                "value": 0,
                "target": "清暑益气"
              },
              {
                "weight": 1,
                "source": "虚劳",
                "value": 0,
                "target": "佐以益气"
              },
              {
                "weight": 1,
                "source": "痰饮",
                "value": 0,
                "target": "健补中阳"
              },
              {
                "weight": 1,
                "source": "淋浊",
                "value": 0,
                "target": "当分利"
              },
              {
                "weight": 1,
                "source": "泄泻",
                "value": 0,
                "target": "酸苦"
              },
              {
                "weight": 2,
                "source": "肿胀",
                "value": 0,
                "target": "开太阳"
              },
              {
                "weight": 1,
                "source": "便血",
                "value": 0,
                "target": "通补阳明"
              },
              {
                "weight": 1,
                "source": "呕吐",
                "value": 0,
                "target": "温胃阳"
              },
              {
                "weight": 1,
                "source": "便血",
                "value": 0,
                "target": "温养固下"
              },
              {
                "weight": 1,
                "source": "肠痹",
                "value": 0,
                "target": "辛润自上宣下法"
              },
              {
                "weight": 1,
                "source": "疝",
                "value": 0,
                "target": "柔苦制热"
              },
              {
                "weight": 1,
                "source": "便血",
                "value": 0,
                "target": "治在脾肾"
              },
              {
                "weight": 2,
                "source": "泄泻",
                "value": 0,
                "target": "治中法"
              },
              {
                "weight": 1,
                "source": "产后",
                "value": 0,
                "target": "急急护阳安胃"
              },
              {
                "weight": 1,
                "source": "淋浊",
                "value": 0,
                "target": "坚阴清热"
              },
              {
                "weight": 1,
                "source": "木乘土",
                "value": 0,
                "target": "寒凉清火"
              },
              {
                "weight": 1,
                "source": "呕吐",
                "value": 0,
                "target": "养金制木"
              },
              {
                "weight": 1,
                "source": "产后",
                "value": 0,
                "target": "酸甘化阴扶胃"
              },
              {
                "weight": 1,
                "source": "呕吐",
                "value": 0,
                "target": "辛以通之"
              },
              {
                "weight": 1,
                "source": "温热",
                "value": 0,
                "target": "滋清"
              },
              {
                "weight": 1,
                "source": "痹",
                "value": 0,
                "target": "和正祛邪"
              },
              {
                "weight": 2,
                "source": "温热",
                "value": 0,
                "target": "辛凉轻剂以宣通"
              },
              {
                "weight": 2,
                "source": "调经",
                "value": 0,
                "target": "宣通"
              },
              {
                "weight": 1,
                "source": "胎前",
                "value": 0,
                "target": "熄风和阳"
              },
              {
                "weight": 1,
                "source": "胃脘痛",
                "value": 0,
                "target": "淡味薄味清养"
              },
              {
                "weight": 1,
                "source": "湿",
                "value": 0,
                "target": "以通为法"
              },
              {
                "weight": 1,
                "source": "疟",
                "value": 0,
                "target": "再商治肾"
              },
              {
                "weight": 2,
                "source": "肿胀",
                "value": 0,
                "target": "缓攻"
              },
              {
                "weight": 2,
                "source": "木乘土",
                "value": 0,
                "target": "泄少阳"
              },
              {
                "weight": 2,
                "source": "疮疡",
                "value": 0,
                "target": "补托"
              },
              {
                "weight": 2,
                "source": "木乘土",
                "value": 0,
                "target": "培土制木"
              },
              {
                "weight": 2,
                "source": "虚劳",
                "value": 0,
                "target": "甘缓"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "益气"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "治手太阴"
              },
              {
                "weight": 2,
                "source": "肿胀",
                "value": 0,
                "target": "分消"
              },
              {
                "weight": 2,
                "source": "木乘土",
                "value": 0,
                "target": "补太阴"
              },
              {
                "weight": 2,
                "source": "木乘土",
                "value": 0,
                "target": "补土泄木"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "和胃生津"
              },
              {
                "weight": 2,
                "source": "肝风",
                "value": 0,
                "target": "和阳熄风"
              },
              {
                "weight": 4,
                "source": "痰饮",
                "value": 0,
                "target": "温药和之"
              },
              {
                "weight": 2,
                "source": "疟",
                "value": 0,
                "target": "升阳法"
              },
              {
                "weight": 2,
                "source": "产后",
                "value": 0,
                "target": "温养"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "养胃阴"
              },
              {
                "weight": 2,
                "source": "痢",
                "value": 0,
                "target": "宣通"
              },
              {
                "weight": 2,
                "source": "吐血",
                "value": 0,
                "target": "摄纳"
              },
              {
                "weight": 2,
                "source": "胸痹",
                "value": 0,
                "target": "温通阳气"
              }
            ],
            "nodes": [
              {
                "degree": 0,
                "name": "痰饮",
                "id": "痰饮",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "通阳",
                "id": "通阳",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "咽喉",
                "id": "咽喉",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "轻药",
                "id": "轻药",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "吐血",
                "id": "吐血",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "辛苦急",
                "id": "辛苦急",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "癫痫",
                "id": "癫痫",
                "distance": 0,
                "group": "33"
              },
              {
                "degree": 0,
                "name": "理阴和阳",
                "id": "理阴和阳",
                "distance": 0,
                "group": "33"
              },
              {
                "degree": 0,
                "name": "肿胀",
                "id": "肿胀",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "通腑以泄浊",
                "id": "通腑以泄浊",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "便血",
                "id": "便血",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "阴药固摄",
                "id": "阴药固摄",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "脾胃",
                "id": "脾胃",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "以通为补",
                "id": "以通为补",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "湿",
                "id": "湿",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "温蒸阳气",
                "id": "温蒸阳气",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "痹",
                "id": "痹",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "宣通经脉",
                "id": "宣通经脉",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "目疾",
                "id": "目疾",
                "distance": 0,
                "group": "34"
              },
              {
                "degree": 0,
                "name": "治肝肾",
                "id": "治肝肾",
                "distance": 0,
                "group": "34"
              },
              {
                "degree": 0,
                "name": "耳",
                "id": "耳",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "辛凉轻药",
                "id": "辛凉轻药",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "痉厥",
                "id": "痉厥",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "育阴熄风",
                "id": "育阴熄风",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "咳嗽",
                "id": "咳嗽",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "甘缓",
                "id": "甘缓",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "寒",
                "id": "寒",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "辛散",
                "id": "辛散",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "胸痹",
                "id": "胸痹",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "辛滑微通其阳",
                "id": "辛滑微通其阳",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "温热",
                "id": "温热",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "滋水制热",
                "id": "滋水制热",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "治在少阴",
                "id": "治在少阴",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "呕吐",
                "id": "呕吐",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "温上通阳",
                "id": "温上通阳",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "疮疡",
                "id": "疮疡",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "和血驱风",
                "id": "和血驱风",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "下焦宜封宜固",
                "id": "下焦宜封宜固",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "虚劳",
                "id": "虚劳",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "佐酸味以敛之",
                "id": "佐酸味以敛之",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "摄纳",
                "id": "摄纳",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "疟",
                "id": "疟",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "甘凉养胃",
                "id": "甘凉养胃",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "迅疾飞走",
                "id": "迅疾飞走",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "崩漏",
                "id": "崩漏",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "坤土阳和旋转",
                "id": "坤土阳和旋转",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "治在营络",
                "id": "治在营络",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "产后",
                "id": "产后",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "温煦阴中之阳",
                "id": "温煦阴中之阳",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "辛以通阳",
                "id": "辛以通阳",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "静养",
                "id": "静养",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "通络",
                "id": "通络",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "痢",
                "id": "痢",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "摄固肠中",
                "id": "摄固肠中",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "泄木安土",
                "id": "泄木安土",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "固阴和阳",
                "id": "固阴和阳",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "和胃气",
                "id": "和胃气",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "泄泻",
                "id": "泄泻",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "下宜封乃藏",
                "id": "下宜封乃藏",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "泄浊阴",
                "id": "泄浊阴",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "甘温宜加",
                "id": "甘温宜加",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "木乘土",
                "id": "木乘土",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "苦辛泄降",
                "id": "苦辛泄降",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "郁",
                "id": "郁",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "清上",
                "id": "清上",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "吐泻",
                "id": "吐泻",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "通胃阳",
                "id": "通胃阳",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "胃脘痛",
                "id": "胃脘痛",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "通胸中之阳",
                "id": "通胸中之阳",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "益阴配阳",
                "id": "益阴配阳",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "开肺气壅遏",
                "id": "开肺气壅遏",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "腰腿足痛",
                "id": "腰腿足痛",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "治从肝经",
                "id": "治从肝经",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "燥",
                "id": "燥",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "甘寒清补胃阴",
                "id": "甘寒清补胃阴",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "平肝和胃",
                "id": "平肝和胃",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "宣通脉络",
                "id": "宣通脉络",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "继当填下",
                "id": "继当填下",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "芳香逐秽宣窍",
                "id": "芳香逐秽宣窍",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "暖水脏以通阳气",
                "id": "暖水脏以通阳气",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "诸痛",
                "id": "诸痛",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "泻阴中伏热",
                "id": "泻阴中伏热",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "滋其化源",
                "id": "滋其化源",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "育阴和阳",
                "id": "育阴和阳",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "疝",
                "id": "疝",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "反佐辛热",
                "id": "反佐辛热",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "暑",
                "id": "暑",
                "distance": 0,
                "group": "36"
              },
              {
                "degree": 0,
                "name": "清暑益气",
                "id": "清暑益气",
                "distance": 0,
                "group": "36"
              },
              {
                "degree": 0,
                "name": "佐以益气",
                "id": "佐以益气",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "健补中阳",
                "id": "健补中阳",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "淋浊",
                "id": "淋浊",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "当分利",
                "id": "当分利",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "酸苦",
                "id": "酸苦",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "开太阳",
                "id": "开太阳",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "通补阳明",
                "id": "通补阳明",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "温胃阳",
                "id": "温胃阳",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "温养固下",
                "id": "温养固下",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "肠痹",
                "id": "肠痹",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "辛润自上宣下法",
                "id": "辛润自上宣下法",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "柔苦制热",
                "id": "柔苦制热",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "治在脾肾",
                "id": "治在脾肾",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "治中法",
                "id": "治中法",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "急急护阳安胃",
                "id": "急急护阳安胃",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "坚阴清热",
                "id": "坚阴清热",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "寒凉清火",
                "id": "寒凉清火",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "养金制木",
                "id": "养金制木",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "酸甘化阴扶胃",
                "id": "酸甘化阴扶胃",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "辛以通之",
                "id": "辛以通之",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "滋清",
                "id": "滋清",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "和正祛邪",
                "id": "和正祛邪",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "辛凉轻剂以宣通",
                "id": "辛凉轻剂以宣通",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "调经",
                "id": "调经",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "宣通",
                "id": "宣通",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "胎前",
                "id": "胎前",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "熄风和阳",
                "id": "熄风和阳",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "淡味薄味清养",
                "id": "淡味薄味清养",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "以通为法",
                "id": "以通为法",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "再商治肾",
                "id": "再商治肾",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "缓攻",
                "id": "缓攻",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "泄少阳",
                "id": "泄少阳",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "补托",
                "id": "补托",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "培土制木",
                "id": "培土制木",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "益气",
                "id": "益气",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "治手太阴",
                "id": "治手太阴",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "分消",
                "id": "分消",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "补太阴",
                "id": "补太阴",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "补土泄木",
                "id": "补土泄木",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "和胃生津",
                "id": "和胃生津",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "肝风",
                "id": "肝风",
                "distance": 0,
                "group": "35"
              },
              {
                "degree": 0,
                "name": "和阳熄风",
                "id": "和阳熄风",
                "distance": 0,
                "group": "35"
              },
              {
                "degree": 0,
                "name": "温药和之",
                "id": "温药和之",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "升阳法",
                "id": "升阳法",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "温养",
                "id": "温养",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "养胃阴",
                "id": "养胃阴",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "温通阳气",
                "id": "温通阳气",
                "distance": 0,
                "group": "14"
              }
            ]
          },
          zyjb_zygl:[
            {
              "coverage": "0.026466836734693876",
              "confidence": "0.7831325301204819",
              "count": 65,
              "lift": "2.5060240963855422",
              "source": "痰饮",
              "support": "0.02072704081632653",
              "target": "茯苓"
            },
            {
              "coverage": "0.02901785714285714",
              "confidence": "0.6263736263736264",
              "count": 57,
              "lift": "2.0043956043956044",
              "source": "泄泻",
              "support": "0.018176020408163265",
              "target": "茯苓"
            },
            {
              "coverage": "0.021364795918367343",
              "confidence": "0.5522388059701493",
              "count": 37,
              "lift": "1.7671641791044777",
              "source": "呕吐",
              "support": "0.011798469387755101",
              "target": "茯苓"
            },
            {
              "coverage": "0.022002551020408163",
              "confidence": "0.5217391304347826",
              "count": 36,
              "lift": "1.6695652173913043",
              "source": "木乘土",
              "support": "0.011479591836734694",
              "target": "茯苓"
            },
            {
              "coverage": "0.026466836734693876",
              "confidence": "0.5180722891566265",
              "count": 43,
              "lift": "4.628702845570316",
              "source": "痰饮",
              "support": "0.01371173469387755",
              "target": "桂枝"
            },
            {
              "coverage": "0.03284438775510204",
              "confidence": "0.4854368932038835",
              "count": 50,
              "lift": "1.5533980582524272",
              "source": "肿胀",
              "support": "0.01594387755102041",
              "target": "茯苓"
            },
            {
              "coverage": "0.02200255102040816",
              "confidence": "0.463768115942029",
              "count": 32,
              "lift": "2.034093442789095",
              "source": "木乘土",
              "support": "0.01020408163265306",
              "target": "人参"
            },
            {
              "coverage": "0.02901785714285714",
              "confidence": "0.46153846153846156",
              "count": 42,
              "lift": "4.269571136827774",
              "source": "泄泻",
              "support": "0.013392857142857142",
              "target": "陈皮"
            },
            {
              "coverage": "0.026466836734693876",
              "confidence": "0.42168674698795183",
              "count": 35,
              "lift": "3.8554216867469884",
              "source": "痰饮",
              "support": "0.011160714285714286",
              "target": "半夏"
            },
            {
              "coverage": "0.03858418367346939",
              "confidence": "0.4049586776859504",
              "count": 49,
              "lift": "1.2958677685950413",
              "source": "产后",
              "support": "0.015625",
              "target": "茯苓"
            },
            {
              "coverage": "0.035076530612244895",
              "confidence": "0.38181818181818183",
              "count": 42,
              "lift": "1.6746598855689767",
              "source": "痢",
              "support": "0.013392857142857142",
              "target": "人参"
            },
            {
              "coverage": "0.039540816326530615",
              "confidence": "0.3709677419354839",
              "count": 46,
              "lift": "1.6270697044890592",
              "source": "虚劳",
              "support": "0.014668367346938776",
              "target": "人参"
            },
            {
              "coverage": "0.039540816326530615",
              "confidence": "0.3629032258064516",
              "count": 45,
              "lift": "1.161290322580645",
              "source": "虚劳",
              "support": "0.014349489795918368",
              "target": "茯苓"
            },
            {
              "coverage": "0.035076530612244895",
              "confidence": "0.35454545454545455",
              "count": 39,
              "lift": "1.1345454545454547",
              "source": "痢",
              "support": "0.012436224489795918",
              "target": "茯苓"
            },
            {
              "coverage": "0.029017857142857137",
              "confidence": "0.3516483516483517",
              "count": 32,
              "lift": "1.542334588488435",
              "source": "泄泻",
              "support": "0.01020408163265306",
              "target": "人参"
            },
            {
              "coverage": "0.050063775510204085",
              "confidence": "0.31210191082802546",
              "count": 49,
              "lift": "3.284401316633181",
              "source": "咳嗽",
              "support": "0.015625",
              "target": "杏仁"
            },
            {
              "coverage": "0.03284438775510204",
              "confidence": "0.3106796116504854",
              "count": 32,
              "lift": "4.217711091497499",
              "source": "肿胀",
              "support": "0.01020408163265306",
              "target": "厚朴"
            },
            {
              "coverage": "0.0589923469387755",
              "confidence": "0.3027027027027027",
              "count": 56,
              "lift": "1.3276582876582879",
              "source": "疟",
              "support": "0.017857142857142856",
              "target": "人参"
            },
            {
              "coverage": "0.07525510204081634",
              "confidence": "0.3008474576271186",
              "count": 71,
              "lift": "2.750605326876513",
              "source": "吐血",
              "support": "0.02264030612244898",
              "target": "茯神"
            },
            {
              "coverage": "0.03858418367346939",
              "confidence": "0.2892561983471074",
              "count": 35,
              "lift": "1.2686817314916488",
              "source": "产后",
              "support": "0.011160714285714286",
              "target": "人参"
            },
            {
              "coverage": "0.039540816326530615",
              "confidence": "0.27419354838709675",
              "count": 34,
              "lift": "1.9410179858734433",
              "source": "虚劳",
              "support": "0.010841836734693877",
              "target": "炙甘草"
            },
            {
              "coverage": "0.039540816326530615",
              "confidence": "0.2661290322580645",
              "count": 33,
              "lift": "2.433179723502304",
              "source": "虚劳",
              "support": "0.010522959183673469",
              "target": "茯神"
            },
            {
              "coverage": "0.039540816326530615",
              "confidence": "0.2661290322580645",
              "count": 33,
              "lift": "3.9741935483870963",
              "source": "虚劳",
              "support": "0.010522959183673469",
              "target": "熟地黄"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.2542372881355932",
              "count": 60,
              "lift": "0.8135593220338982",
              "source": "吐血",
              "support": "0.01913265306122449",
              "target": "茯苓"
            },
            {
              "coverage": "0.050063775510204085",
              "confidence": "0.22929936305732485",
              "count": 36,
              "lift": "3.9510044096031356",
              "source": "咳嗽",
              "support": "0.011479591836734694",
              "target": "甘草"
            },
            {
              "coverage": "0.050063775510204085",
              "confidence": "0.22929936305732485",
              "count": 36,
              "lift": "5.063963398223738",
              "source": "咳嗽",
              "support": "0.011479591836734694",
              "target": "桑叶"
            },
            {
              "coverage": "0.05899234693877551",
              "confidence": "0.22162162162162163",
              "count": 41,
              "lift": "0.7091891891891893",
              "source": "疟",
              "support": "0.013073979591836735",
              "target": "茯苓"
            },
            {
              "coverage": "0.05899234693877551",
              "confidence": "0.21621621621621623",
              "count": 40,
              "lift": "5.46817785527463",
              "source": "疟",
              "support": "0.012755102040816327",
              "target": "知母"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.21610169491525424",
              "count": 51,
              "lift": "0.9478250562996327",
              "source": "吐血",
              "support": "0.016262755102040817",
              "target": "人参"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.211864406779661",
              "count": 50,
              "lift": "1.4997895703408959",
              "source": "吐血",
              "support": "0.01594387755102041",
              "target": "炙甘草"
            },
            {
              "coverage": "0.05899234693877551",
              "confidence": "0.21081081081081082",
              "count": 39,
              "lift": "1.9274131274131274",
              "source": "疟",
              "support": "0.012436224489795918",
              "target": "半夏"
            },
            {
              "coverage": "0.05006377551020408",
              "confidence": "0.21019108280254778",
              "count": 33,
              "lift": "1.4879440985751464",
              "source": "咳嗽",
              "support": "0.010522959183673469",
              "target": "炙甘草"
            },
            {
              "coverage": "0.0589923469387755",
              "confidence": "0.20540540540540542",
              "count": 38,
              "lift": "3.9518487812966345",
              "source": "疟",
              "support": "0.01211734693877551",
              "target": "黄芩"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.2033898305084746",
              "count": 48,
              "lift": "1.8983050847457628",
              "source": "吐血",
              "support": "0.015306122448979591",
              "target": "地黄"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.2033898305084746",
              "count": 48,
              "lift": "2.462666055886395",
              "source": "吐血",
              "support": "0.015306122448979591",
              "target": "麦冬"
            },
            {
              "coverage": "0.05899234693877551",
              "confidence": "0.1837837837837838",
              "count": 34,
              "lift": "1.6420112420112423",
              "source": "疟",
              "support": "0.010841836734693877",
              "target": "桂枝"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.15254237288135594",
              "count": 36,
              "lift": "2.765161163907123",
              "source": "吐血",
              "support": "0.011479591836734694",
              "target": "鲜石斛"
            },
            {
              "coverage": "0.07525510204081633",
              "confidence": "0.13983050847457626",
              "count": 33,
              "lift": "2.088135593220339",
              "source": "吐血",
              "support": "0.010522959183673469",
              "target": "熟地黄"
            }
          ],
          zyzh_zfst:{
            "edges": [
              {
                "weight": 1,
                "source": "木火上升肺不肃降",
                "value": 0,
                "target": "怡悦开怀"
              },
              {
                "weight": 1,
                "source": "痰火",
                "value": 0,
                "target": "清上宣通"
              },
              {
                "weight": 1,
                "source": "木火犯土",
                "value": 0,
                "target": "和脾胃以调之"
              },
              {
                "weight": 1,
                "source": "暑湿弥漫三焦",
                "value": 0,
                "target": "滋胃汁"
              },
              {
                "weight": 1,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "清热解毒"
              },
              {
                "weight": 1,
                "source": "阳脱",
                "value": 0,
                "target": "镇摄"
              },
              {
                "weight": 1,
                "source": "血络痹胸胁痛",
                "value": 0,
                "target": "降气和血"
              },
              {
                "weight": 1,
                "source": "肝胃",
                "value": 0,
                "target": "泄少阳"
              },
              {
                "weight": 1,
                "source": "寒热客邪迫肺",
                "value": 0,
                "target": "两解法"
              },
              {
                "weight": 1,
                "source": "风",
                "value": 0,
                "target": "辛凉解散"
              },
              {
                "weight": 1,
                "source": "阴虚邪伏",
                "value": 0,
                "target": "堵塞阳明"
              },
              {
                "weight": 1,
                "source": "怒劳血痹",
                "value": 0,
                "target": "降气导血"
              },
              {
                "weight": 1,
                "source": "阳虚气滞",
                "value": 0,
                "target": "温通"
              },
              {
                "weight": 1,
                "source": "暑伤营阴",
                "value": 0,
                "target": "便通再议补虚"
              },
              {
                "weight": 1,
                "source": "肝胃",
                "value": 0,
                "target": "升降疏补"
              },
              {
                "weight": 1,
                "source": "阴虚阳升",
                "value": 0,
                "target": "滋养"
              },
              {
                "weight": 1,
                "source": "胃阴虚",
                "value": 0,
                "target": "益胃阴"
              },
              {
                "weight": 1,
                "source": "郁怒木火犯土",
                "value": 0,
                "target": "和阴"
              },
              {
                "weight": 1,
                "source": "肝胃",
                "value": 0,
                "target": "开泄厥阴"
              },
              {
                "weight": 1,
                "source": "阳虚肿胀",
                "value": 0,
                "target": "温养"
              },
              {
                "weight": 1,
                "source": "肾阳虚饮逆喘咳呕",
                "value": 0,
                "target": "通阳逐饮"
              },
              {
                "weight": 1,
                "source": "牙痈后络痹",
                "value": 0,
                "target": "宣通络痹"
              },
              {
                "weight": 1,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "搜逐肝肾至阴"
              },
              {
                "weight": 1,
                "source": "郁伤肝脾",
                "value": 0,
                "target": "佐益气"
              },
              {
                "weight": 1,
                "source": "营络气聚结瘕",
                "value": 0,
                "target": "柔温辛补"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "培土制木"
              },
              {
                "weight": 2,
                "source": "气血凝络",
                "value": 0,
                "target": "通络"
              },
              {
                "weight": 1,
                "source": "中虚痰热",
                "value": 0,
                "target": "清中焦热痰"
              },
              {
                "weight": 1,
                "source": "阴虚热伏血分",
                "value": 0,
                "target": "养阴"
              },
              {
                "weight": 1,
                "source": "胆脾",
                "value": 0,
                "target": "养脾泄胆"
              },
              {
                "weight": 2,
                "source": "溃疡",
                "value": 0,
                "target": "补托"
              },
              {
                "weight": 1,
                "source": "脾阳虚",
                "value": 0,
                "target": "温药和之"
              },
              {
                "weight": 1,
                "source": "郁冒",
                "value": 0,
                "target": "甘寒"
              },
              {
                "weight": 1,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "凉血透毒"
              },
              {
                "weight": 1,
                "source": "阳虚单胀浊阴凝滞",
                "value": 0,
                "target": "缓攻"
              },
              {
                "weight": 1,
                "source": "怒劳血痹",
                "value": 0,
                "target": "两和厥阴阳明之阳"
              },
              {
                "weight": 1,
                "source": "忧郁痰阻",
                "value": 0,
                "target": "辛以通之"
              },
              {
                "weight": 2,
                "source": "肺疟",
                "value": 0,
                "target": "治手太阴"
              },
              {
                "weight": 1,
                "source": "肾气不纳",
                "value": 0,
                "target": "镇摄固纳"
              },
              {
                "weight": 1,
                "source": "暑",
                "value": 0,
                "target": "佐以宣通营卫"
              },
              {
                "weight": 1,
                "source": "阴虚风阳动",
                "value": 0,
                "target": "填隙固髓"
              },
              {
                "weight": 1,
                "source": "痞",
                "value": 0,
                "target": "清肃上中二焦"
              },
              {
                "weight": 1,
                "source": "郁怒木火犯土",
                "value": 0,
                "target": "补土泄木"
              },
              {
                "weight": 1,
                "source": "痞",
                "value": 0,
                "target": "酸苦泄其在里热邪"
              },
              {
                "weight": 1,
                "source": "湿浊凝滞小溲不行当开太阳",
                "value": 0,
                "target": "当开太阳"
              },
              {
                "weight": 1,
                "source": "劳伤中气虚",
                "value": 0,
                "target": "敛摄神气"
              },
              {
                "weight": 1,
                "source": "胃虚风阳上逆",
                "value": 0,
                "target": "柔缓之法"
              },
              {
                "weight": 1,
                "source": "血络痹胸胁痛",
                "value": 0,
                "target": "清养胃阴"
              },
              {
                "weight": 1,
                "source": "阴虚阳升",
                "value": 0,
                "target": "镇补"
              },
              {
                "weight": 1,
                "source": "湿壅三焦",
                "value": 0,
                "target": "宜通六腑"
              },
              {
                "weight": 1,
                "source": "寒湿",
                "value": 0,
                "target": "迅疾飞走"
              },
              {
                "weight": 1,
                "source": "胸次清阳少旋支脉结饮",
                "value": 0,
                "target": "通上焦之阳"
              },
              {
                "weight": 1,
                "source": "肝胃",
                "value": 0,
                "target": "理胃阳"
              },
              {
                "weight": 1,
                "source": "酒湿伤阳郁生胃痈",
                "value": 0,
                "target": "治湿"
              },
              {
                "weight": 2,
                "source": "湿热",
                "value": 0,
                "target": "苦味坚阴"
              },
              {
                "weight": 1,
                "source": "肝脾气血郁",
                "value": 0,
                "target": "辛润少佐和阳"
              },
              {
                "weight": 1,
                "source": "胆脾气血郁",
                "value": 0,
                "target": "泄少阳补太阴"
              },
              {
                "weight": 1,
                "source": "脾阳虚",
                "value": 0,
                "target": "温通中阳"
              },
              {
                "weight": 1,
                "source": "肝犯胃",
                "value": 0,
                "target": "扶土泄木"
              },
              {
                "weight": 1,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "清解活血提顶"
              },
              {
                "weight": 1,
                "source": "阴虚火炎",
                "value": 0,
                "target": "补三阴脏阴"
              },
              {
                "weight": 2,
                "source": "胸脘清阳不运",
                "value": 0,
                "target": "温通阳气"
              },
              {
                "weight": 1,
                "source": "肝胆胃",
                "value": 0,
                "target": "佐泄少阳"
              },
              {
                "weight": 1,
                "source": "阳虚浊阴上逆",
                "value": 0,
                "target": "镇肝安胃理阳"
              },
              {
                "weight": 1,
                "source": "疟母",
                "value": 0,
                "target": "通络"
              },
              {
                "weight": 1,
                "source": "阴分伏热",
                "value": 0,
                "target": "泻阴中伏热"
              },
              {
                "weight": 1,
                "source": "暑伤营阴",
                "value": 0,
                "target": "亟清营热"
              },
              {
                "weight": 1,
                "source": "湿热",
                "value": 0,
                "target": "开内闭"
              },
              {
                "weight": 1,
                "source": "暑伤气分上焦闭郁",
                "value": 0,
                "target": "治肺经"
              },
              {
                "weight": 1,
                "source": "肝犯胃",
                "value": 0,
                "target": "辛酸两和厥阴体用"
              },
              {
                "weight": 1,
                "source": "脾液外越",
                "value": 0,
                "target": "顺天之气"
              },
              {
                "weight": 1,
                "source": "阴虚阳浮",
                "value": 0,
                "target": "介类潜阳"
              },
              {
                "weight": 1,
                "source": "肺气不降胸脘痹阻",
                "value": 0,
                "target": "清理上焦"
              },
              {
                "weight": 1,
                "source": "久痢伤阴积滞未清",
                "value": 0,
                "target": "先与理阴"
              },
              {
                "weight": 1,
                "source": "风温上郁",
                "value": 0,
                "target": "再议育阴"
              },
              {
                "weight": 1,
                "source": "阴虚风阳动",
                "value": 0,
                "target": "扶阳益阴"
              },
              {
                "weight": 1,
                "source": "暑伤营阴",
                "value": 0,
                "target": "和解"
              },
              {
                "weight": 1,
                "source": "血络瘀痹",
                "value": 0,
                "target": "甘缓理虚"
              },
              {
                "weight": 1,
                "source": "热邪痞结肺痹",
                "value": 0,
                "target": "软坚开痞"
              },
              {
                "weight": 1,
                "source": "肝风",
                "value": 0,
                "target": "当镇肝阳"
              },
              {
                "weight": 1,
                "source": "痛经郁伤气血滞",
                "value": 0,
                "target": "通阳摄阴法"
              },
              {
                "weight": 1,
                "source": "阴虚血涩",
                "value": 0,
                "target": "润剂通腑"
              },
              {
                "weight": 1,
                "source": "劳伤中气虚",
                "value": 0,
                "target": "下焦宜封宜固"
              },
              {
                "weight": 1,
                "source": "木火犯中胃虚生痰",
                "value": 0,
                "target": "少阳阳明同治"
              },
              {
                "weight": 1,
                "source": "湿火",
                "value": 0,
                "target": "苦辛寒燥"
              },
              {
                "weight": 1,
                "source": "湿热",
                "value": 0,
                "target": "导水利湿"
              },
              {
                "weight": 3,
                "source": "暑热阻气中痞不运",
                "value": 0,
                "target": "清暑益气"
              },
              {
                "weight": 2,
                "source": "胃阴虚",
                "value": 0,
                "target": "养胃阴"
              },
              {
                "weight": 2,
                "source": "脾胃阳虚",
                "value": 0,
                "target": "治中法"
              },
              {
                "weight": 2,
                "source": "肾阳虚饮逆喘咳呕",
                "value": 0,
                "target": "通阳"
              },
              {
                "weight": 2,
                "source": "胃阴虚",
                "value": 0,
                "target": "甘缓"
              },
              {
                "weight": 2,
                "source": "气虚",
                "value": 0,
                "target": "益气"
              },
              {
                "weight": 2,
                "source": "肝胃",
                "value": 0,
                "target": "苦辛泄降"
              },
              {
                "weight": 2,
                "source": "脾阳不运",
                "value": 0,
                "target": "温药和之"
              },
              {
                "weight": 2,
                "source": "湿浊凝滞小溲不行当开太阳",
                "value": 0,
                "target": "开太阳"
              },
              {
                "weight": 2,
                "source": "暑",
                "value": 0,
                "target": "清气热"
              },
              {
                "weight": 2,
                "source": "肝肾虚",
                "value": 0,
                "target": "治肝肾"
              },
              {
                "weight": 2,
                "source": "热毒壅结上焦",
                "value": 0,
                "target": "辛凉轻剂以宣通"
              },
              {
                "weight": 2,
                "source": "阳虚",
                "value": 0,
                "target": "通补"
              },
              {
                "weight": 2,
                "source": "胆脾",
                "value": 0,
                "target": "补土泄木"
              }
            ],
            "nodes": [
              {
                "degree": 0,
                "name": "木火上升肺不肃降",
                "id": "木火上升肺不肃降",
                "distance": 0,
                "group": "60"
              },
              {
                "degree": 0,
                "name": "怡悦开怀",
                "id": "怡悦开怀",
                "distance": 0,
                "group": "60"
              },
              {
                "degree": 0,
                "name": "痰火",
                "id": "痰火",
                "distance": 0,
                "group": "40"
              },
              {
                "degree": 0,
                "name": "清上宣通",
                "id": "清上宣通",
                "distance": 0,
                "group": "40"
              },
              {
                "degree": 0,
                "name": "木火犯土",
                "id": "木火犯土",
                "distance": 0,
                "group": "34"
              },
              {
                "degree": 0,
                "name": "和脾胃以调之",
                "id": "和脾胃以调之",
                "distance": 0,
                "group": "34"
              },
              {
                "degree": 0,
                "name": "暑湿弥漫三焦",
                "id": "暑湿弥漫三焦",
                "distance": 0,
                "group": "54"
              },
              {
                "degree": 0,
                "name": "滋胃汁",
                "id": "滋胃汁",
                "distance": 0,
                "group": "54"
              },
              {
                "degree": 0,
                "name": "肝肾蕴毒闷症",
                "id": "肝肾蕴毒闷症",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "清热解毒",
                "id": "清热解毒",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "阳脱",
                "id": "阳脱",
                "distance": 0,
                "group": "50"
              },
              {
                "degree": 0,
                "name": "镇摄",
                "id": "镇摄",
                "distance": 0,
                "group": "50"
              },
              {
                "degree": 0,
                "name": "血络痹胸胁痛",
                "id": "血络痹胸胁痛",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "降气和血",
                "id": "降气和血",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "肝胃",
                "id": "肝胃",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "泄少阳",
                "id": "泄少阳",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "寒热客邪迫肺",
                "id": "寒热客邪迫肺",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "两解法",
                "id": "两解法",
                "distance": 0,
                "group": "30"
              },
              {
                "degree": 0,
                "name": "风",
                "id": "风",
                "distance": 0,
                "group": "49"
              },
              {
                "degree": 0,
                "name": "辛凉解散",
                "id": "辛凉解散",
                "distance": 0,
                "group": "49"
              },
              {
                "degree": 0,
                "name": "阴虚邪伏",
                "id": "阴虚邪伏",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "堵塞阳明",
                "id": "堵塞阳明",
                "distance": 0,
                "group": "24"
              },
              {
                "degree": 0,
                "name": "怒劳血痹",
                "id": "怒劳血痹",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "降气导血",
                "id": "降气导血",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "阳虚气滞",
                "id": "阳虚气滞",
                "distance": 0,
                "group": "33"
              },
              {
                "degree": 0,
                "name": "温通",
                "id": "温通",
                "distance": 0,
                "group": "33"
              },
              {
                "degree": 0,
                "name": "暑伤营阴",
                "id": "暑伤营阴",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "便通再议补虚",
                "id": "便通再议补虚",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "升降疏补",
                "id": "升降疏补",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "阴虚阳升",
                "id": "阴虚阳升",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "滋养",
                "id": "滋养",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "胃阴虚",
                "id": "胃阴虚",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "益胃阴",
                "id": "益胃阴",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "郁怒木火犯土",
                "id": "郁怒木火犯土",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "和阴",
                "id": "和阴",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "开泄厥阴",
                "id": "开泄厥阴",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "阳虚肿胀",
                "id": "阳虚肿胀",
                "distance": 0,
                "group": "37"
              },
              {
                "degree": 0,
                "name": "温养",
                "id": "温养",
                "distance": 0,
                "group": "37"
              },
              {
                "degree": 0,
                "name": "肾阳虚饮逆喘咳呕",
                "id": "肾阳虚饮逆喘咳呕",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "通阳逐饮",
                "id": "通阳逐饮",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "牙痈后络痹",
                "id": "牙痈后络痹",
                "distance": 0,
                "group": "36"
              },
              {
                "degree": 0,
                "name": "宣通络痹",
                "id": "宣通络痹",
                "distance": 0,
                "group": "36"
              },
              {
                "degree": 0,
                "name": "搜逐肝肾至阴",
                "id": "搜逐肝肾至阴",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "郁伤肝脾",
                "id": "郁伤肝脾",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "佐益气",
                "id": "佐益气",
                "distance": 0,
                "group": "27"
              },
              {
                "degree": 0,
                "name": "营络气聚结瘕",
                "id": "营络气聚结瘕",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "柔温辛补",
                "id": "柔温辛补",
                "distance": 0,
                "group": "25"
              },
              {
                "degree": 0,
                "name": "培土制木",
                "id": "培土制木",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "气血凝络",
                "id": "气血凝络",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "通络",
                "id": "通络",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "中虚痰热",
                "id": "中虚痰热",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "清中焦热痰",
                "id": "清中焦热痰",
                "distance": 0,
                "group": "23"
              },
              {
                "degree": 0,
                "name": "阴虚热伏血分",
                "id": "阴虚热伏血分",
                "distance": 0,
                "group": "41"
              },
              {
                "degree": 0,
                "name": "养阴",
                "id": "养阴",
                "distance": 0,
                "group": "41"
              },
              {
                "degree": 0,
                "name": "胆脾",
                "id": "胆脾",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "养脾泄胆",
                "id": "养脾泄胆",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "溃疡",
                "id": "溃疡",
                "distance": 0,
                "group": "62"
              },
              {
                "degree": 0,
                "name": "补托",
                "id": "补托",
                "distance": 0,
                "group": "62"
              },
              {
                "degree": 0,
                "name": "脾阳虚",
                "id": "脾阳虚",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "温药和之",
                "id": "温药和之",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "郁冒",
                "id": "郁冒",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "甘寒",
                "id": "甘寒",
                "distance": 0,
                "group": "21"
              },
              {
                "degree": 0,
                "name": "凉血透毒",
                "id": "凉血透毒",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "阳虚单胀浊阴凝滞",
                "id": "阳虚单胀浊阴凝滞",
                "distance": 0,
                "group": "44"
              },
              {
                "degree": 0,
                "name": "缓攻",
                "id": "缓攻",
                "distance": 0,
                "group": "44"
              },
              {
                "degree": 0,
                "name": "两和厥阴阳明之阳",
                "id": "两和厥阴阳明之阳",
                "distance": 0,
                "group": "14"
              },
              {
                "degree": 0,
                "name": "忧郁痰阻",
                "id": "忧郁痰阻",
                "distance": 0,
                "group": "45"
              },
              {
                "degree": 0,
                "name": "辛以通之",
                "id": "辛以通之",
                "distance": 0,
                "group": "45"
              },
              {
                "degree": 0,
                "name": "肺疟",
                "id": "肺疟",
                "distance": 0,
                "group": "69"
              },
              {
                "degree": 0,
                "name": "治手太阴",
                "id": "治手太阴",
                "distance": 0,
                "group": "69"
              },
              {
                "degree": 0,
                "name": "肾气不纳",
                "id": "肾气不纳",
                "distance": 0,
                "group": "51"
              },
              {
                "degree": 0,
                "name": "镇摄固纳",
                "id": "镇摄固纳",
                "distance": 0,
                "group": "51"
              },
              {
                "degree": 0,
                "name": "暑",
                "id": "暑",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "佐以宣通营卫",
                "id": "佐以宣通营卫",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "阴虚风阳动",
                "id": "阴虚风阳动",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "填隙固髓",
                "id": "填隙固髓",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "痞",
                "id": "痞",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "清肃上中二焦",
                "id": "清肃上中二焦",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "补土泄木",
                "id": "补土泄木",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "酸苦泄其在里热邪",
                "id": "酸苦泄其在里热邪",
                "distance": 0,
                "group": "13"
              },
              {
                "degree": 0,
                "name": "湿浊凝滞小溲不行当开太阳",
                "id": "湿浊凝滞小溲不行当开太阳",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "当开太阳",
                "id": "当开太阳",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "劳伤中气虚",
                "id": "劳伤中气虚",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "敛摄神气",
                "id": "敛摄神气",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "胃虚风阳上逆",
                "id": "胃虚风阳上逆",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "柔缓之法",
                "id": "柔缓之法",
                "distance": 0,
                "group": "29"
              },
              {
                "degree": 0,
                "name": "清养胃阴",
                "id": "清养胃阴",
                "distance": 0,
                "group": "12"
              },
              {
                "degree": 0,
                "name": "镇补",
                "id": "镇补",
                "distance": 0,
                "group": "16"
              },
              {
                "degree": 0,
                "name": "湿壅三焦",
                "id": "湿壅三焦",
                "distance": 0,
                "group": "46"
              },
              {
                "degree": 0,
                "name": "宜通六腑",
                "id": "宜通六腑",
                "distance": 0,
                "group": "46"
              },
              {
                "degree": 0,
                "name": "寒湿",
                "id": "寒湿",
                "distance": 0,
                "group": "52"
              },
              {
                "degree": 0,
                "name": "迅疾飞走",
                "id": "迅疾飞走",
                "distance": 0,
                "group": "52"
              },
              {
                "degree": 0,
                "name": "胸次清阳少旋支脉结饮",
                "id": "胸次清阳少旋支脉结饮",
                "distance": 0,
                "group": "43"
              },
              {
                "degree": 0,
                "name": "通上焦之阳",
                "id": "通上焦之阳",
                "distance": 0,
                "group": "43"
              },
              {
                "degree": 0,
                "name": "理胃阳",
                "id": "理胃阳",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "酒湿伤阳郁生胃痈",
                "id": "酒湿伤阳郁生胃痈",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "治湿",
                "id": "治湿",
                "distance": 0,
                "group": "31"
              },
              {
                "degree": 0,
                "name": "湿热",
                "id": "湿热",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "苦味坚阴",
                "id": "苦味坚阴",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "肝脾气血郁",
                "id": "肝脾气血郁",
                "distance": 0,
                "group": "58"
              },
              {
                "degree": 0,
                "name": "辛润少佐和阳",
                "id": "辛润少佐和阳",
                "distance": 0,
                "group": "58"
              },
              {
                "degree": 0,
                "name": "胆脾气血郁",
                "id": "胆脾气血郁",
                "distance": 0,
                "group": "56"
              },
              {
                "degree": 0,
                "name": "泄少阳补太阴",
                "id": "泄少阳补太阴",
                "distance": 0,
                "group": "56"
              },
              {
                "degree": 0,
                "name": "温通中阳",
                "id": "温通中阳",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "肝犯胃",
                "id": "肝犯胃",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "扶土泄木",
                "id": "扶土泄木",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "清解活血提顶",
                "id": "清解活血提顶",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "阴虚火炎",
                "id": "阴虚火炎",
                "distance": 0,
                "group": "53"
              },
              {
                "degree": 0,
                "name": "补三阴脏阴",
                "id": "补三阴脏阴",
                "distance": 0,
                "group": "53"
              },
              {
                "degree": 0,
                "name": "胸脘清阳不运",
                "id": "胸脘清阳不运",
                "distance": 0,
                "group": "68"
              },
              {
                "degree": 0,
                "name": "温通阳气",
                "id": "温通阳气",
                "distance": 0,
                "group": "68"
              },
              {
                "degree": 0,
                "name": "肝胆胃",
                "id": "肝胆胃",
                "distance": 0,
                "group": "48"
              },
              {
                "degree": 0,
                "name": "佐泄少阳",
                "id": "佐泄少阳",
                "distance": 0,
                "group": "48"
              },
              {
                "degree": 0,
                "name": "阳虚浊阴上逆",
                "id": "阳虚浊阴上逆",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "镇肝安胃理阳",
                "id": "镇肝安胃理阳",
                "distance": 0,
                "group": "22"
              },
              {
                "degree": 0,
                "name": "疟母",
                "id": "疟母",
                "distance": 0,
                "group": "9"
              },
              {
                "degree": 0,
                "name": "阴分伏热",
                "id": "阴分伏热",
                "distance": 0,
                "group": "47"
              },
              {
                "degree": 0,
                "name": "泻阴中伏热",
                "id": "泻阴中伏热",
                "distance": 0,
                "group": "47"
              },
              {
                "degree": 0,
                "name": "亟清营热",
                "id": "亟清营热",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "开内闭",
                "id": "开内闭",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "暑伤气分上焦闭郁",
                "id": "暑伤气分上焦闭郁",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "治肺经",
                "id": "治肺经",
                "distance": 0,
                "group": "20"
              },
              {
                "degree": 0,
                "name": "辛酸两和厥阴体用",
                "id": "辛酸两和厥阴体用",
                "distance": 0,
                "group": "17"
              },
              {
                "degree": 0,
                "name": "脾液外越",
                "id": "脾液外越",
                "distance": 0,
                "group": "42"
              },
              {
                "degree": 0,
                "name": "顺天之气",
                "id": "顺天之气",
                "distance": 0,
                "group": "42"
              },
              {
                "degree": 0,
                "name": "阴虚阳浮",
                "id": "阴虚阳浮",
                "distance": 0,
                "group": "39"
              },
              {
                "degree": 0,
                "name": "介类潜阳",
                "id": "介类潜阳",
                "distance": 0,
                "group": "39"
              },
              {
                "degree": 0,
                "name": "肺气不降胸脘痹阻",
                "id": "肺气不降胸脘痹阻",
                "distance": 0,
                "group": "38"
              },
              {
                "degree": 0,
                "name": "清理上焦",
                "id": "清理上焦",
                "distance": 0,
                "group": "38"
              },
              {
                "degree": 0,
                "name": "久痢伤阴积滞未清",
                "id": "久痢伤阴积滞未清",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "先与理阴",
                "id": "先与理阴",
                "distance": 0,
                "group": "28"
              },
              {
                "degree": 0,
                "name": "风温上郁",
                "id": "风温上郁",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "再议育阴",
                "id": "再议育阴",
                "distance": 0,
                "group": "19"
              },
              {
                "degree": 0,
                "name": "扶阳益阴",
                "id": "扶阳益阴",
                "distance": 0,
                "group": "18"
              },
              {
                "degree": 0,
                "name": "和解",
                "id": "和解",
                "distance": 0,
                "group": "11"
              },
              {
                "degree": 0,
                "name": "血络瘀痹",
                "id": "血络瘀痹",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "甘缓理虚",
                "id": "甘缓理虚",
                "distance": 0,
                "group": "26"
              },
              {
                "degree": 0,
                "name": "热邪痞结肺痹",
                "id": "热邪痞结肺痹",
                "distance": 0,
                "group": "61"
              },
              {
                "degree": 0,
                "name": "软坚开痞",
                "id": "软坚开痞",
                "distance": 0,
                "group": "61"
              },
              {
                "degree": 0,
                "name": "肝风",
                "id": "肝风",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "当镇肝阳",
                "id": "当镇肝阳",
                "distance": 0,
                "group": "32"
              },
              {
                "degree": 0,
                "name": "痛经郁伤气血滞",
                "id": "痛经郁伤气血滞",
                "distance": 0,
                "group": "35"
              },
              {
                "degree": 0,
                "name": "通阳摄阴法",
                "id": "通阳摄阴法",
                "distance": 0,
                "group": "35"
              },
              {
                "degree": 0,
                "name": "阴虚血涩",
                "id": "阴虚血涩",
                "distance": 0,
                "group": "59"
              },
              {
                "degree": 0,
                "name": "润剂通腑",
                "id": "润剂通腑",
                "distance": 0,
                "group": "59"
              },
              {
                "degree": 0,
                "name": "下焦宜封宜固",
                "id": "下焦宜封宜固",
                "distance": 0,
                "group": "15"
              },
              {
                "degree": 0,
                "name": "木火犯中胃虚生痰",
                "id": "木火犯中胃虚生痰",
                "distance": 0,
                "group": "57"
              },
              {
                "degree": 0,
                "name": "少阳阳明同治",
                "id": "少阳阳明同治",
                "distance": 0,
                "group": "57"
              },
              {
                "degree": 0,
                "name": "湿火",
                "id": "湿火",
                "distance": 0,
                "group": "55"
              },
              {
                "degree": 0,
                "name": "苦辛寒燥",
                "id": "苦辛寒燥",
                "distance": 0,
                "group": "55"
              },
              {
                "degree": 0,
                "name": "导水利湿",
                "id": "导水利湿",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "暑热阻气中痞不运",
                "id": "暑热阻气中痞不运",
                "distance": 0,
                "group": "70"
              },
              {
                "degree": 0,
                "name": "清暑益气",
                "id": "清暑益气",
                "distance": 0,
                "group": "70"
              },
              {
                "degree": 0,
                "name": "养胃阴",
                "id": "养胃阴",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "脾胃阳虚",
                "id": "脾胃阳虚",
                "distance": 0,
                "group": "67"
              },
              {
                "degree": 0,
                "name": "治中法",
                "id": "治中法",
                "distance": 0,
                "group": "67"
              },
              {
                "degree": 0,
                "name": "通阳",
                "id": "通阳",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "甘缓",
                "id": "甘缓",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "气虚",
                "id": "气虚",
                "distance": 0,
                "group": "66"
              },
              {
                "degree": 0,
                "name": "益气",
                "id": "益气",
                "distance": 0,
                "group": "66"
              },
              {
                "degree": 0,
                "name": "苦辛泄降",
                "id": "苦辛泄降",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "脾阳不运",
                "id": "脾阳不运",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "开太阳",
                "id": "开太阳",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "清气热",
                "id": "清气热",
                "distance": 0,
                "group": "10"
              },
              {
                "degree": 0,
                "name": "肝肾虚",
                "id": "肝肾虚",
                "distance": 0,
                "group": "65"
              },
              {
                "degree": 0,
                "name": "治肝肾",
                "id": "治肝肾",
                "distance": 0,
                "group": "65"
              },
              {
                "degree": 0,
                "name": "热毒壅结上焦",
                "id": "热毒壅结上焦",
                "distance": 0,
                "group": "64"
              },
              {
                "degree": 0,
                "name": "辛凉轻剂以宣通",
                "id": "辛凉轻剂以宣通",
                "distance": 0,
                "group": "64"
              },
              {
                "degree": 0,
                "name": "阳虚",
                "id": "阳虚",
                "distance": 0,
                "group": "63"
              },
              {
                "degree": 0,
                "name": "通补",
                "id": "通补",
                "distance": 0,
                "group": "63"
              }
            ]
        },
        zyzh_zygl:[
            {
              "coverage": "0.028380102040816327",
              "confidence": "0.47191011235955055",
              "count": 42,
              "lift": "2.0698043529504204",
              "source": "肝胃",
              "support": "0.013392857142857142",
              "target": "人参"
            },
            {
              "coverage": "0.028380102040816327",
              "confidence": "0.43820224719101125",
              "count": 39,
              "lift": "1.402247191011236",
              "source": "肝胃",
              "support": "0.012436224489795918",
              "target": "茯苓"
            },
            {
              "coverage": "0.028380102040816327",
              "confidence": "0.38202247191011235",
              "count": 34,
              "lift": "3.4927768860353128",
              "source": "肝胃",
              "support": "0.010841836734693877",
              "target": "半夏"
            }
        ],
        zyzh_zyst:{
            "edges": [
              {
                "weight": 13,
                "source": "湿热",
                "value": 0,
                "target": "厚朴"
              },
              {
                "weight": 12,
                "source": "阴虚阳升",
                "value": 0,
                "target": "山药"
              },
              {
                "weight": 21,
                "source": "阴阳并虚",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 13,
                "source": "脾阳虚",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 13,
                "source": "中气虚",
                "value": 0,
                "target": "饴糖"
              },
              {
                "weight": 17,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "炒楂"
              },
              {
                "weight": 15,
                "source": "阴虚",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 11,
                "source": "阴虚",
                "value": 0,
                "target": "阿胶"
              },
              {
                "weight": 19,
                "source": "寒湿",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 14,
                "source": "劳伤中气虚",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 15,
                "source": "阴虚",
                "value": 0,
                "target": "地黄"
              },
              {
                "weight": 13,
                "source": "阴虚阳浮",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 16,
                "source": "阴虚",
                "value": 0,
                "target": "熟地黄"
              },
              {
                "weight": 15,
                "source": "胃阴虚",
                "value": 0,
                "target": "北沙参"
              },
              {
                "weight": 11,
                "source": "脾肾阳虚",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 12,
                "source": "胃阳虚",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 20,
                "source": "肝胃",
                "value": 0,
                "target": "白芍"
              },
              {
                "weight": 16,
                "source": "肝胃",
                "value": 0,
                "target": "乌梅"
              },
              {
                "weight": 13,
                "source": "肝胃",
                "value": 0,
                "target": "生姜汁"
              },
              {
                "weight": 16,
                "source": "阴虚阳升",
                "value": 0,
                "target": "茯神"
              },
              {
                "weight": 13,
                "source": "心肾兼治",
                "value": 0,
                "target": "远志"
              },
              {
                "weight": 12,
                "source": "暑湿热",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 15,
                "source": "中气虚",
                "value": 0,
                "target": "白芍"
              },
              {
                "weight": 14,
                "source": "肝胃",
                "value": 0,
                "target": "干姜"
              },
              {
                "weight": 14,
                "source": "胃阴虚",
                "value": 0,
                "target": "鲜石斛"
              },
              {
                "weight": 12,
                "source": "脾阳虚",
                "value": 0,
                "target": "白术"
              },
              {
                "weight": 12,
                "source": "湿热",
                "value": 0,
                "target": "泽泻"
              },
              {
                "weight": 24,
                "source": "脾胃阳虚",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 14,
                "source": "阴虚阳升",
                "value": 0,
                "target": "山萸肉"
              },
              {
                "weight": 13,
                "source": "肝胃",
                "value": 0,
                "target": "桂枝"
              },
              {
                "weight": 17,
                "source": "血络瘀痹",
                "value": 0,
                "target": "桃仁"
              },
              {
                "weight": 17,
                "source": "胃阴虚",
                "value": 0,
                "target": "甘草"
              },
              {
                "weight": 24,
                "source": "中气虚",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 13,
                "source": "肝胃",
                "value": 0,
                "target": "牡蛎"
              },
              {
                "weight": 39,
                "source": "肝胃",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 18,
                "source": "肝犯胃",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 15,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "桔梗"
              },
              {
                "weight": 15,
                "source": "中气虚",
                "value": 0,
                "target": "桂枝"
              },
              {
                "weight": 14,
                "source": "湿热",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 23,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "连翘"
              },
              {
                "weight": 12,
                "source": "阴阳并虚",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 17,
                "source": "脾阳虚",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 12,
                "source": "脾胃阳虚",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 14,
                "source": "湿热",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 13,
                "source": "肝犯胃",
                "value": 0,
                "target": "白芍"
              },
              {
                "weight": 12,
                "source": "湿阻中焦阳气",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 17,
                "source": "湿热",
                "value": 0,
                "target": "黄芩"
              },
              {
                "weight": 14,
                "source": "阴虚阳浮",
                "value": 0,
                "target": "熟地黄"
              },
              {
                "weight": 12,
                "source": "中气虚",
                "value": 0,
                "target": "黄芪"
              },
              {
                "weight": 20,
                "source": "肝胃",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 15,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 12,
                "source": "胃阳虚",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 12,
                "source": "营虚",
                "value": 0,
                "target": "茯神"
              },
              {
                "weight": 13,
                "source": "阳虚",
                "value": 0,
                "target": "当归"
              },
              {
                "weight": 13,
                "source": "阳虚",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 14,
                "source": "脾胃阳虚",
                "value": 0,
                "target": "白术"
              },
              {
                "weight": 18,
                "source": "阴虚",
                "value": 0,
                "target": "茯神"
              },
              {
                "weight": 12,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 43,
                "source": "肝胃",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 21,
                "source": "劳伤中气虚",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 15,
                "source": "血络瘀痹",
                "value": 0,
                "target": "当归尾"
              },
              {
                "weight": 16,
                "source": "中气虚",
                "value": 0,
                "target": "大枣"
              },
              {
                "weight": 13,
                "source": "湿阻中焦阳气",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 16,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 11,
                "source": "肝胃",
                "value": 0,
                "target": "吴茱萸"
              },
              {
                "weight": 15,
                "source": "胃阴虚",
                "value": 0,
                "target": "茯神"
              },
              {
                "weight": 13,
                "source": "阴虚阳升",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 18,
                "source": "营虚",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 18,
                "source": "胃阳虚",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 12,
                "source": "暑湿热",
                "value": 0,
                "target": "厚朴"
              },
              {
                "weight": 20,
                "source": "湿热",
                "value": 0,
                "target": "黄连"
              },
              {
                "weight": 14,
                "source": "阴虚",
                "value": 0,
                "target": "鲜石斛"
              },
              {
                "weight": 12,
                "source": "营虚",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 17,
                "source": "脾阳虚",
                "value": 0,
                "target": "厚朴"
              },
              {
                "weight": 17,
                "source": "脾胃阳虚",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 15,
                "source": "肝胃",
                "value": 0,
                "target": "川楝子"
              },
              {
                "weight": 14,
                "source": "燥",
                "value": 0,
                "target": "桑叶"
              },
              {
                "weight": 11,
                "source": "中虚",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 25,
                "source": "阳虚",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 14,
                "source": "心肾兼治",
                "value": 0,
                "target": "茯神"
              },
              {
                "weight": 14,
                "source": "阴虚阳升",
                "value": 0,
                "target": "五味子"
              },
              {
                "weight": 21,
                "source": "肝胃",
                "value": 0,
                "target": "黄连"
              },
              {
                "weight": 12,
                "source": "心肾兼治",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 13,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "甘草"
              },
              {
                "weight": 34,
                "source": "肝胃",
                "value": 0,
                "target": "半夏"
              },
              {
                "weight": 25,
                "source": "肝犯胃",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 22,
                "source": "阳虚",
                "value": 0,
                "target": "炙甘草"
              },
              {
                "weight": 20,
                "source": "脾肾阳虚",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 20,
                "source": "阴虚阳升",
                "value": 0,
                "target": "熟地黄"
              },
              {
                "weight": 11,
                "source": "湿热",
                "value": 0,
                "target": "防己"
              },
              {
                "weight": 21,
                "source": "肝犯胃",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 18,
                "source": "胃阴虚",
                "value": 0,
                "target": "白扁豆"
              },
              {
                "weight": 16,
                "source": "胃阳虚",
                "value": 0,
                "target": "人参"
              },
              {
                "weight": 12,
                "source": "劳嗽",
                "value": 0,
                "target": "熟地黄"
              },
              {
                "weight": 14,
                "source": "阳虚",
                "value": 0,
                "target": "桂枝"
              },
              {
                "weight": 12,
                "source": "阴虚阳浮",
                "value": 0,
                "target": "五味子"
              },
              {
                "weight": 29,
                "source": "阳虚",
                "value": 0,
                "target": "茯苓"
              },
              {
                "weight": 17,
                "source": "肝肾蕴毒闷症",
                "value": 0,
                "target": "牡丹皮"
              },
              {
                "weight": 12,
                "source": "肝犯胃",
                "value": 0,
                "target": "陈皮"
              },
              {
                "weight": 27,
                "source": "胃阴虚",
                "value": 0,
                "target": "麦冬"
              }
            ],
            "nodes": [
              {
                "degree": 0,
                "name": "湿热",
                "id": "湿热",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "厚朴",
                "id": "厚朴",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "阴虚阳升",
                "id": "阴虚阳升",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "山药",
                "id": "山药",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "阴阳并虚",
                "id": "阴阳并虚",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "人参",
                "id": "人参",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "脾阳虚",
                "id": "脾阳虚",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "陈皮",
                "id": "陈皮",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "中气虚",
                "id": "中气虚",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "饴糖",
                "id": "饴糖",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "肝肾蕴毒闷症",
                "id": "肝肾蕴毒闷症",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "炒楂",
                "id": "炒楂",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "阴虚",
                "id": "阴虚",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "茯苓",
                "id": "茯苓",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "阿胶",
                "id": "阿胶",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "寒湿",
                "id": "寒湿",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "劳伤中气虚",
                "id": "劳伤中气虚",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "地黄",
                "id": "地黄",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "阴虚阳浮",
                "id": "阴虚阳浮",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "熟地黄",
                "id": "熟地黄",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "胃阴虚",
                "id": "胃阴虚",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "北沙参",
                "id": "北沙参",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "脾肾阳虚",
                "id": "脾肾阳虚",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "胃阳虚",
                "id": "胃阳虚",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "半夏",
                "id": "半夏",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "肝胃",
                "id": "肝胃",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "白芍",
                "id": "白芍",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "乌梅",
                "id": "乌梅",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "生姜汁",
                "id": "生姜汁",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "茯神",
                "id": "茯神",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "心肾兼治",
                "id": "心肾兼治",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "远志",
                "id": "远志",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "暑湿热",
                "id": "暑湿热",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "干姜",
                "id": "干姜",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "鲜石斛",
                "id": "鲜石斛",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "白术",
                "id": "白术",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "泽泻",
                "id": "泽泻",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "脾胃阳虚",
                "id": "脾胃阳虚",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "山萸肉",
                "id": "山萸肉",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "桂枝",
                "id": "桂枝",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "血络瘀痹",
                "id": "血络瘀痹",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "桃仁",
                "id": "桃仁",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "甘草",
                "id": "甘草",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "炙甘草",
                "id": "炙甘草",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "牡蛎",
                "id": "牡蛎",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "肝犯胃",
                "id": "肝犯胃",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "桔梗",
                "id": "桔梗",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "连翘",
                "id": "连翘",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "湿阻中焦阳气",
                "id": "湿阻中焦阳气",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "黄芩",
                "id": "黄芩",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "黄芪",
                "id": "黄芪",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "营虚",
                "id": "营虚",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "阳虚",
                "id": "阳虚",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "当归",
                "id": "当归",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "当归尾",
                "id": "当归尾",
                "distance": 0,
                "group": "8"
              },
              {
                "degree": 0,
                "name": "大枣",
                "id": "大枣",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "吴茱萸",
                "id": "吴茱萸",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "黄连",
                "id": "黄连",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "川楝子",
                "id": "川楝子",
                "distance": 0,
                "group": "2"
              },
              {
                "degree": 0,
                "name": "燥",
                "id": "燥",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "桑叶",
                "id": "桑叶",
                "distance": 0,
                "group": "6"
              },
              {
                "degree": 0,
                "name": "中虚",
                "id": "中虚",
                "distance": 0,
                "group": "4"
              },
              {
                "degree": 0,
                "name": "五味子",
                "id": "五味子",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "防己",
                "id": "防己",
                "distance": 0,
                "group": "1"
              },
              {
                "degree": 0,
                "name": "白扁豆",
                "id": "白扁豆",
                "distance": 0,
                "group": "5"
              },
              {
                "degree": 0,
                "name": "劳嗽",
                "id": "劳嗽",
                "distance": 0,
                "group": "3"
              },
              {
                "degree": 0,
                "name": "牡丹皮",
                "id": "牡丹皮",
                "distance": 0,
                "group": "7"
              },
              {
                "degree": 0,
                "name": "麦冬",
                "id": "麦冬",
                "distance": 0,
                "group": "5"
              }
            ]
        },
    }
}